import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { GlobalVariable } from 'src/app/global';
import { BaseComponent } from 'src/app/models/base-component';
import { CampeonatosService } from '../../services/campeonatos/campeonatos.service';
import { EscenariosService } from '../../services/escenarios/escenarios.service';
import { RolesPartidosService } from '../../services/roles-partidos/roles-partidos.service';
import { RolPartidoPdfService } from '../../services/rol-partido-pdf/rol-partido-pdf.service';
import { Util } from 'src/app/utils/utils';
import { PdfService } from 'src/app/base/services/pdf/pdf.service';
import { PopupConfirmacionComponent } from 'src/app/base/components/popup-confirmacion/popup-confirmacion.component';
import { OrderPipe } from 'ngx-order-pipe';
import { VentaComponent } from 'src/app/base/components/venta/venta.component';
import { ProductosService } from 'src/app/snapquick/services/productos/productos.service';
import { RegistroJugadorComponent } from '../registro-jugador/registro-jugador.component';
import * as fs from 'file-saver';
import { Socket } from 'ngx-socket-io';
import { ConfiguracionAplicacionRolPartidosComponent } from 'src/app/base/components/configuracion-aplicacion-rol-partidos/configuracion-aplicacion-rol-partidos.component';
import { VentasService } from 'src/app/base/services/ventas/ventas.service';
import { CajasService } from 'src/app/snapquick/services/cajas/cajas.service';
import { ProveedoresService } from 'src/app/snapquick/services/proveedores/proveedores.service';
import { CalendarOptions, EventInput } from '@fullcalendar/core';
import resourceTimeGridPlugin  from '@fullcalendar/resource-timegrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import { FullCalendarComponent } from '@fullcalendar/angular';
import scrollGridPlugin from '@fullcalendar/scrollgrid';
import listPlugin from '@fullcalendar/list';
import {CdkDragDrop,moveItemInArray,transferArrayItem} from '@angular/cdk/drag-drop';

declare const aplicarPluginCalendario:any;
declare const resaltarPestañaMenu:any;
declare const PDFDocument:any;
declare const blobStream:any;
declare const qr:any
declare const Buffer;
declare const FullCalendar:any;
declare const $:any;

@Component({
    selector: 'app-rol-partidos',
    templateUrl: './rol-partidos.component.html',
    styleUrls: ['./rol-partidos.component.css'],
    standalone: false
})
export class RolPartidosComponent extends BaseComponent implements OnInit {

  draggedIndex: number | null = null;
  roles_partidos:any[]=[];
  partidos_arbitro:any[]=[];
  partido:any;
  cierres_mesas:any;
  //cierre que se muestra en la ventana de caja del rol (una pestaña por mesa y fecha)
  indice_cierre_seleccionado:number=0;
  equipos:any[]=[];
  lista_tarjetas:any[]=[];
  equipos_diferente:any[]=[];
  rol_partido:any;
  tipo_rol_partido:any;
  escenarios:any[]=[];
  arbitros:any[]=[];
  //horas que ofrece el desplegable de la tarjeta del calendario
  horas_disponibles:string[]=[];
  //rotacion de arbitros por disciplina y disciplinas que quedaron sin arbitro propio
  rotacion_arbitro:any={};
  disciplinas_sin_arbitro:any={};
  mesas:any[]=[];
  goleadores:any[]=[];
  tipo_categoria:any;
  tipo_fase:any={clases:[]};
  tipo_disciplina:any={clases:[]};
  marcadorEquipo1 = 0;
  marcadorEquipo2 = 0;
  tabla_posiciones:any={};
  rol_partido_arbitro:any={};
  tiposPago:any;
  cajas:any=[];
  movimientos:any=[];
  cierre_rol:any;
  gloval_variable:any=GlobalVariable;

  calendarOptions: CalendarOptions = {
    plugins: [listPlugin,scrollGridPlugin,timeGridPlugin,resourceTimeGridPlugin],
    schedulerLicenseKey:'CC-Attribution-NonCommercial-NoDerivatives',
    initialView: 'resourceTimeGridDay',
    resources: [],
    filterResourcesWithEvents:true,
    themeSystem: 'bootstrap',
    headerToolbar: {
      start: 'today,prev,next',
      center: 'title',
      end: 'resourceTimeGridWeek,resourceTimeGridDay,listWeek'
    },
    events: [],
    editable:true,
    droppable:true,
    allDaySlot:false,
    locale:'es',
    dayMinWidth: 50,
    selectable:true,
    selectLongPressDelay:200,
    contentHeight:'auto',
    slotMinTime:"08:00",
    slotDuration:"00:15",
  };
  calendarApi:any;
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;

  modal_registro_rol_partido:NgbModalRef;
  @ViewChild('modal_registro_rol_partido')
  private modal_registro_rol_partido_ref: TemplateRef<any>;

  modal_registro_rol_partido_fixture:NgbModalRef;
  @ViewChild('modal_registro_rol_partido_fixture')
  private modal_registro_rol_partido_fixture_ref: TemplateRef<any>;

  modal_tabla_posiciones:NgbModalRef;
  @ViewChild('modal_tabla_posiciones')
  private modal_tabla_posiciones_ref: TemplateRef<any>;

  modal_tabla_goleadores:NgbModalRef;
  @ViewChild('modal_tabla_goleadores')
  private modal_tabla_goleadores_ref: TemplateRef<any>;

  modal_rol_partidos_arbitros:NgbModalRef;
  @ViewChild('modal_rol_partidos_arbitros')
  private modal_rol_partidos_arbitros_ref: TemplateRef<any>;

  modal_resultado_partido:NgbModalRef;
  @ViewChild('modal_resultado_partido')
  private modal_resultado_partido_ref: TemplateRef<any>;

  modal_registro_caja_mesa:NgbModalRef;
  @ViewChild('modal_registro_caja')
  private modal_registro_caja_mesa_ref: TemplateRef<any>;

  modalVenta:NgbModalRef;
  modalJugador:NgbModalRef;
  campeonatos:any[]=[];
  aplicacion_ventas:any;
  calendar:any;
  tiposDocumentosCompra: any;
  conceptos_egreso_compra: any;
  roles_partido_seleccionados:any[]=[];
  mostrar_matriz_cruces:boolean=false;
  matriz_equipos:any[]=[];
  matriz_celdas:any[][]=[];
  matriz_partidos_campeonato:any[]=[];
  matriz_filtro:any=null;
  matriz_duracion_partido:number=50;
  /* Fondos por fecha para los partidos sin resultado. Son los unicos tres tonos que mantienen
     separacion suficiente entre si, contra el blanco de la celda libre y contra el durazno de
     "jugado"; de la cuarta fecha en adelante se usa el neutro. */
  /* Los dias son ordenados, no categorias sueltas, asi que se usa una rampa de un solo tono por
     luminosidad en vez de colores distintos: cinco rellenos categoricos no llegan a distinguirse.
     El indice va de martes a sabado; ademas la celda lleva escrita la abreviatura del dia. */
  matriz_colores_dia:any={
    2:{ fondo:"#9ec5f4", texto:"#242424", nombre:"MAR" },
    3:{ fondo:"#5598e7", texto:"#242424", nombre:"MIÉ" },
    4:{ fondo:"#256abf", texto:"#ffffff", nombre:"JUE" },
    5:{ fondo:"#184f95", texto:"#ffffff", nombre:"VIE" },
    6:{ fondo:"#0d366b", texto:"#ffffff", nombre:"SÁB" },
    0:{ fondo:"#6a3d9a", texto:"#ffffff", nombre:"DOM" },
    1:{ fondo:"#7a7a7a", texto:"#ffffff", nombre:"LUN" }
  };
  matriz_color_otras_fechas:string="#979797";
  matriz_leyenda_fechas:any[]=[];
  matriz_resumen_equipos:any[]=[];
  matriz_dias_semana:string[]=["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"];
  matriz_grupos:any[]=[];
  matriz_grupo:any=null;
  matriz_densidad:string="";
  mostrar_panel_fixture:boolean=false;
  //cambio de fase en bloque de los partidos del campeonato (ver abrirCambioFase)
  mostrar_cambio_fase:boolean=false;
  cambio_fase:any={ conflictos:[] };
  fixture:any=null;

  /* Cada campeonato se programa distinto. El algoritmo elegido define cuantos partidos tiene que
     jugar como minimo cada equipo en la semana y como se ordenan los cruces; el resto (arbitro de
     la disciplina, un solo partido por equipo y dia, tope por escenario) vale para todos.
     Las prioridades se muestran en el panel para poder confirmar que es el que corresponde. */
  algoritmos_fixture:any[]=[
    { codigo:"OPF", nombre:"Olimpiadas de Padres de Familia",
      partidos_minimos:1, partidos_maximos:2,
      agrupar_disciplina:true, alternar_genero:true, peso_mismo_nombre:3,
      prioridades:["Todos los equipos juegan al menos un partido en la semana",
                   "Si sobra tiempo y cancha, el segundo partido va a los que menos partidos tienen",
                   "Los partidos de cada disciplina van juntos",
                   "Se alternan las categorías: primero damas, después varones, y así sucesivamente",
                   "Cada partido lleva un árbitro de su disciplina",
                   "En lo posible, damas y varones del mismo nombre se programan seguidos"] },
    { codigo:"ASFSEM", nombre:"Asfinbol semestral",
      partidos_minimos:1, partidos_maximos:2,
      agrupar_disciplina:false, alternar_genero:false, peso_mismo_nombre:8,
      prioridades:["Todos los equipos juegan al menos un partido en la semana",
                   "Si sobra tiempo y cancha, el segundo partido va a los que menos partidos tienen",
                   "Los equipos del mismo nombre de distintas categorías se programan juntos",
                   "Cada partido lleva un árbitro de su disciplina"] },
    { codigo:"ASFVER", nombre:"Asfinbol verano",
      partidos_minimos:2, partidos_maximos:3,
      agrupar_disciplina:false, alternar_genero:false, peso_mismo_nombre:8,
      prioridades:["Todos los equipos juegan al menos dos partidos en la semana",
                   "Si sobra tiempo y cancha, el tercer partido va a los que menos partidos tienen",
                   "Los equipos del mismo nombre de distintas categorías se programan juntos",
                   "Cada partido lleva un árbitro de su disciplina"] },
    { codigo:"LIBSEN", nombre:"Categoría Libre Senior",
      partidos_minimos:1, partidos_maximos:2,
      agrupar_disciplina:false, alternar_genero:false, peso_mismo_nombre:0,
      prioridades:["Todos los equipos juegan al menos un partido en la semana",
                   "Si sobra tiempo y cancha, el segundo partido va a los que menos partidos tienen",
                   "Cada partido lleva un árbitro de su disciplina"] }
  ];
  vista_calendario:boolean=true;
  columnas_calendario:any[]=[];
  celda_arrastrada:any=null;
  partido_arrastrado:any=null;
  //canchas siempre disponibles: las agregadas a mano sin partidos, la que llena la matriz y lo que se puede deshacer
  canchas_abiertas:any[]=[];
  cancha_activa:any=null;
  historial_turnos:any[]=[];
  //panel al lado de la matriz: dias para elegir, partidos de la cancha activa y su siguiente horario
  fecha_panel:any=null;
  canchas_panel:any[]=[];
  //disponibilidad cargada en cada escenario (dias y horario), por id de escenario
  disponibilidad_escenarios:any={};
  partidos_cancha_activa:any[]=[];
  siguiente_cancha_activa:string=null;

  constructor(private router: Router,
    public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService: NgbModal,
    private toastr: ToastrService,
    public campeonatosService:CampeonatosService,
    public rolesPartidosService:RolesPartidosService,
    public rolPartidoPdfService:RolPartidoPdfService,
    public pdfService:PdfService,
    public productosService:ProductosService,
    public orderPipe:OrderPipe,
    public socket:Socket,
    public ventasService:VentasService,
    public cajasService:CajasService,
    public proveedoresService:ProveedoresService,
    public escenariosService:EscenariosService,
  private cdr: ChangeDetectorRef){
      super(persistenciaService,modalService,generalService,usuarioService);
    }

  async ngOnInit(): Promise<void> {
    this.init();
    this.armarHorasDisponibles();
		this.buscarAplicacion(this.router.url.substring(1));
    this.aplicacion_ventas= this.usuario.aplicacionesUsuario.filter(app_usuario => app_usuario.aplicacion.codigo==GlobalVariable.Dictionary.CODIGO_APP_VENTAS)[0];
		this.configuracion_pagina={};
    this.obtenerConfiguracionPagina(GlobalVariable.Dictionary.CODIGO_APP_ROL_PARTIDOS);
    this.filter={
			id_empresa:this.usuario.id_empresa,
      campeonato:GlobalVariable.Dictionary.SELECCION_TODOS,
      campeonatos:[GlobalVariable.Dictionary.SELECCION_TODOS],
      usuarios:[{nombre_usuario:"TODOS",id:0}],
      usuario: {nombre_usuario:"TODOS",id:0},
		}

    this.obtenerCampeonatos();
    await this.configurarCalendario();
    this.obtenerPartidos();
    this.column = "updatedAt";
    this.direction = "desc";
		this.getSearch(this.text_search,null);
  }

  ngAfterViewInit() {
    aplicarPluginCalendario();
		resaltarPestañaMenu(this.router.url.substring(1)+"1");
  }

  getItems(){
		this.blockUI.start('Recuperando... espere por favor!');
		this.rolesPartidosService.obtenerListaRolesPartidos(this).subscribe((dato:any) => {
			this.setPages(dato.paginas);
			this.roles_partidos=dato.roles_partidos;
			this.blockUI.stop();
		});
	}

  async obtenerCampeonatos(){
    this.filter.campeonatos=[GlobalVariable.Dictionary.SELECCION_TODOS];
    this.campeonatos=await this.campeonatosService.obtenerCampeonatosEmpresa(this.usuario.id_empresa).toPromise() as any[];
    this.filter.campeonatos=this.filter.campeonatos.concat(this.campeonatos);
  }

  async obtenerPartidos(){
    this.blockUI.start();
    this.calendarApi = this.calendarComponent.getApi();
    this.rolesPartidosService.obtenerPartidosSemana(this.usuario.id_empresa).subscribe((partidos:any)=>{
      this.blockUI.stop();      
      let escenarios:any = Array.from(
        partidos
          .reduce((map, partido) => map.set(partido.id_escenario, partido.escenario), new Map())
          .values()
      );
      let rr=[];
      for(let j=0;j<escenarios.length;j++){
        let resource:any={
          id:escenarios[j].id,
          title:escenarios[j].nombre
        }
        rr.push(resource);
      }
      this.calendarOptions.resources=rr;
      for(var i=0;i<partidos.length;i++){
        let partido_calendario:any={
            id:partidos[i].id,
            title: (partidos[i].equipo_1.nombre+" VS "+partidos[i].equipo_2.nombre)
        }
        
        let fecha_hora_inicio=new Date(partidos[i].fecha_hora);
        let fecha_hora_fin=new Date(partidos[i].fecha_hora);
        fecha_hora_fin.setMinutes(fecha_hora_fin.getMinutes()+45);
        const newEvent: EventInput = {
          resourceId: partidos[i].id_escenario,
          id:partidos[i].id,
          start:fecha_hora_inicio,
          end: fecha_hora_fin,
          title: (partidos[i].equipo_1.nombre+" VS "+partidos[i].equipo_2.nombre),
          backgroundColor:partidos[i].rol_partido.campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta,
          className: "text-white text-80", // Sets background only
        };
        
        this.calendarApi.addEvent(newEvent);
      }
      //$('#'+$scope.idCalendario).fullCalendar('addEventSource',$scope.pedidos_calendario);
    });
	}

  async configurarCalendario(){
      this.calendarOptions.businessHours={
        daysOfWeek: [0,1,2,3,4,5,6],
        startTime: "08:00",
        endTime: "23:00"
      };
    }  

  obtenerTarjetas(){
    this.blockUI.start('Recuperando... espere por favor!');
		this.rolesPartidosService.obtenerListaTarjetas().subscribe((lista_tarjetas:any) => {
			this.lista_tarjetas=lista_tarjetas;
			this.blockUI.stop();
		});
  }

  async crearNuevoRolPartido(){
    this.partido={
      w_o_equipo_1:{es_wo:false},
      w_o_equipo_2:{es_wo:false}
    };
    this.equipos=[];
    this.reiniciarMatrizCruces();
    await this.obtenerRolesPartidosEmpresa();
    this.obtenerCategoriasEquiposEmpresa();
    this.obtenerFasesCampeonato();
    this.obtenerDisciplinasCampeonato();
    this.obtenerEscenarios();
    this.obtenerArbitros();
    let codigo_nuevo=await this.obtenerUltimoCodigo(GlobalVariable.Dictionary.TIPO_CORRELATIVO_CODIGO_ROL_PARTIDO);
    this.rol_partido={
        id_empresa: this.usuario.id_empresa, id_usuario:this.usuario.id,
        codigo:codigo_nuevo,
        activo:true,
        partidos:[]
    }
    this.columnas_calendario=[];
    this.reiniciarTurnosCancha();
    this.abrirRegistroRolPartido();
  }

  async modificarRolPartido(rol_partido){
    this.partido={
      escenario:null,
      w_o_equipo_1:{es_wo:false},
      w_o_equipo_2:{es_wo:false}
    };
    this.reiniciarMatrizCruces();
    this.reiniciarTurnosCancha();
    this.blockUI.start();
    await this.obtenerRolesPartidosEmpresa();
    this.obtenerCategoriasEquiposEmpresa();
    this.obtenerFasesCampeonato();
    this.obtenerDisciplinasCampeonato();
    this.rolesPartidosService.obtenerRolPartido(rol_partido.id).subscribe((res:any)=>{
      this.blockUI.stop();
      this.obtenerEscenarios();
      this.obtenerArbitros();
      this.rol_partido=res;
      this.rol_partido.partidos=this.rol_partido.partidos.filter(p => p.activo);
      this.abrirRegistroRolPartido();
      this.allItemsSelected=true;
      this.selectAllItems(this.rol_partido.partidos);
      this.refrescarCalendario();
    });
  }

  abrirRegistroRolPartido(){
    this.modal_registro_rol_partido=this.modalService.open(this.modal_registro_rol_partido_ref, {windowClass:'rol-partido',ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
    this.modal_registro_rol_partido.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  async obtenerRolesPartidosEmpresa(){
		this.tipo_rol_partido=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_ROLES_PARTIDOS).toPromise();
	}

  obtenerEquiposCampeonato(campeonato,categoria,disciplina){
    if(campeonato && categoria){
      this.blockUI.start('Recuperando... espere por favor!');
      this.campeonatosService.obtenerListaEquipos(campeonato.id,categoria?categoria.id:0,disciplina?disciplina.id:0).subscribe((equipos:any) => {
        this.equipos=equipos;
        this.blockUI.stop();
      });
    }
  }

  obtenerEscenarios(){
    this.blockUI.start('Recuperando... espere por favor!');
		this.rolesPartidosService.obtenerEscenarios(this.usuario.id_empresa).subscribe((escenarios:any) => {
			this.escenarios=escenarios;
			//el calendario puede haberse armado antes de que llegaran: se completan sus canchas destino
			this.columnas_calendario.forEach(columna => columna.canchas.forEach(cancha => cancha.destinos=this.canchasDestino(cancha)));
			this.cargarDisponibilidadEscenarios();
			this.blockUI.stop();
		});
  }

  obtenerArbitros(){
    this.blockUI.start('Recuperando... espere por favor!');
		this.rolesPartidosService.obtenerArbitros(this.usuario.id_empresa).subscribe((arbitros:any) => {
			this.arbitros=arbitros.filter(a => a.tipo.nombre_corto==GlobalVariable.Dictionary.TOR.ARBITRO_PRINCIPAL);
      this.mesas=arbitros.filter(a => a.tipo.nombre_corto==GlobalVariable.Dictionary.TOR.ARBITRO_MESA);
			this.blockUI.stop();
		});
  }

  /* Matriz de cruces: cada fila es el equipo 1 y cada columna el equipo 2, igual que la planilla de
     programacion en excel. Las celdas ocupadas muestran los partidos ya programados/jugados de todo el
     campeonato y al hacer click en una celda vacia se agrega el cruce a la lista del rol de partidos. */

  reiniciarMatrizCruces(){
    this.mostrar_matriz_cruces=false;
    this.mostrar_cambio_fase=false;
    this.matriz_equipos=[];
    this.matriz_celdas=[];
    this.matriz_partidos_campeonato=[];
    this.matriz_filtro=null;
    this.matriz_grupos=[];
    this.matriz_grupo=null;
    this.matriz_leyenda_fechas=[];
    this.matriz_densidad="";
  }

  esFaseSoloIda(){
    return this.matriz_filtro && this.matriz_filtro.fase && this.matriz_filtro.fase.nombre_corto=="T.C.T. SOLO IDA";
  }

  async alternarMatrizCruces(){
    if(this.mostrar_matriz_cruces){
      this.reiniciarMatrizCruces();
    }else{
      if(!this.rol_partido || !this.rol_partido.campeonato){
        this.toastr.error("Debe especificar el campeonato!");
        return;
      }
      this.mostrar_matriz_cruces=true;
      await this.obtenerGruposMatriz();
    }
  }

  /* Una pestaña por categoria+disciplina, que es como se arma la planilla. La fase se elige dentro
     de la pestaña: agrupar tambien por fase daria decenas de pestañas de llaves (final, semifinales)
     con dos o tres equipos, donde la matriz no aporta nada. */
  async obtenerGruposMatriz(){
    this.blockUI.start('Recuperando categorias... espere por favor!');
    this.matriz_grupos=await this.campeonatosService.obtenerCombosMatriz(this.rol_partido.campeonato.id).toPromise() as any[];
    this.blockUI.stop();
    this.matriz_grupo=null;
    this.matriz_filtro=null;
    this.matriz_equipos=[];
    this.matriz_celdas=[];
    if(this.matriz_grupos.length==0){
      this.toastr.info("El campeonato no tiene categorias con equipos suficientes para armar una matriz!");
      return;
    }
    //si el formulario ya tiene categoria y disciplina, se abre esa pestaña
    let grupo_formulario=null;
    if(this.partido.categoria && this.partido.disciplina){
      grupo_formulario=this.matriz_grupos.filter(grupo => grupo.id_categoria==this.partido.categoria.id &&
                                                          grupo.id_disciplina==this.partido.disciplina.id)[0];
    }
    await this.seleccionarGrupoMatriz(grupo_formulario?grupo_formulario:this.matriz_grupos[0]);
  }

  async seleccionarGrupoMatriz(grupo){
    this.matriz_grupo=grupo;
    //por defecto la fase con mas partidos, que es la de todos contra todos
    let fase=grupo.fases.length>0?this.buscarFasePorId(grupo.fases[0].id_fase):null;
    if(!fase){
      fase=(this.partido.fase && grupo.fases.length==0)?this.partido.fase:
           (this.tipo_fase.clases.length>0?this.tipo_fase.clases[0]:null);
    }
    await this.establecerFiltroMatriz(grupo,fase);
  }

  /* ─── Cambio de fase en bloque ─────────────────────────────────────────────────
     Muchas veces recien en la 3ra o 4ta fecha se decide si el torneo es solo ida. Los partidos
     guardados quedaron en la otra fase y la matriz (que filtra por fase) ya no los ve. Esto pasa de
     una vez todos los partidos del campeonato de una fase a otra, en todos sus roles, y antes
     muestra los cruces que quedarian repetidos (A vs B y B vs A en solo ida) para quitar el que
     todavia no se jugo. */

  abrirCambioFase(){
    let origen=this.matriz_filtro?this.matriz_filtro.fase:null;
    this.cambio_fase={ origen:origen, destino:this.faseOpuesta(origen), todo_campeonato:true,
                       revisado:false, conflictos:[], total:0, grupos:0 };
    this.mostrar_cambio_fase=true;
  }

  //de "T.C.T. ida y vuelta" propone "T.C.T. solo ida" y al reves
  faseOpuesta(fase){
    if(!fase || !this.tipo_fase || !this.tipo_fase.clases){
      return null;
    }
    let nombre=String(fase.nombre).toUpperCase();
    let buscada=nombre.indexOf("IDA Y VUELTA")>=0?"SOLO IDA":(nombre.indexOf("SOLO IDA")>=0?"IDA Y VUELTA":null);
    if(!buscada){
      return null;
    }
    return this.tipo_fase.clases.filter(clase => String(clase.nombre).toUpperCase().indexOf(buscada)>=0)[0]||null;
  }

  //si se cambia algo del cambio de fase, hay que volver a revisar
  invalidarCambioFase(){
    this.cambio_fase.revisado=false;
    this.cambio_fase.conflictos=[];
  }

  //el partido entra en el alcance del cambio (todo el campeonato o la categoria y disciplina de la matriz)
  partidoEnAlcanceCambioFase(id_categoria,id_disciplina){
    if(this.cambio_fase.todo_campeonato){
      return true;
    }
    return id_categoria==this.matriz_filtro.categoria.id && id_disciplina==this.matriz_filtro.disciplina.id;
  }

  async revisarCambioFase(){
    let cambio=this.cambio_fase;
    if(!cambio.origen || !cambio.destino){
      this.toastr.error("Elige la fase de origen y la de destino");
      return;
    }
    if(cambio.origen.id==cambio.destino.id){
      this.toastr.error("La fase de origen y la de destino son la misma");
      return;
    }
    let id_categoria=cambio.todo_campeonato?0:this.matriz_filtro.categoria.id;
    let id_disciplina=cambio.todo_campeonato?0:this.matriz_filtro.disciplina.id;
    this.blockUI.start('Revisando partidos... espere por favor!');
    let partidos:any[];
    try{
      partidos=await this.rolesPartidosService.obtenerPartidosCambioFase(this.rol_partido.campeonato.id,id_categoria,id_disciplina,
                                                                         cambio.origen.id,cambio.destino.id).toPromise() as any[];
    }catch(error){
      this.blockUI.stop();
      this.toastr.error("No se pudieron revisar los partidos");
      return;
    }
    this.blockUI.stop();
    //los partidos del rol abierto que todavia no se guardaron tambien cambian de fase
    let sin_guardar=this.rol_partido.partidos.filter(partido =>
      !partido.id && !partido.eliminado && partido.fase && partido.categoria && partido.disciplina &&
      (partido.fase.id==cambio.origen.id || partido.fase.id==cambio.destino.id) &&
      this.partidoEnAlcanceCambioFase(partido.categoria.id,partido.disciplina.id))
      .map(partido => ({ id:null, referencia:partido, id_fase:partido.fase.id,
                         id_categoria:partido.categoria.id, id_disciplina:partido.disciplina.id,
                         id_equipo_1:partido.equipo_1.id, id_equipo_2:partido.equipo_2.id,
                         equipo_1:partido.equipo_1, equipo_2:partido.equipo_2,
                         categoria:partido.categoria, disciplina:partido.disciplina,
                         fecha_hora:partido.fecha_hora, marcador_equipo_1:null, marcador_equipo_2:null,
                         rol_partido:{ codigo:this.rol_partido.codigo }, sin_guardar:true }));
    let todos=partidos.concat(sin_guardar);
    let que_cambian=todos.filter(partido => partido.id_fase==cambio.origen.id);
    cambio.total=que_cambian.length;
    cambio.grupos=new Set(que_cambian.map(partido => partido.id_categoria+"|"+partido.id_disciplina)).size;

    /* Cruces repetidos: misma categoria y disciplina, los mismos dos equipos (en cualquier orden) y
       al menos uno de los partidos cambia de fase. Por defecto se quitan los no jugados: si alguno
       ya se jugo quedan los jugados; si ninguno, queda el primero. Los que tienen resultado o venta
       no se pueden quitar. */
    let pares={};
    todos.forEach(partido => {
      let menor=Math.min(partido.id_equipo_1,partido.id_equipo_2),mayor=Math.max(partido.id_equipo_1,partido.id_equipo_2);
      let clave=partido.id_categoria+"|"+partido.id_disciplina+"|"+menor+"|"+mayor;
      pares[clave]=pares[clave]?pares[clave]:[];
      pares[clave].push(partido);
    });
    let conflictos=[];
    Object.keys(pares).forEach(clave => {
      let grupo=pares[clave];
      if(grupo.length<2 || !grupo.some(partido => partido.id_fase==cambio.origen.id)){
        return;
      }
      grupo.sort((uno,otro) => new Date(uno.fecha_hora).getTime()-new Date(otro.fecha_hora).getTime());
      grupo.forEach(partido => {
        partido.jugado=(partido.marcador_equipo_1!=null && partido.marcador_equipo_2!=null);
        partido.con_venta=!!(partido.id_venta_equipo_1 || partido.id_venta_equipo_2);
        partido.quitable=!partido.jugado && !partido.con_venta;
      });
      let hay_jugados=grupo.some(partido => partido.jugado);
      grupo.forEach((partido,indice) => {
        partido.quitar=partido.quitable && (hay_jugados || indice>0);
      });
      conflictos.push({ categoria:grupo[0].categoria, disciplina:grupo[0].disciplina, partidos:grupo });
    });
    cambio.conflictos=conflictos;
    cambio.revisado=true;
  }

  aplicarCambioFase(){
    let cambio=this.cambio_fase;
    let quitar=[];
    cambio.conflictos.forEach(conflicto => conflicto.partidos.forEach(partido => {
      if(partido.quitar && partido.quitable){
        quitar.push(partido);
      }
    }));
    this.popupConfirmacion=this.modalService.open(PopupConfirmacionComponent);
    this.popupConfirmacion.componentInstance.message="¿Pasar "+cambio.total+" partido(s) de "+cambio.origen.nombre+" a "+cambio.destino.nombre+
      (quitar.length>0?(" y quitar "+quitar.length+" partido(s) repetido(s) sin jugar"):"")+"?";
    this.popupConfirmacion.componentInstance.onConfirm.subscribe(async ($e) => {
      this.popupConfirmacion.close();
      if(!$e.confirm){
        return;
      }
      this.blockUI.start('Cambiando la fase... espere por favor!');
      let res:any;
      try{
        res=await this.rolesPartidosService.cambiarFasePartidos(this.rol_partido.campeonato.id,{
          id_fase_origen:cambio.origen.id,
          id_fase_destino:cambio.destino.id,
          id_categoria:cambio.todo_campeonato?null:this.matriz_filtro.categoria.id,
          id_disciplina:cambio.todo_campeonato?null:this.matriz_filtro.disciplina.id,
          quitar:quitar.filter(partido => partido.id).map(partido => partido.id)
        }).toPromise();
      }catch(error){
        this.blockUI.stop();
        this.toastr.error("No se pudo cambiar la fase");
        return;
      }
      /* El rol abierto tambien se pone al dia, si no al guardarlo volveria a escribir la fase vieja:
         sus partidos de la fase de origen pasan a la de destino y los repetidos quitados salen. */
      let ids_quitados=quitar.filter(partido => partido.id).map(partido => partido.id);
      let referencias_quitadas=quitar.filter(partido => partido.referencia).map(partido => partido.referencia);
      this.rol_partido.partidos=this.rol_partido.partidos.filter(partido =>
        referencias_quitadas.indexOf(partido)<0 && !(partido.id && ids_quitados.indexOf(partido.id)>=0));
      this.rol_partido.partidos.forEach(partido => {
        if(!partido.eliminado && partido.fase && partido.fase.id==cambio.origen.id && partido.categoria && partido.disciplina &&
           this.partidoEnAlcanceCambioFase(partido.categoria.id,partido.disciplina.id)){
          partido.fase=cambio.destino;
        }
      });
      this.blockUI.stop();
      this.toastr.success(res.mensaje);
      this.mostrar_cambio_fase=false;
      this.refrescarCalendario();
      await this.recargarMatrizConFase(cambio.destino);
    });
  }

  //despues del cambio, la matriz se vuelve a armar con la fase nueva (y los conteos por fase al dia)
  async recargarMatrizConFase(fase){
    let grupo_actual=this.matriz_grupo;
    this.matriz_grupos=await this.campeonatosService.obtenerCombosMatriz(this.rol_partido.campeonato.id).toPromise() as any[];
    let grupo=grupo_actual?this.matriz_grupos.filter(otro => otro.id_categoria==grupo_actual.id_categoria &&
                                                             otro.id_disciplina==grupo_actual.id_disciplina)[0]:null;
    if(!grupo){
      grupo=this.matriz_grupos.length>0?this.matriz_grupos[0]:null;
    }
    if(!grupo){
      return;
    }
    this.matriz_grupo=grupo;
    await this.establecerFiltroMatriz(grupo,fase);
  }

  buscarFasePorId(id_fase){
    return this.buscarClasePorId(this.tipo_fase,id_fase);
  }

  buscarClasePorId(tipo,id_clase){
    return (tipo && tipo.clases)?tipo.clases.filter(clase => clase.id==id_clase)[0]:null;
  }

  async cambiarFaseMatriz(id_fase){
    await this.establecerFiltroMatriz(this.matriz_grupo,this.buscarFasePorId(id_fase));
  }

  async establecerFiltroMatriz(grupo,fase){
    if(!grupo || !fase){
      this.toastr.error("Debe especificar la fase para armar la matriz de cruces!");
      return;
    }
    this.matriz_filtro={
      categoria:{ id:grupo.id_categoria, nombre:grupo.categoria },
      disciplina:{ id:grupo.id_disciplina, nombre:grupo.disciplina },
      fase:fase
    };
    this.blockUI.start('Recuperando cruces... espere por favor!');
    this.matriz_equipos=await this.campeonatosService.obtenerListaEquipos(this.rol_partido.campeonato.id,grupo.id_categoria,grupo.id_disciplina).toPromise() as any[];
    this.matriz_partidos_campeonato=await this.rolesPartidosService.obtenerPartidosCruces(this.rol_partido.campeonato.id,grupo.id_categoria,grupo.id_disciplina,fase.id).toPromise() as any[];
    this.blockUI.stop();
    /* La matriz debe entrar sin scroll horizontal: cuantos mas equipos, mas angosta la celda, y a
       partir de 12 se muestra solo la hora (la fecha queda en el color de jornada y en el tooltip). */
    this.matriz_densidad=(this.matriz_equipos.length>20)?"matriz-muy-compacta":
                         ((this.matriz_equipos.length>12)?"matriz-compacta":"");
    this.refrescarMatrizCruces();
    this.refrescarCalendario();
  }

  //se mantiene para los (change) de categoria/fase/disciplina del formulario de alta
  async construirMatrizCruces(){
    if(!this.mostrar_matriz_cruces || this.matriz_grupos.length==0){
      return;
    }
    if(!this.partido.categoria || !this.partido.disciplina){
      return;
    }
    let grupo=this.matriz_grupos.filter(g => g.id_categoria==this.partido.categoria.id &&
                                             g.id_disciplina==this.partido.disciplina.id)[0];
    if(grupo && grupo!=this.matriz_grupo){
      await this.seleccionarGrupoMatriz(grupo);
    }
  }

  refrescarMatrizCruces(){
    if(!this.mostrar_matriz_cruces || !this.matriz_filtro || this.matriz_equipos.length==0){
      return;
    }
    let indice_cruces={};
    //partidos ya guardados de todo el campeonato
    for(let i=0;i<this.matriz_partidos_campeonato.length;i++){
      let partido_campeonato=this.matriz_partidos_campeonato[i];
      //los del rol que se esta editando se toman de la lista local, que es la que tiene los cambios sin guardar
      if(this.rol_partido.id && partido_campeonato.id_rol_partido==this.rol_partido.id){
        continue;
      }
      indice_cruces[partido_campeonato.id_equipo_1+"-"+partido_campeonato.id_equipo_2]={
        partido:partido_campeonato,
        codigo_rol:partido_campeonato.rol_partido?partido_campeonato.rol_partido.codigo:"",
        en_rol_actual:false
      };
    }
    //partidos de la lista del rol que se esta editando, incluidos los que aun no se guardan
    for(let i=0;i<this.rol_partido.partidos.length;i++){
      let partido_rol=this.rol_partido.partidos[i];
      if(partido_rol.eliminado || !partido_rol.equipo_1 || !partido_rol.equipo_2){
        continue;
      }
      if(partido_rol.categoria && partido_rol.categoria.id!=this.matriz_filtro.categoria.id){
        continue;
      }
      if(partido_rol.fase && partido_rol.fase.id!=this.matriz_filtro.fase.id){
        continue;
      }
      if(partido_rol.disciplina && partido_rol.disciplina.id!=this.matriz_filtro.disciplina.id){
        continue;
      }
      indice_cruces[partido_rol.equipo_1.id+"-"+partido_rol.equipo_2.id]={
        partido:partido_rol,
        codigo_rol:this.rol_partido.codigo,
        en_rol_actual:true
      };
    }

    this.contarPartidosEquiposMatriz(indice_cruces);

    let solo_ida=this.esFaseSoloIda();
    this.matriz_celdas=[];
    for(let f=0;f<this.matriz_equipos.length;f++){
      let fila=[];
      for(let c=0;c<this.matriz_equipos.length;c++){
        let equipo_fila=this.matriz_equipos[f],equipo_columna=this.matriz_equipos[c];
        let celda:any={ equipo_fila:equipo_fila, equipo_columna:equipo_columna, espejo:false,
                        equipo_baja:(!equipo_fila.activo || !equipo_columna.activo) };
        if(equipo_fila.id==equipo_columna.id){
          celda.estado="diagonal";
        }else{
          let cruce=indice_cruces[equipo_fila.id+"-"+equipo_columna.id];
          //en las fases de solo ida el cruce inverso es el mismo partido, se marca como espejo
          if(!cruce && solo_ida){
            cruce=indice_cruces[equipo_columna.id+"-"+equipo_fila.id];
            celda.espejo=cruce?true:false;
          }
          if(cruce){
            celda.partido=cruce.partido;
            celda.codigo_rol=cruce.codigo_rol;
            celda.en_rol_actual=cruce.en_rol_actual;
            celda.sin_guardar=!cruce.partido.id;
            celda.jugado=(cruce.partido.marcador_equipo_1!=null && cruce.partido.marcador_equipo_2!=null);
            celda.estado=celda.jugado?"jugado":"programado";
            celda.marcador=celda.espejo?(cruce.partido.marcador_equipo_2+"-"+cruce.partido.marcador_equipo_1):
                                        (cruce.partido.marcador_equipo_1+"-"+cruce.partido.marcador_equipo_2);
          }else{
            celda.estado="vacia";
          }
        }
        //se resuelve aca y no en la plantilla: ahi se evaluaria una vez por celda en cada ciclo
        celda.movible=this.puedeMoverCelda(celda);
        fila.push(celda);
      }
      this.matriz_celdas.push(fila);
    }
    this.asignarColoresFechaMatriz();
  }

  /* Cuenta cuantos partidos tiene cada equipo en la matriz, jugados y pendientes. Se cuenta sobre los
     cruces y no sobre las celdas: en las fases de solo ida el cruce inverso es el mismo partido y
     contarlo por celda lo duplicaria. */
  contarPartidosEquiposMatriz(indice_cruces){
    let total={},pendientes={};
    for(let clave in indice_cruces){
      let cruce=indice_cruces[clave];
      let jugado=(cruce.partido.marcador_equipo_1!=null && cruce.partido.marcador_equipo_2!=null);
      let ids=clave.split("-");
      for(let i=0;i<ids.length;i++){
        total[ids[i]]=(total[ids[i]]||0)+1;
        if(!jugado){
          pendientes[ids[i]]=(pendientes[ids[i]]||0)+1;
        }
      }
    }
    this.matriz_resumen_equipos=this.matriz_equipos.map(equipo => {
      let partidos_total=total[equipo.id]||0,partidos_pendientes=pendientes[equipo.id]||0;
      return {
        total:partidos_total,
        pendientes:partidos_pendientes,
        jugados:partidos_total-partidos_pendientes
      };
    });
  }

  /* Pinta cada partido sin resultado segun su fecha, para distinguir de un vistazo los de cada dia.
     Los colores se reparten en orden cronologico y la leyenda siempre muestra la equivalencia, asi
     que la fecha nunca queda expresada solo por color: la celda tambien la lleva escrita. */
  asignarColoresFechaMatriz(){
    let fechas=[];
    let celdas_pendientes=[];
    for(let f=0;f<this.matriz_celdas.length;f++){
      for(let c=0;c<this.matriz_celdas[f].length;c++){
        let celda=this.matriz_celdas[f][c];
        celda.color_fecha=null;
        if(celda.estado!="programado" || !celda.partido.fecha_hora){
          continue;
        }
        let fecha_partido=new Date(celda.partido.fecha_hora);
        let dia=new Date(fecha_partido.getFullYear(),fecha_partido.getMonth(),fecha_partido.getDate());
        celda.clave_fecha=dia.getTime();
        celdas_pendientes.push(celda);
        if(fechas.filter(fe => fe.clave==celda.clave_fecha).length==0){
          //el nombre del dia se arma aca porque la aplicacion no tiene registrado el locale es
          fechas.push({ clave:dia.getTime(), fecha:dia, dia_literal:this.matriz_dias_semana[dia.getDay()] });
        }
      }
    }
    fechas.sort((a,b) => a.clave-b.clave);
    //el color sale del dia de la semana, no del orden: asi el martes siempre se ve igual
    for(let i=0;i<fechas.length;i++){
      let paleta=this.matriz_colores_dia[fechas[i].fecha.getDay()];
      fechas[i].color=paleta?paleta.fondo:this.matriz_color_otras_fechas;
      fechas[i].color_texto=paleta?paleta.texto:"#ffffff";
      fechas[i].abreviatura=paleta?paleta.nombre:"";
      fechas[i].partidos=celdas_pendientes.filter(celda => celda.clave_fecha==fechas[i].clave).length;
    }
    for(let i=0;i<celdas_pendientes.length;i++){
      let fecha_celda=fechas.filter(fe => fe.clave==celdas_pendientes[i].clave_fecha)[0];
      celdas_pendientes[i].color_fecha=fecha_celda?fecha_celda.color:null;
      celdas_pendientes[i].color_texto_fecha=fecha_celda?fecha_celda.color_texto:null;
      celdas_pendientes[i].dia_abreviado=fecha_celda?fecha_celda.abreviatura:"";
    }
    this.matriz_leyenda_fechas=fechas;
  }

  /* ─── Generacion automatica del rol de la semana ───────────────────────────────
     El rol es semanal y abarca todas las categorias y disciplinas del campeonato a la vez.

     Los cruces salen de un todos contra todos por el metodo del circulo (se fija el primer equipo
     y se rotan los demas), calculado por separado para cada categoria+disciplina segun su fase:
     ida y vuelta duplica la rueda invirtiendo la localia. De ahi se descartan los cruces que ya
     estan jugados o programados, y los que quedan se van acomodando en los turnos libres de la
     semana.

     Un turno es una combinacion de dia, escenario y hora. Salen de la disponibilidad cargada en
     cada escenario, que dice que dias se puede usar y en que franja horaria.

     Restricciones que se respetan al acomodar:
       - ningun equipo juega mas de un partido por dia
       - ningun equipo supera el maximo de partidos por semana
       - cada escenario no pasa del tope de partidos por dia
       - dos partidos nunca caen en el mismo escenario a la misma hora */

  alternarPanelFixture(){
    this.mostrar_panel_fixture=!this.mostrar_panel_fixture;
    if(this.mostrar_panel_fixture){
      this.prepararPanelFixture();
    }
  }

  async prepararPanelFixture(){
    let hoy=new Date();
    //la semana arranca el proximo martes, que es cuando empieza a jugarse
    let inicio=new Date(hoy.getTime());
    while(inicio.getDay()!=2){
      inicio.setDate(inicio.getDate()+1);
    }
    this.blockUI.start('Recuperando escenarios... espere por favor!');
    let escenarios:any=await this.escenariosService.obtenerEscenariosConDisponibilidad(this.usuario.id_empresa).toPromise();
    this.blockUI.stop();
    this.fixture={
      algoritmo: this.algoritmos_fixture[0],
      fecha_inicio_texto: Util.convertirFechaAObjectoFecha(inicio),
      //dias en la numeracion de Date.getDay(); por defecto de martes a sabado
      dias: [{dia:2,nombre:"Martes",usar:true},{dia:3,nombre:"Miércoles",usar:true},
             {dia:4,nombre:"Jueves",usar:true},{dia:5,nombre:"Viernes",usar:true},
             {dia:6,nombre:"Sábado",usar:true},{dia:0,nombre:"Domingo",usar:false},
             {dia:1,nombre:"Lunes",usar:false}],
      partidos_por_dia_escenario: 4,
      maximo_partidos_equipo_semana: this.algoritmos_fixture[0].partidos_maximos,
      escenarios: escenarios.filter(escenario => escenario.disponibilidades && escenario.disponibilidades.length>0),
      escenarios_sin_disponibilidad: escenarios.filter(escenario => !escenario.disponibilidades || escenario.disponibilidades.length==0).length,
      seleccionados: []
    };
    //se usan por defecto todos los escenarios que tengan disponibilidad cargada
    this.fixture.seleccionados=this.fixture.escenarios.slice();
  }

  algoritmoFixture(){
    return (this.fixture && this.fixture.algoritmo)?this.fixture.algoritmo:this.algoritmos_fixture[0];
  }

  //al cambiar de algoritmo se acomoda el tope semanal al que ese algoritmo propone
  cambiarAlgoritmoFixture(){
    this.fixture.maximo_partidos_equipo_semana=this.algoritmoFixture().partidos_maximos;
  }

  alternarEscenarioFixture(escenario){
    let indice=this.fixture.seleccionados.findIndex(seleccionado => seleccionado.id==escenario.id);
    if(indice>=0){
      this.fixture.seleccionados.splice(indice,1);
    }else{
      this.fixture.seleccionados.push(escenario);
    }
  }

  esEscenarioFixtureSeleccionado(escenario){
    return this.fixture && this.fixture.seleccionados.some(seleccionado => seleccionado.id==escenario.id);
  }

  diasDisponiblesEscenario(escenario){
    let nombres={0:"Dom",1:"Lun",2:"Mar",3:"Mié",4:"Jue",5:"Vie",6:"Sáb"};
    return (escenario.disponibilidades||[]).map(disponibilidad => nombres[disponibilidad.id_dia]).join(" ");
  }

  //rueda de todos contra todos: devuelve un arreglo de jornadas, cada una con sus cruces
  armarRuedaFixture(equipos){
    let lista=equipos.slice();
    if(lista.length%2==1){
      lista.push(null);   //descanso
    }
    let cantidad=lista.length,jornadas=[];
    for(let ronda=0;ronda<cantidad-1;ronda++){
      let jornada=[];
      for(let i=0;i<cantidad/2;i++){
        let uno=lista[i],otro=lista[cantidad-1-i];
        if(uno && otro){
          //se alterna la localia por jornada para que no siempre juegue de local el mismo
          jornada.push((ronda%2==0)?{ local:uno, visitante:otro }:{ local:otro, visitante:uno });
        }
      }
      jornadas.push(jornada);
      lista.splice(1,0,lista.pop());   //rota dejando fijo el primero
    }
    return jornadas;
  }

  //de las fases del grupo se toma la de todos contra todos, que es la unica que admite rueda
  faseTodosContraTodosGrupo(grupo){
    for(let i=0;i<grupo.fases.length;i++){
      let fase=this.buscarClasePorId(this.tipo_fase,grupo.fases[i].id_fase);
      if(fase && fase.nombre.toUpperCase().indexOf("T.C.T.")>=0){
        return fase;
      }
    }
    //si todavia no tiene partidos, se busca entre las fases configuradas de la empresa
    return this.tipo_fase.clases.filter(clase => clase.nombre.toUpperCase().indexOf("T.C.T. SOLO IDA")>=0)[0];
  }

  //cruces que faltan jugar en todo el campeonato, en orden de jornada
  async obtenerCrucesPendientesCampeonato(){
    let pendientes_por_grupo=[];
    for(let g=0;g<this.matriz_grupos.length;g++){
      let grupo=this.matriz_grupos[g];
      let fase=this.faseTodosContraTodosGrupo(grupo);
      let categoria=this.buscarClasePorId(this.tipo_categoria,grupo.id_categoria);
      let disciplina=this.buscarClasePorId(this.tipo_disciplina,grupo.id_disciplina);
      if(!fase || !categoria || !disciplina){
        continue;
      }
      let equipos=await this.campeonatosService.obtenerListaEquipos(this.rol_partido.campeonato.id,
                        grupo.id_categoria,grupo.id_disciplina).toPromise() as any[];
      /* Los equipos dados de baja quedan fuera del fixture automatico. Siguen viendose en la matriz
         y se les puede programar un partido a mano haciendo click en su celda. */
      equipos=equipos.filter(equipo => equipo.activo);
      if(equipos.length<2){
        continue;
      }
      let partidos=await this.rolesPartidosService.obtenerPartidosCruces(this.rol_partido.campeonato.id,
                        grupo.id_categoria,grupo.id_disciplina,fase.id).toPromise() as any[];
      let existentes={};
      for(let i=0;i<partidos.length;i++){
        existentes[partidos[i].id_equipo_1+"-"+partidos[i].id_equipo_2]=true;
      }
      //los que ya estan en la lista de este rol, todavia sin guardar
      for(let i=0;i<this.rol_partido.partidos.length;i++){
        let partido=this.rol_partido.partidos[i];
        if(!partido.eliminado && partido.equipo_1 && partido.equipo_2){
          existentes[partido.equipo_1.id+"-"+partido.equipo_2.id]=true;
        }
      }

      this.marcarEquiposAtrasados(equipos,partidos);

      let ida_y_vuelta=fase.nombre.toUpperCase().indexOf("IDA Y VUELTA")>=0;
      let jornadas=this.armarRuedaFixture(equipos);
      if(ida_y_vuelta){
        jornadas=jornadas.concat(jornadas.map(jornada =>
                   jornada.map(cruce => ({ local:cruce.visitante, visitante:cruce.local }))));
      }
      let pendientes_grupo=[];
      for(let j=0;j<jornadas.length;j++){
        for(let c=0;c<jornadas[j].length;c++){
          let cruce=jornadas[j][c];
          let directo=existentes[cruce.local.id+"-"+cruce.visitante.id];
          //en solo ida el cruce inverso es el mismo partido; en ida y vuelta son dos distintos
          let inverso=existentes[cruce.visitante.id+"-"+cruce.local.id];
          if(directo || (!ida_y_vuelta && inverso)){
            continue;
          }
          pendientes_grupo.push({ categoria:categoria, disciplina:disciplina, fase:fase,
                                  local:cruce.local, visitante:cruce.visitante });
        }
      }
      if(pendientes_grupo.length>0){
        pendientes_por_grupo.push(pendientes_grupo);
      }
    }

    /* Se intercalan los grupos en vez de encadenarlos: si se encadenaran, cuando hay pocos turnos
       la primera categoria se los lleva todos y las ultimas quedan sin partidos en la semana.
       Intercalando, cada categoria entra por turno y el orden de jornada se mantiene dentro de
       cada una.
       El intercalado va por disciplina y, dentro de cada una, alternando damas y varones: asi los
       partidos de una misma disciplina quedan juntos y las categorias se van turnando. */
    return this.intercalarPendientes(pendientes_por_grupo);
  }

  esCategoriaDamas(categoria){
    return categoria && categoria.nombre.toUpperCase().indexOf("DAMA")>=0;
  }

  esCategoriaVarones(categoria){
    return categoria && categoria.nombre.toUpperCase().indexOf("VARON")>=0;
  }

  /* Ordena los cruces pendientes de todo el campeonato segun el algoritmo elegido:
       1. disciplina: los partidos de una misma disciplina salen juntos (si el algoritmo lo pide)
       2. damas y varones alternados dentro de la disciplina (si el algoritmo lo pide)
       3. resto de categorias, intercaladas para que ninguna quede afuera
     Sin agrupar por disciplina, todas las listas caen en un solo bloque y se mezclan entre si. */
  intercalarPendientes(pendientes_por_grupo){
    let algoritmo=this.algoritmoFixture();
    //se agrupan las listas por disciplina, conservando el orden en que vinieron
    let disciplinas=[];
    for(let g=0;g<pendientes_por_grupo.length;g++){
      let lista=pendientes_por_grupo[g];
      let id_disciplina=algoritmo.agrupar_disciplina?lista[0].disciplina.id:0;
      let bloque=disciplinas.filter(item => item.id_disciplina==id_disciplina)[0];
      if(!bloque){
        bloque={ id_disciplina:id_disciplina, damas:[], varones:[], otras:[] };
        disciplinas.push(bloque);
      }
      if(algoritmo.alternar_genero && this.esCategoriaDamas(lista[0].categoria)){
        bloque.damas.push(lista);
      }else if(algoritmo.alternar_genero && this.esCategoriaVarones(lista[0].categoria)){
        bloque.varones.push(lista);
      }else{
        bloque.otras.push(lista);
      }
    }

    let ordenados=[];
    for(let d=0;d<disciplinas.length;d++){
      let bloque=disciplinas[d];
      //dentro de damas (o de varones) se intercalan sus categorias entre si
      let damas=this.intercalarListas(bloque.damas);
      let varones=this.intercalarListas(bloque.varones);
      let otras=this.intercalarListas(bloque.otras);
      //primero un partido de damas, luego uno de varones, y asi sucesivamente
      let mayor=Math.max(damas.length,varones.length);
      for(let i=0;i<mayor;i++){
        if(i<damas.length){ ordenados.push(damas[i]); }
        if(i<varones.length){ ordenados.push(varones[i]); }
      }
      ordenados=ordenados.concat(otras);
    }
    return ordenados;
  }

  //mezcla varias listas tomando un elemento de cada una por vuelta
  intercalarListas(listas){
    let resultado=[],mayor=0;
    for(let i=0;i<listas.length;i++){
      mayor=Math.max(mayor,listas[i].length);
    }
    for(let i=0;i<mayor;i++){
      for(let l=0;l<listas.length;l++){
        if(i<listas[l].length){
          resultado.push(listas[l][i]);
        }
      }
    }
    return resultado;
  }

  /* Arma el calendario: una columna por fecha y, dentro de cada una, un bloque por cancha con sus
     partidos ordenados por hora. Se recalcula cada vez que cambia la lista, igual que la matriz. */
  refrescarCalendario(){
    let columnas=[];
    let obtenerColumna=(dia) => {
      let columna=columnas.filter(item => item.clave==dia.getTime())[0];
      if(!columna){
        let paleta=this.matriz_colores_dia[dia.getDay()];
        columna={ clave:dia.getTime(), fecha:dia,
                  dia_literal:this.matriz_dias_semana[dia.getDay()],
                  color:paleta?paleta.fondo:this.matriz_color_otras_fechas,
                  color_texto:paleta?paleta.texto:"#ffffff",
                  canchas:[], total:0 };
        columnas.push(columna);
      }
      return columna;
    };
    let obtenerCancha=(columna,escenario) => {
      let id_cancha=escenario?escenario.id:0;
      let cancha=columna.canchas.filter(item => item.id==id_cancha)[0];
      if(!cancha){
        cancha={ id:id_cancha,
                 nombre:escenario?escenario.nombre:"Sin escenario",
                 escenario:escenario?escenario:null,
                 partidos:[], mover_a:null, abierta:null };
        //se calcula aca y no en la plantilla, si no el desplegable se redibujaria a cada rato
        cancha.destinos=this.canchasDestino(cancha);
        columna.canchas.push(cancha);
      }
      return cancha;
    };
    for(let i=0;i<this.rol_partido.partidos.length;i++){
      let partido=this.rol_partido.partidos[i];
      if(partido.eliminado || !partido.fecha_hora){
        continue;
      }
      let fecha_hora=new Date(partido.fecha_hora);
      let columna=obtenerColumna(new Date(fecha_hora.getFullYear(),fecha_hora.getMonth(),fecha_hora.getDate()));
      obtenerCancha(columna,partido.escenario).partidos.push(partido);
      columna.total++;
    }
    //las canchas agregadas a mano aparecen aunque todavia no tengan partidos
    for(let i=0;i<this.canchas_abiertas.length;i++){
      let abierta=this.canchas_abiertas[i];
      obtenerCancha(obtenerColumna(abierta.fecha),abierta.escenario).abierta=abierta;
    }
    columnas.sort((uno,otro) => uno.clave-otro.clave);
    for(let i=0;i<columnas.length;i++){
      columnas[i].canchas.sort((uno,otro) => uno.nombre.localeCompare(otro.nombre));
      for(let c=0;c<columnas[i].canchas.length;c++){
        let cancha=columnas[i].canchas[c];
        cancha.partidos.sort((uno,otro) =>
          new Date(uno.fecha_hora).getTime()-new Date(otro.fecha_hora).getTime());
        //el siguiente turno de la cancha, que se muestra al pie del bloque
        cancha.siguiente=cancha.escenario?
          this.siguienteHoraCancha(columnas[i].fecha,cancha.escenario,cancha.abierta?cancha.abierta.desde:"08:00"):null;
      }
    }
    this.columnas_calendario=columnas;
    this.actualizarPanelCancha();
  }

  reiniciarTurnosCancha(){
    this.canchas_abiertas=[];
    this.cancha_activa=null;
    this.historial_turnos=[];
    this.fecha_panel=null;
  }

  /* ─── Canchas siempre disponibles ──────────────────────────────────────────────
     Toda cancha de todo dia esta disponible, sin tope de turnos ni de horario: el "siguiente" de
     una cancha es la hora de su ultimo partido ese dia mas la duracion de partido (la de la matriz),
     y si no tiene partidos, la hora desde la que se la agrego. Tocando "+ siguiente" en una cancha
     del calendario, o eligiendo dia y cancha en "Los cruces van a" (junto a la matriz), esa cancha
     queda activa y cada celda que se marca en la matriz va a su siguiente turno, con el arbitro y la
     mesa del ultimo partido de esa cancha ese dia (el arbitro es opcional: se puede asignar despues
     por cancha). Una cancha elegida que todavia no tiene partidos vive solo en pantalla hasta que
     tenga alguno. */

  partidosCancha(fecha,escenario){
    return this.rol_partido.partidos.filter(otro =>
      !otro.eliminado && otro.escenario && otro.escenario.id==escenario.id &&
      otro.fecha_hora && new Date(otro.fecha_hora).toDateString()==fecha.toDateString());
  }

  //hora desde la que se agrego la cancha a mano (si se agrego), o las 08:00
  desdeCancha(fecha,escenario){
    let abierta=this.canchas_abiertas.filter(otra => otra.escenario.id==escenario.id && otra.fecha.getTime()==fecha.getTime())[0];
    return abierta?abierta.desde:"08:00";
  }

  /* Siguiente turno de una cancha ese dia: despues de su ultimo partido, sumando la duracion; sin
     partidos, desde la hora indicada. Salta los horarios ocupados. null si ya no queda dia. */
  siguienteHoraCancha(fecha,escenario,desde){
    let duracion=Number(this.matriz_duracion_partido)>0?Number(this.matriz_duracion_partido):50;
    let previos=this.partidosCancha(fecha,escenario);
    let hora,minuto;
    if(previos.length>0){
      let siguiente=new Date(Math.max(...previos.map(otro => new Date(otro.fecha_hora).getTime()))+duracion*60000);
      if(siguiente.toDateString()!=fecha.toDateString()){
        return null;
      }
      hora=siguiente.getHours();
      minuto=siguiente.getMinutes();
    }else{
      let partes=String(desde||"08:00").split(":");
      hora=Number(partes[0]);
      minuto=Number(partes[1]);
    }
    let libre=this.horarioLibreCancha(fecha,escenario,null,hora,minuto);
    return libre.toDateString()==fecha.toDateString()?this.horaTextoPdf(libre):null;
  }

  esCanchaActiva(columna,cancha){
    let activa=this.cancha_activa;
    return !!activa && !!cancha.escenario && activa.escenario.id==cancha.escenario.id &&
           activa.fecha.getTime()==columna.fecha.getTime();
  }

  activarCancha(columna,cancha){
    if(!cancha.escenario){
      return;
    }
    this.establecerCanchaActiva(columna.fecha,cancha.escenario);
  }

  dejarDeLlenar(){
    this.establecerCanchaActiva(null,null);
  }

  /* Cambia la cancha que llena la matriz. Si esa cancha no tiene partidos ese dia, se la agrega al
     calendario (vacia) para que se vea donde van a caer los cruces; la que se agrego asi y se dejo
     sin partidos se quita al cambiar a otra. */
  establecerCanchaActiva(fecha,escenario){
    let anterior=this.cancha_activa;
    if(anterior){
      this.canchas_abiertas=this.canchas_abiertas.filter(abierta =>
        !(abierta.automatica && abierta.escenario.id==anterior.escenario.id && abierta.fecha.getTime()==anterior.fecha.getTime() &&
          this.partidosCancha(abierta.fecha,abierta.escenario).length==0));
    }
    this.cancha_activa=(fecha && escenario)?{ fecha:fecha, escenario:escenario }:null;
    if(this.cancha_activa && this.partidosCancha(fecha,escenario).length==0 &&
       !this.canchas_abiertas.some(abierta => abierta.escenario.id==escenario.id && abierta.fecha.getTime()==fecha.getTime())){
      this.canchas_abiertas.push({ fecha:fecha, escenario:escenario, desde:this.inicioDisponibilidad(fecha,escenario), automatica:true });
    }
    this.refrescarCalendario();
  }

  /* Canchas que se ofrecen en "Los cruces van a": las que tienen disponibilidad cargada para ese
     dia de la semana. Si ningun escenario tiene disponibilidad cargada, se ofrecen todas, para no
     dejar el selector vacio en las empresas que no la usan. */
  async cargarDisponibilidadEscenarios(){
    try{
      let lista:any=await this.escenariosService.obtenerEscenariosConDisponibilidad(this.usuario.id_empresa).toPromise();
      let mapa={};
      (lista||[]).forEach(escenario => mapa[escenario.id]=escenario.disponibilidades?escenario.disponibilidades:[]);
      this.disponibilidad_escenarios=mapa;
    }catch(error){
      this.disponibilidad_escenarios={};
    }
    this.actualizarPanelCancha();
  }

  canchasDisponibles(fecha){
    let escenarios=this.escenarios?this.escenarios:[];
    let alguna_con_disponibilidad=escenarios.some(escenario => (this.disponibilidad_escenarios[escenario.id]||[]).length>0);
    if(!fecha || !alguna_con_disponibilidad){
      return escenarios;
    }
    let dia=fecha.getDay();
    return escenarios.filter(escenario =>
      (this.disponibilidad_escenarios[escenario.id]||[]).some(fila => fila.id_dia==dia) ||
      (this.cancha_activa && this.cancha_activa.escenario.id==escenario.id && this.cancha_activa.fecha.getTime()==fecha.getTime()));
  }

  //hora en que abre la cancha ese dia segun su disponibilidad, o las 08:00
  inicioDisponibilidad(fecha,escenario){
    let fila=(this.disponibilidad_escenarios[escenario.id]||[]).filter(disponibilidad => disponibilidad.id_dia==fecha.getDay())[0];
    if(!fila){
      return "08:00";
    }
    let hora=Number(fila.hora_inicio)||0,minuto=Number(fila.minuto_inicio)||0;
    return (hora<10?"0":"")+hora+":"+(minuto<10?"0":"")+minuto;
  }

  //selectores del panel de la matriz: cualquier fecha y, de ese dia, las canchas disponibles
  cambiarFechaPanel(valor){
    this.fecha_panel=valor;
    if(!valor || !valor.year){
      return; //todavia escribiendo la fecha
    }
    let fecha=Util.convertirObjetoAfecha(valor);
    fecha.setHours(0,0,0,0);
    if(this.cancha_activa && this.cancha_activa.fecha.getTime()==fecha.getTime()){
      return;
    }
    let disponibles=this.canchasDisponibles(fecha);
    let escenario=(this.cancha_activa && disponibles.some(otro => otro.id==this.cancha_activa.escenario.id))?
                  this.cancha_activa.escenario:(disponibles.length>0?disponibles[0]:null);
    if(!escenario){
      this.toastr.info("Ninguna cancha tiene disponibilidad ese día");
      this.establecerCanchaActiva(null,null);
      return;
    }
    this.establecerCanchaActiva(fecha,escenario);
  }

  cambiarCanchaPanel(escenario){
    if(!escenario){
      return;
    }
    let fecha=this.cancha_activa?this.cancha_activa.fecha:
              ((this.fecha_panel && this.fecha_panel.year)?Util.convertirObjetoAfecha(this.fecha_panel):null);
    if(!fecha){
      //sin dia elegido: el del ultimo partido del rol, o mañana
      fecha=this.columnas_calendario.length>0?new Date(this.columnas_calendario[this.columnas_calendario.length-1].fecha.getTime()):new Date();
      if(this.columnas_calendario.length==0){
        fecha.setDate(fecha.getDate()+1);
      }
    }
    fecha.setHours(0,0,0,0);
    this.establecerCanchaActiva(fecha,escenario);
  }

  //hora de inicio de una cancha que todavia no tiene partidos ese dia
  cambiarDesdePanel(hora){
    let activa=this.cancha_activa;
    if(!activa || !hora){
      return;
    }
    let abierta=this.canchas_abiertas.filter(otra => otra.escenario.id==activa.escenario.id && otra.fecha.getTime()==activa.fecha.getTime())[0];
    if(abierta){
      abierta.desde=hora;
    }else{
      this.canchas_abiertas.push({ fecha:activa.fecha, escenario:activa.escenario, desde:hora, automatica:true });
    }
    this.refrescarCalendario();
  }

  actualizarPanelCancha(){
    let activa=this.cancha_activa;
    if(activa){
      this.fecha_panel=Util.convertirFechaAObjectoFecha(activa.fecha);
    }
    let fecha_elegida=activa?activa.fecha:((this.fecha_panel && this.fecha_panel.year)?Util.convertirObjetoAfecha(this.fecha_panel):null);
    this.canchas_panel=this.canchasDisponibles(fecha_elegida);
    this.partidos_cancha_activa=activa?this.partidosCancha(activa.fecha,activa.escenario)
      .sort((uno,otro) => new Date(uno.fecha_hora).getTime()-new Date(otro.fecha_hora).getTime()):[];
    this.siguiente_cancha_activa=this.siguienteCanchaActiva();
  }

  //quita una cancha agregada a mano que todavia no tiene partidos
  quitarCanchaVacia(columna,cancha){
    this.canchas_abiertas=this.canchas_abiertas.filter(abierta =>
      !(abierta.escenario.id==cancha.escenario.id && abierta.fecha.getTime()==columna.fecha.getTime()));
    if(this.esCanchaActiva(columna,cancha)){
      this.cancha_activa=null;
    }
    this.refrescarCalendario();
  }

  siguienteCanchaActiva(){
    let activa=this.cancha_activa;
    return activa?this.siguienteHoraCancha(activa.fecha,activa.escenario,this.desdeCancha(activa.fecha,activa.escenario)):null;
  }

  textoCanchaActiva(){
    let activa=this.cancha_activa;
    if(!activa){
      return "";
    }
    let siguiente=this.siguienteCanchaActiva();
    return this.matriz_dias_semana[activa.fecha.getDay()]+" "+activa.fecha.getDate()+"/"+(activa.fecha.getMonth()+1)+
           " · "+activa.escenario.nombre+(siguiente?(" · siguiente "+siguiente):" · sin horario libre hasta medianoche");
  }

  /* La celda de la matriz va al siguiente turno de la cancha activa, con el arbitro y la mesa del
     ultimo partido de esa cancha ese dia que los tenga (o sin ellos). */
  async llenarTurnoActivo(){
    let activa=this.cancha_activa;
    let siguiente=this.siguienteCanchaActiva();
    if(!siguiente){
      this.toastr.warning(activa.escenario.nombre+" ya no tiene horario libre ese día. Elige otra cancha u otro día.");
      this.partido.equipo_1_c=null;
      this.partido.equipo_2_c=null;
      return;
    }
    let previos=this.partidosCancha(activa.fecha,activa.escenario)
                    .sort((uno,otro) => new Date(uno.fecha_hora).getTime()-new Date(otro.fecha_hora).getTime());
    let con_arbitro=previos.filter(otro => otro.arbitro).pop();
    let con_mesa=previos.filter(otro => otro.mesa).pop();
    let partes=siguiente.split(":");
    let partido_nuevo=Object.assign({},this.partido,{
      fecha_hora_texto:Util.convertirFechaAObjectoFecha(activa.fecha),
      hora:{ hour:Number(partes[0]), minute:Number(partes[1]) },
      escenario:activa.escenario,
      arbitro:con_arbitro?con_arbitro.arbitro:null,
      mesa:con_mesa?con_mesa.mesa:null
    });
    if(await this.validarPartido(partido_nuevo)){
      partido_nuevo.fecha_hora=Util.convertirObjetoAfecha(partido_nuevo.fecha_hora_texto);
      partido_nuevo.fecha_hora.setHours(partido_nuevo.hora.hour,partido_nuevo.hora.minute,0,0);
      partido_nuevo.w_o_equipo_1={es_wo:false};
      partido_nuevo.w_o_equipo_2={es_wo:false};
      this.rol_partido.partidos.push(partido_nuevo);
      this.historial_turnos.push({ partido:partido_nuevo });
    }
    this.partido.equipo_1_c=null;
    this.partido.equipo_2_c=null;
    this.partido.equipo_1=null;
    this.partido.equipo_2=null;
    this.refrescarMatrizCruces();
    this.refrescarCalendario();
  }

  //quita el ultimo cruce cargado desde la matriz y vuelve a dejar activa su cancha
  deshacerTurno(){
    let paso=this.historial_turnos.pop();
    if(!paso){
      return;
    }
    let indice=this.rol_partido.partidos.indexOf(paso.partido);
    if(indice>=0 && !paso.partido.id){
      this.rol_partido.partidos.splice(indice,1);
    }
    let fecha=new Date(paso.partido.fecha_hora);
    fecha.setHours(0,0,0,0);
    //si la cancha se quedo sin partidos, sigue en el calendario desde la hora del que se quito
    if(this.partidosCancha(fecha,paso.partido.escenario).length==0 &&
       !this.canchas_abiertas.some(abierta => abierta.escenario.id==paso.partido.escenario.id && abierta.fecha.getTime()==fecha.getTime())){
      this.canchas_abiertas.push({ fecha:fecha, escenario:paso.partido.escenario, desde:this.horaTextoPdf(new Date(paso.partido.fecha_hora)) });
    }
    this.cancha_activa={ fecha:fecha, escenario:paso.partido.escenario };
    this.refrescarMatrizCruces();
    this.refrescarCalendario();
  }

  /* ─── Mover partidos entre dias y canchas en el calendario ─────────────────────
     Se arrastra la tarjeta y se suelta en el bloque de otra cancha, de la misma fecha o de otra.
     El partido conserva su hora; si ese horario ya esta ocupado en la cancha destino, se corre al
     siguiente turno libre de ese dia. */

  puedeMoverPartido(partido){
    return this.aplicacion.puede_crear && !partido.id_venta_equipo_1 && !partido.id_venta_equipo_2;
  }

  iniciarArrastrePartido(evento,partido){
    if(!this.puedeMoverPartido(partido)){
      evento.preventDefault();
      return;
    }
    this.partido_arrastrado=partido;
    evento.dataTransfer.effectAllowed="move";
    evento.dataTransfer.setData("text/plain","partido");
  }

  permitirSoltarPartido(evento,cancha){
    //no se admite soltar en el bloque de los partidos sin escenario
    if(this.partido_arrastrado && cancha.escenario){
      evento.preventDefault();
      evento.dataTransfer.dropEffect="move";
    }
  }

  permitirSoltarSobrePartido(evento,destino){
    if(this.partido_arrastrado && this.partido_arrastrado!=destino && this.puedeMoverPartido(destino)){
      evento.preventDefault();
      evento.stopPropagation();
      evento.dataTransfer.dropEffect="move";
    }
  }

  /* Soltar una tarjeta encima de otra intercambia los dos partidos: cada uno se queda con la fecha,
     la hora y la cancha del otro. Sirve tanto para cambiar de horario dentro de la misma cancha
     como para permutar dos partidos de dias o canchas distintas. */
  soltarSobrePartido(evento,destino){
    evento.stopPropagation();
    let origen=this.partido_arrastrado;
    this.partido_arrastrado=null;
    if(!origen || origen==destino){
      return;
    }
    if(!this.puedeMoverPartido(destino)){
      this.toastr.error("No se puede mover un partido que ya tiene venta generada!");
      return;
    }
    let fecha_origen=new Date(origen.fecha_hora),escenario_origen=origen.escenario;

    origen.fecha_hora=new Date(destino.fecha_hora);
    origen.fecha_hora_texto=Util.convertirFechaAObjectoFecha(origen.fecha_hora);
    origen.hora={ hour:origen.fecha_hora.getHours(), minute:origen.fecha_hora.getMinutes() };
    origen.escenario=destino.escenario;

    destino.fecha_hora=fecha_origen;
    destino.fecha_hora_texto=Util.convertirFechaAObjectoFecha(fecha_origen);
    destino.hora={ hour:fecha_origen.getHours(), minute:fecha_origen.getMinutes() };
    destino.escenario=escenario_origen;

    this.refrescarCalendario();
    this.refrescarMatrizCruces();
    this.toastr.success("Partidos intercambiados: "+origen.equipo_1.nombre+" pasa a las "+
                        this.horaTextoPdf(new Date(origen.fecha_hora))+" y "+destino.equipo_1.nombre+
                        " a las "+this.horaTextoPdf(new Date(destino.fecha_hora)));
  }

  terminarArrastrePartido(){
    this.partido_arrastrado=null;
  }

  //primer horario libre de esa cancha ese dia, a partir del que traia el partido
  horarioLibreCancha(fecha,escenario,partido,hora,minuto){
    let duracion=Number(this.matriz_duracion_partido);
    let candidato=new Date(fecha.getTime());
    candidato.setHours(hora);
    candidato.setMinutes(minuto);
    for(let intento=0;intento<24;intento++){
      let ocupado=this.rol_partido.partidos.some(otro =>
        !otro.eliminado && otro!=partido && otro.escenario && otro.escenario.id==escenario.id &&
        otro.fecha_hora && new Date(otro.fecha_hora).getTime()==candidato.getTime());
      if(!ocupado){
        return candidato;
      }
      candidato=new Date(candidato.getTime());
      candidato.setMinutes(candidato.getMinutes()+duracion);
    }
    return candidato;
  }

  /* Horas que ofrece la tarjeta, cada 15 minutos. Se arma una sola vez: si se armara en cada
     chequeo de cambios, el desplegable se redibujaria a cada rato. */
  armarHorasDisponibles(){
    let horas=[];
    for(let hora=6;hora<=23;hora++){
      for(let minuto=0;minuto<60;minuto=minuto+15){
        horas.push((hora<10?"0":"")+hora+":"+(minuto<10?"0":"")+minuto);
      }
    }
    this.horas_disponibles=horas;
  }

  horaTextoPartido(partido){
    return partido.fecha_hora?this.horaTextoPdf(new Date(partido.fecha_hora)):"";
  }

  //un partido puede tener una hora que no cae en la grilla de 15 minutos; se la agrega aparte
  horaFueraDeGrilla(partido){
    let actual=this.horaTextoPartido(partido);
    return actual!="" && this.horas_disponibles.indexOf(actual)<0;
  }

  //el motivo por el que un partido no admite cambios, para poder mostrarlo en la tarjeta
  motivoPartidoBloqueado(partido){
    if(partido.id_venta_equipo_1 || partido.id_venta_equipo_2){
      return "No se puede cambiar la hora: el partido ya tiene venta generada";
    }
    return "No tenés permiso para modificar el rol";
  }

  /* Cambio rapido de hora desde la tarjeta, sin entrar a modificar todo el partido. Se conserva el
     dia y la cancha; si ese horario ya esta ocupado en la misma cancha, se corre al siguiente
     libre, igual que cuando se arrastra la tarjeta. */
  cambiarHoraPartido(partido,valor){
    if(!valor || !this.puedeMoverPartido(partido)){
      return;
    }
    let partes=String(valor).split(":");
    let hora=Number(partes[0]),minuto=Number(partes[1]);
    if(isNaN(hora) || isNaN(minuto)){
      return;
    }
    let fecha_previa=new Date(partido.fecha_hora);
    if(fecha_previa.getHours()==hora && fecha_previa.getMinutes()==minuto){
      return;
    }

    let fecha_hora=new Date(fecha_previa.getTime());
    fecha_hora.setHours(hora);
    fecha_hora.setMinutes(minuto);
    fecha_hora.setSeconds(0);
    if(partido.escenario){
      let dia=new Date(fecha_previa.getFullYear(),fecha_previa.getMonth(),fecha_previa.getDate());
      fecha_hora=this.horarioLibreCancha(dia,partido.escenario,partido,hora,minuto);
    }
    partido.fecha_hora=fecha_hora;
    partido.fecha_hora_texto=Util.convertirFechaAObjectoFecha(fecha_hora);
    partido.hora={ hour:fecha_hora.getHours(), minute:fecha_hora.getMinutes() };

    this.refrescarCalendario();
    this.refrescarMatrizCruces();
    if(fecha_hora.getHours()!=hora || fecha_hora.getMinutes()!=minuto){
      this.toastr.info("Ese horario ya estaba ocupado en "+partido.escenario.nombre+
                       ": el partido quedó a las "+this.horaTextoPdf(fecha_hora));
    }
  }

  /* Lo marcado es lo que entra en la imagen para redes; si no hay nada marcado, la imagen sale
     con todos los partidos del rol, que es como venia funcionando desde la vista tabla. */
  alternarSeleccionPartido(partido,marcado){
    partido.selected=marcado;
    this.addItemToSelected(partido);
  }

  seleccionarPartidosCancha(cancha,marcado){
    for(let i=0;i<cancha.partidos.length;i++){
      cancha.partidos[i].selected=marcado;
      this.addItemToSelected(cancha.partidos[i]);
    }
  }

  contarSeleccionadosCancha(cancha){
    return cancha.partidos.filter(partido => partido.selected).length;
  }

  canchaTodaSeleccionada(cancha){
    return cancha.partidos.length>0 && this.contarSeleccionadosCancha(cancha)==cancha.partidos.length;
  }

  //cuantos partidos entrarian hoy en la imagen, contando todo el rol
  contarSeleccionadosRol(){
    return this.rol_partido.partidos.filter(partido => !partido.eliminado && partido.selected).length;
  }

  //marca todos los partidos del rol, de todas las canchas y dias
  marcarTodosPartidos(){
    this.allItemsSelected=true;
    this.selectedItems=[];
    for(let i=0;i<this.rol_partido.partidos.length;i++){
      let partido=this.rol_partido.partidos[i];
      partido.selected=!partido.eliminado;
      if(partido.selected){
        this.selectedItems.push(partido);
      }
    }
  }

  /* Copia del rol con solo los partidos de una cancha del calendario (un dia y una cancha). Las
     casillas siguen valiendo dentro de la cancha: si hay partidos marcados en ella sale solo con
     esos, y si no, con la cancha completa. Lo marcado en otras canchas no entra; para juntar
     varias canchas esta el fixture general. */
  rolDeCancha(rol_partido,cancha){
    return Object.assign({},rol_partido,{
      partidos:cancha.partidos.filter(partido => !partido.eliminado)
    });
  }

  textoAlcanceCancha(cancha){
    let marcados=this.contarSeleccionadosCancha(cancha);
    return cancha.nombre+" ("+(marcados>0?(marcados+" marcado(s)"):("los "+cancha.partidos.length+" partidos"))+")";
  }

  textoAlcanceFixture(){
    let marcados=this.contarSeleccionadosRol();
    return marcados>0?(marcados+" partido(s) marcados"):"todo el rol";
  }

  quitarSeleccionPartidos(){
    this.selectedItems=[];
    this.allItemsSelected=false;
    this.rol_partido.partidos.forEach(partido => partido.selected=false);
  }


  soltarPartidoCalendario(columna,cancha){
    let partido=this.partido_arrastrado;
    this.partido_arrastrado=null;
    if(!partido || !cancha.escenario){
      return;
    }
    let fecha_previa=new Date(partido.fecha_hora);
    let mismo_dia=(columna.fecha.getFullYear()==fecha_previa.getFullYear() &&
                   columna.fecha.getMonth()==fecha_previa.getMonth() &&
                   columna.fecha.getDate()==fecha_previa.getDate());
    if(mismo_dia && partido.escenario && partido.escenario.id==cancha.escenario.id){
      return;   //no se movio a ningun lado
    }

    let fecha_hora=this.horarioLibreCancha(columna.fecha,cancha.escenario,partido,
                                           fecha_previa.getHours(),fecha_previa.getMinutes());
    partido.fecha_hora=fecha_hora;
    partido.fecha_hora_texto=Util.convertirFechaAObjectoFecha(fecha_hora);
    partido.hora={ hour:fecha_hora.getHours(), minute:fecha_hora.getMinutes() };
    partido.escenario=cancha.escenario;

    this.refrescarCalendario();
    this.refrescarMatrizCruces();
    let corrido=(fecha_hora.getHours()!=fecha_previa.getHours() || fecha_hora.getMinutes()!=fecha_previa.getMinutes());
    this.toastr.success("Partido movido a "+cancha.escenario.nombre+" el "+
                        this.matriz_dias_semana[fecha_hora.getDay()]+" "+fecha_hora.getDate()+"/"+(fecha_hora.getMonth()+1)+
                        (corrido?(", corrido a las "+this.horaTextoPdf(fecha_hora)+" porque el horario estaba ocupado"):""));
  }

  /* Cambio urgente de cancha: pasa los partidos de esta cancha (ese dia) a otra. Respeta las
     casillas: si hay partidos marcados en la cancha se mueven solo esos; si no, todos. Cada
     partido conserva su hora y, si ese horario ya esta ocupado en la cancha destino, se corre al
     siguiente libre, igual que al arrastrarlo. Los partidos con venta generada no se mueven. */
  moverPartidosCancha(cancha,escenario){
    cancha.mover_a=null;
    if(!escenario){
      return;
    }
    let marcados=cancha.partidos.filter(partido => partido.selected);
    let candidatos=(marcados.length>0?marcados:cancha.partidos)
                     .slice().sort((uno,otro) => new Date(uno.fecha_hora).getTime()-new Date(otro.fecha_hora).getTime());
    let movidos=0,corridos=0,bloqueados=0;
    for(let i=0;i<candidatos.length;i++){
      let partido=candidatos[i];
      if(!this.puedeMoverPartido(partido)){
        bloqueados++;
        continue;
      }
      let fecha_previa=new Date(partido.fecha_hora);
      let dia=new Date(fecha_previa.getFullYear(),fecha_previa.getMonth(),fecha_previa.getDate());
      let fecha_hora=this.horarioLibreCancha(dia,escenario,partido,fecha_previa.getHours(),fecha_previa.getMinutes());
      if(fecha_hora.getTime()!=fecha_previa.getTime()){
        corridos++;
      }
      partido.fecha_hora=fecha_hora;
      partido.fecha_hora_texto=Util.convertirFechaAObjectoFecha(fecha_hora);
      partido.hora={ hour:fecha_hora.getHours(), minute:fecha_hora.getMinutes() };
      partido.escenario=escenario;
      movidos++;
    }
    this.refrescarCalendario();
    this.refrescarMatrizCruces();
    if(movidos>0){
      this.toastr.success(movidos+" partido(s) movidos de "+cancha.nombre+" a "+escenario.nombre+
                          (corridos>0?(". "+corridos+" se corrieron de hora porque el horario estaba ocupado"):""));
    }
    if(bloqueados>0){
      this.toastr.warning(bloqueados+" partido(s) no se movieron porque ya tienen venta generada");
    }
  }

  //canchas a las que se pueden pasar los partidos: todas menos la propia
  canchasDestino(cancha){
    return (this.escenarios?this.escenarios:[]).filter(escenario => !cancha.escenario || escenario.id!=cancha.escenario.id);
  }

  /* Asigna de una sola vez el arbitro o la mesa a todos los partidos de esa cancha en ese dia.
     Los partidos con venta generada no se tocan. */
  asignarArbitroCancha(cancha,arbitro){
    let alcanzados=0;
    for(let i=0;i<cancha.partidos.length;i++){
      if(this.puedeMoverPartido(cancha.partidos[i])){
        cancha.partidos[i].arbitro=arbitro;
        alcanzados++;
      }
    }
    this.toastr.success("Árbitro asignado a "+alcanzados+" partido(s) de "+cancha.nombre);
  }

  asignarMesaCancha(cancha,mesa){
    let alcanzados=0;
    for(let i=0;i<cancha.partidos.length;i++){
      if(this.puedeMoverPartido(cancha.partidos[i])){
        cancha.partidos[i].mesa=mesa;
        alcanzados++;
      }
    }
    this.toastr.success("Mesa asignada a "+alcanzados+" partido(s) de "+cancha.nombre);
  }

  //dos cruces comparten club si alguno de sus equipos pertenece al mismo cliente
  compartenClub(uno,otro){
    let clubes=[otro.local.id_cliente,otro.visitante.id_cliente].filter(id => id!=null);
    if(clubes.length==0){
      return false;
    }
    return clubes.indexOf(uno.local.id_cliente)>=0 || clubes.indexOf(uno.visitante.id_cliente)>=0;
  }

  /* Cuenta cuantos equipos del cruce llevan el mismo nombre que alguno del cruce anterior. Es la
     misma cuenta para damas y varones de un colegio que para las distintas categorias de un club:
     el nombre del equipo se repite y la categoria es la que cambia. */
  coincidenciaNombres(uno,otro){
    if(!uno || !otro){
      return 0;
    }
    let previos=[this.nombreEquipoFixture(otro.local),this.nombreEquipoFixture(otro.visitante)]
                  .filter(nombre => nombre!="");
    let cantidad=0;
    if(previos.indexOf(this.nombreEquipoFixture(uno.local))>=0){
      cantidad++;
    }
    if(previos.indexOf(this.nombreEquipoFixture(uno.visitante))>=0){
      cantidad++;
    }
    return cantidad;
  }

  nombreEquipoFixture(equipo){
    return (equipo && equipo.nombre)?String(equipo.nombre).toUpperCase().trim():"";
  }

  /* Marca los equipos que van muy atrasados en partidos jugados respecto a su propia categoria,
     para adelantarlos y que lleguen a jugar sus dos partidos de la semana. */
  marcarEquiposAtrasados(equipos,partidos){
    let jugados={};
    for(let i=0;i<equipos.length;i++){
      jugados[equipos[i].id]=0;
    }
    for(let i=0;i<partidos.length;i++){
      if(jugados[partidos[i].id_equipo_1]!=null){ jugados[partidos[i].id_equipo_1]++; }
      if(jugados[partidos[i].id_equipo_2]!=null){ jugados[partidos[i].id_equipo_2]++; }
    }
    let suma=0;
    for(let i=0;i<equipos.length;i++){
      suma=suma+jugados[equipos[i].id];
    }
    let promedio=equipos.length>0?(suma/equipos.length):0;
    for(let i=0;i<equipos.length;i++){
      equipos[i].partidos_jugados=jugados[equipos[i].id];
      //se considera atrasado si le falta mas de un partido respecto al promedio de su categoria
      equipos[i].atrasado=(jugados[equipos[i].id]<(promedio-1));
    }
  }

  /* Restricciones cargadas en el equipo. Devuelve false si el turno no le sirve. */
  equipoAceptaTurno(equipo,turno){
    let restricciones=equipo.restricciones?equipo.restricciones:[];
    let hay_escenario_obligado=false,cumple_escenario_obligado=false;
    for(let i=0;i<restricciones.length;i++){
      let restriccion=restricciones[i];
      if(restriccion.tipo=="DIA_NO" && turno.fecha_hora.getDay()==restriccion.dia){
        return false;
      }
      if(restriccion.tipo=="ESCENARIO_NO" && turno.escenario.id==restriccion.id_escenario){
        return false;
      }
      if(restriccion.tipo=="HORA_DESDE"){
        let minuto_turno=turno.fecha_hora.getHours()*60+turno.fecha_hora.getMinutes();
        if(minuto_turno<(restriccion.hora*60+(restriccion.minuto?restriccion.minuto:0))){
          return false;
        }
      }
      if(restriccion.tipo=="HORA_HASTA"){
        //el partido tiene que terminar antes del limite, no solo empezar
        let minuto_fin=turno.fecha_hora.getHours()*60+turno.fecha_hora.getMinutes()+Number(this.matriz_duracion_partido);
        if(minuto_fin>(restriccion.hora*60+(restriccion.minuto?restriccion.minuto:0))){
          return false;
        }
      }
      if(restriccion.tipo=="ESCENARIO_SI"){
        hay_escenario_obligado=true;
        if(turno.escenario.id==restriccion.id_escenario){
          cumple_escenario_obligado=true;
        }
      }
    }
    //si tiene escenarios obligados, el turno debe ser en alguno de ellos
    return hay_escenario_obligado?cumple_escenario_obligado:true;
  }

  /* Turnos libres de la semana: dia + escenario + hora. Salen de la disponibilidad de cada
     escenario, respetando su franja horaria y el tope de partidos por dia. */
  armarTurnosSemana(){
    let turnos=[];
    let duracion=Number(this.matriz_duracion_partido);
    let tope=Number(this.fixture.partidos_por_dia_escenario);
    let inicio_semana=Util.convertirObjetoAfecha(this.fixture.fecha_inicio_texto);
    for(let d=0;d<7;d++){
      let fecha=new Date(inicio_semana.getTime());
      fecha.setDate(fecha.getDate()+d);
      let dia=fecha.getDay();
      if(!this.fixture.dias.some(configuracion => configuracion.dia==dia && configuracion.usar)){
        continue;
      }
      for(let e=0;e<this.fixture.seleccionados.length;e++){
        let escenario=this.fixture.seleccionados[e];
        let disponibilidad=(escenario.disponibilidades||[]).filter(fila => fila.id_dia==dia)[0];
        if(!disponibilidad){
          continue;   //ese escenario no se usa ese dia
        }
        let minuto=disponibilidad.hora_inicio*60+disponibilidad.minuto_inicio;
        let minuto_fin=disponibilidad.hora_fin*60+disponibilidad.minuto_fin;
        let cupo=0;
        while((minuto+duracion)<=minuto_fin && cupo<tope){
          let fecha_hora=new Date(fecha.getTime());
          fecha_hora.setHours(Math.floor(minuto/60));
          fecha_hora.setMinutes(minuto%60);
          turnos.push({ fecha_hora:fecha_hora, escenario:escenario });
          minuto=minuto+duracion;
          cupo++;
        }
      }
    }
    turnos.sort((uno,otro) => uno.fecha_hora.getTime()-otro.fecha_hora.getTime());
    return turnos;
  }

  validarFixture(){
    let res=true;
    if(!this.rol_partido || !this.rol_partido.campeonato){
      this.toastr.error("Debe especificar el campeonato!");
      res=false;
    }
    if(!this.fixture.fecha_inicio_texto || !this.fixture.fecha_inicio_texto.year){
      this.toastr.error("Debe especificar la fecha de inicio de la semana!");
      res=false;
    }
    if(this.fixture.seleccionados.length==0){
      this.toastr.error("Debe seleccionar al menos un escenario con disponibilidad cargada!");
      res=false;
    }
    if(!this.fixture.dias.some(configuracion => configuracion.usar)){
      this.toastr.error("Debe seleccionar al menos un día de la semana!");
      res=false;
    }
    if(!(Number(this.fixture.partidos_por_dia_escenario)>0)){
      this.toastr.error("Los partidos por día y escenario deben ser mayores a cero!");
      res=false;
    }
    if(!(Number(this.fixture.maximo_partidos_equipo_semana)>0)){
      this.toastr.error("El máximo de partidos por equipo debe ser mayor a cero!");
      res=false;
    }
    if(!this.fixture.algoritmo){
      this.toastr.error("Debe especificar el algoritmo de programación!");
      res=false;
    }else if(Number(this.fixture.maximo_partidos_equipo_semana)<Number(this.fixture.algoritmo.partidos_minimos)){
      this.toastr.error("Con "+this.fixture.algoritmo.nombre+" cada equipo juega al menos "+
                        this.fixture.algoritmo.partidos_minimos+" partido(s), así que el máximo no puede ser menor!");
      res=false;
    }
    if(!(Number(this.matriz_duracion_partido)>0)){
      this.toastr.error("La duración del partido debe ser mayor a cero!");
      res=false;
    }
    if(!this.partido.arbitro && (!this.arbitros || this.arbitros.length==0)){
      this.toastr.error("Debe seleccionar un árbitro o tener árbitros registrados!");
      res=false;
    }
    return res;
  }

  async generarFixture(){
    if(!this.validarFixture()){
      return;
    }
    this.blockUI.start('Planificando la semana... espere por favor!');
    let pendientes=await this.obtenerCrucesPendientesCampeonato();
    let turnos=this.armarTurnosSemana();
    this.blockUI.stop();

    if(turnos.length==0){
      this.toastr.error("No hay turnos disponibles: revisá los días marcados y la disponibilidad de los escenarios.");
      return;
    }
    if(pendientes.length==0){
      this.toastr.info("No quedan cruces pendientes en el campeonato.");
      return;
    }

    let algoritmo=this.algoritmoFixture();
    let minimo=Number(algoritmo.partidos_minimos);
    let maximo=Number(this.fixture.maximo_partidos_equipo_semana);
    let partidos_equipo={},equipo_dia={};
    let agregados=0,cruce_anterior=null;
    //la rotacion de arbitros se lleva por disciplina, para que cada una reparta parejo
    this.rotacion_arbitro={};
    this.disciplinas_sin_arbitro={};

    /* Se asigna en dos pasadas. La primera con tope en el minimo que pide el algoritmo: asi los
       turnos alcanzan para que juegue la mayor cantidad posible de equipos, en vez de que unos
       pocos se lleven varios partidos y otros se queden sin jugar. Recien despues, con los turnos
       que hayan sobrado, se agregan los partidos extra, priorizando a los equipos atrasados. */
    let pasadas=[minimo];
    if(maximo>minimo){
      pasadas.push(maximo);
    }
    let turnos_libres=turnos.slice();

    for(let k=0;k<pasadas.length;k++){
      let tope=pasadas[k];
      let sobrantes=[];

      for(let t=0;t<turnos_libres.length;t++){
        let turno=turnos_libres[t];
        let clave_dia=turno.fecha_hora.toDateString();
        /* De los cruces que pueden jugarse en este turno se elige el mejor. La posicion en la lista
           manda (ahi ya vienen agrupados por disciplina y alternando damas/varones), pero se adelanta
           a los equipos atrasados en partidos y a los que comparten club con el partido anterior. */
        let indice=-1,mejor_puntaje=null,mejor_cobertura=null,mejor_disciplina=null;
        for(let p=0;p<pendientes.length;p++){
          let cruce=pendientes[p];
          if((partidos_equipo[cruce.local.id]||0)>=tope || (partidos_equipo[cruce.visitante.id]||0)>=tope){
            continue;
          }
          if(equipo_dia[cruce.local.id+"|"+clave_dia] || equipo_dia[cruce.visitante.id+"|"+clave_dia]){
            continue;
          }
          //restricciones cargadas en cada equipo: dia, escenario y hora
          if(!this.equipoAceptaTurno(cruce.local,turno) || !this.equipoAceptaTurno(cruce.visitante,turno)){
            continue;
          }
          /* Cuantos partidos le faltan a este cruce para que sus dos equipos lleguen al minimo del
             algoritmo. Asi entra primero el que no jugo nada, despues el que jugo uno, etc. */
          let cobertura=Math.max(0,minimo-(partidos_equipo[cruce.local.id]||0))+
                        Math.max(0,minimo-(partidos_equipo[cruce.visitante.id]||0));
          let puntaje=p;
          if(cruce.local.atrasado || cruce.visitante.atrasado){
            puntaje=puntaje-8;   //muy por debajo del resto en partidos jugados
          }
          if(cruce_anterior && this.compartenClub(cruce,cruce_anterior)){
            puntaje=puntaje-4;   //equipos del mismo club, mejor seguidos
          }
          if(algoritmo.peso_mismo_nombre>0 && cruce_anterior){
            //damas y varones, o las categorias de un mismo club, que vienen una sola vez
            puntaje=puntaje-algoritmo.peso_mismo_nombre*this.coincidenciaNombres(cruce,cruce_anterior);
          }
          /* Seguir en la misma disciplina que el partido anterior, para los algoritmos que las
             piden juntas. Va como escalon aparte y no como puntaje porque tiene que ganarle
             siempre a las preferencias de nombre y club, que si no se saltan de disciplina. */
          let sigue_disciplina=(algoritmo.agrupar_disciplina && cruce_anterior &&
                                cruce.disciplina.id==cruce_anterior.disciplina.id)?1:0;

          /* El orden de decision es el de las prioridades del algoritmo: primero la cobertura, para
             que juegue todo el mundo; despues no cambiar de disciplina; y recien ahi el puntaje,
             donde pesan el orden de la lista (jornada, categorias alternadas), los equipos
             atrasados, el club y el mismo nombre. En la primera pasada todos los candidatos tienen
             a sus dos equipos sin jugar, asi que la cobertura no desordena nada. */
          if(mejor_cobertura==null || cobertura>mejor_cobertura ||
             (cobertura==mejor_cobertura && sigue_disciplina>mejor_disciplina) ||
             (cobertura==mejor_cobertura && sigue_disciplina==mejor_disciplina && puntaje<mejor_puntaje)){
            mejor_cobertura=cobertura;
            mejor_disciplina=sigue_disciplina;
            mejor_puntaje=puntaje;
            indice=p;
          }
        }
        if(indice<0){
          sobrantes.push(turno);   //queda libre para la pasada siguiente
          continue;
        }
        let cruce=pendientes.splice(indice,1)[0];
        cruce_anterior=cruce;

        this.rol_partido.partidos.push({
          categoria:cruce.categoria, fase:cruce.fase, disciplina:cruce.disciplina,
          equipo_1:cruce.local, equipo_2:cruce.visitante,
          equipo_1_c:cruce.local, equipo_2_c:cruce.visitante,
          fecha_hora:turno.fecha_hora,
          fecha_hora_texto:Util.convertirFechaAObjectoFecha(turno.fecha_hora),
          hora:{ hour:turno.fecha_hora.getHours(), minute:turno.fecha_hora.getMinutes() },
          escenario:turno.escenario,
          arbitro:this.partido.arbitro?this.partido.arbitro:this.arbitroParaDisciplina(cruce.disciplina,turno.fecha_hora),
          mesa:this.partido.mesa?this.partido.mesa:null,
          w_o_equipo_1:{es_wo:false}, w_o_equipo_2:{es_wo:false}
        });
        partidos_equipo[cruce.local.id]=(partidos_equipo[cruce.local.id]||0)+1;
        partidos_equipo[cruce.visitante.id]=(partidos_equipo[cruce.visitante.id]||0)+1;
        equipo_dia[cruce.local.id+"|"+clave_dia]=true;
        equipo_dia[cruce.visitante.id+"|"+clave_dia]=true;
        agregados++;
      }
      turnos_libres=sobrantes;
    }

    //cuantos equipos llegaron a jugar y cuantos alcanzaron el minimo del algoritmo
    let con_partido=Object.keys(partidos_equipo).length;
    let con_minimo=Object.keys(partidos_equipo).filter(id => partidos_equipo[id]>=minimo).length;
    let con_extra=Object.keys(partidos_equipo).filter(id => partidos_equipo[id]>minimo).length;

    this.refrescarMatrizCruces();
    this.refrescarCalendario();
    this.mostrar_panel_fixture=false;
    if(agregados==0){
      this.toastr.info("No se pudo programar ningún partido con los turnos y topes indicados.");
    }else{
      this.toastr.success("Se programaron "+agregados+" partidos con "+algoritmo.nombre+": "+
                          con_partido+" equipos juegan esta semana"+
                          (minimo>1?(", "+con_minimo+" llegan a los "+minimo+" partidos"):"")+
                          (con_extra>0?(", "+con_extra+" con un partido extra"):"")+". "+
                          "Quedan "+pendientes.length+" cruces pendientes para las próximas semanas.");
    }
    let sin_arbitro=Object.keys(this.disciplinas_sin_arbitro);
    if(sin_arbitro.length>0){
      this.toastr.warning("No hay árbitros registrados para "+sin_arbitro.join(", ")+
                          ": esos partidos se repartieron entre todos. Asignales la disciplina en la pestaña Árbitros.");
    }
  }

  /* Arbitro para un partido: solo los que dirigen esa disciplina, mas los que no tienen ninguna
     asignada, que valen para todas. Dentro de ese grupo se reparte por rotacion, salteando al que
     ya tiene otro partido a la misma hora en otra cancha. */
  arbitroParaDisciplina(disciplina,fecha_hora){
    let id_disciplina=disciplina?disciplina.id:null;
    let grupo=this.arbitros.filter(arbitro => (id_disciplina && arbitro.id_disciplina==id_disciplina) ||
                                              !arbitro.id_disciplina);
    if(grupo.length==0){
      //nadie dirige esa disciplina: se reparte entre todos y se avisa al final
      grupo=this.arbitros;
      this.disciplinas_sin_arbitro[disciplina?disciplina.nombre:"partidos sin disciplina"]=true;
    }
    //cuantos partidos lleva cada uno en la semana y quien ya esta ocupado a esa hora
    let carga={},ocupados={};
    for(let i=0;i<this.rol_partido.partidos.length;i++){
      let partido=this.rol_partido.partidos[i];
      if(!partido.arbitro){
        continue;
      }
      carga[partido.arbitro.id]=(carga[partido.arbitro.id]||0)+1;
      if(partido.fecha_hora && new Date(partido.fecha_hora).getTime()==fecha_hora.getTime()){
        ocupados[partido.arbitro.id]=true;
      }
    }

    /* Se elige al que menos partidos lleva y esta libre a esa hora. Va por carga y no por turno
       redondo porque el arbitro sin disciplina entra en el grupo de todas: rotando por separado
       terminaba dirigiendo el doble que los demas. El desempate arranca donde quedo la rotacion
       de la disciplina, para no cargarle siempre al primero de la lista. */
    let clave=id_disciplina?id_disciplina:0;
    if(this.rotacion_arbitro[clave]==undefined){
      this.rotacion_arbitro[clave]=0;
    }
    let elegido=null,menor=null;
    for(let i=0;i<grupo.length;i++){
      let candidato=grupo[(this.rotacion_arbitro[clave]+i)%grupo.length];
      if(ocupados[candidato.id]){
        continue;
      }
      let suyos=carga[candidato.id]||0;
      if(menor==null || suyos<menor){
        menor=suyos;
        elegido=candidato;
      }
    }
    if(!elegido){
      //todos ocupados a esa hora: se asigna igual, antes que dejar el partido sin arbitro
      elegido=grupo[this.rotacion_arbitro[clave]%grupo.length];
    }
    this.rotacion_arbitro[clave]++;
    return elegido;
  }

  /* ─── Arrastrar y eliminar cruces en la matriz ─────────────────────────────────
     Solo se pueden mover o quitar los partidos de este rol: los que vienen de otros roles del
     campeonato se muestran para no reprogramarlos, pero no se tocan desde aca. */

  puedeMoverCelda(celda){
    return celda.estado!="diagonal" && celda.partido && celda.en_rol_actual && !celda.espejo &&
           !celda.partido.id_venta_equipo_1 && !celda.partido.id_venta_equipo_2 &&
           this.aplicacion.puede_crear;
  }

  iniciarArrastreCelda(evento,celda){
    if(!this.puedeMoverCelda(celda)){
      evento.preventDefault();
      return;
    }
    this.celda_arrastrada=celda;
    evento.dataTransfer.effectAllowed="move";
    //Firefox no dispara el drop si no se setea algo
    evento.dataTransfer.setData("text/plain","celda");
  }

  permitirSoltarCelda(evento,celda){
    if(this.celda_arrastrada && celda.estado=="vacia"){
      evento.preventDefault();
      evento.dataTransfer.dropEffect="move";
    }
  }

  terminarArrastreCelda(){
    this.celda_arrastrada=null;
  }

  /* Mueve el partido al cruce de la celda destino: cambia los equipos y conserva fecha, hora,
     escenario y arbitro. */
  async soltarCelda(celda){
    let origen=this.celda_arrastrada;
    this.celda_arrastrada=null;
    if(!origen || celda.estado!="vacia" || origen==celda){
      return;
    }
    if(celda.equipo_fila.id==celda.equipo_columna.id){
      return;
    }
    let partido=origen.partido;
    let equipo_1_previo=partido.equipo_1,equipo_2_previo=partido.equipo_2;
    partido.equipo_1=celda.equipo_fila;
    partido.equipo_2=celda.equipo_columna;
    partido.equipo_1_c=celda.equipo_fila;
    partido.equipo_2_c=celda.equipo_columna;

    if(await this.validarDuplicidadPartido(partido)){
      //el cruce destino ya existia: se deja el partido como estaba
      partido.equipo_1=equipo_1_previo;
      partido.equipo_2=equipo_2_previo;
      partido.equipo_1_c=equipo_1_previo;
      partido.equipo_2_c=equipo_2_previo;
      return;
    }
    this.refrescarMatrizCruces();
    this.refrescarCalendario();
    this.toastr.success("Partido movido a "+celda.equipo_fila.nombre+" vs "+celda.equipo_columna.nombre);
  }

  quitarCeldaMatriz(evento,celda){
    evento.stopPropagation();
    if(!this.puedeMoverCelda(celda)){
      return;
    }
    this.abrirPopupConfirmacionEliminacionPartido(celda.partido);
  }

  async clickCeldaMatriz(celda){
    if(celda.estado=="diagonal"){
      return;
    }
    if(celda.estado!="vacia"){
      this.toastr.info((celda.espejo?"El cruce inverso ya esta programado: ":"El cruce ya esta programado: ")+
                        celda.equipo_fila.nombre+" vs "+celda.equipo_columna.nombre);
      return;
    }
    if(!this.aplicacion.puede_crear){
      return;
    }
    //el partido se crea con la categoria, disciplina y fase de la pestaña abierta de la matriz
    this.partido.categoria=this.buscarClasePorId(this.tipo_categoria,this.matriz_filtro.categoria.id);
    this.partido.disciplina=this.buscarClasePorId(this.tipo_disciplina,this.matriz_filtro.disciplina.id);
    this.partido.fase=this.matriz_filtro.fase;
    if(!this.partido.categoria || !this.partido.disciplina || !this.partido.fase){
      this.toastr.error("No se pudo determinar la categoria, disciplina o fase de la matriz!");
      return;
    }
    this.partido.equipo_1_c=celda.equipo_fila;
    this.partido.equipo_2_c=celda.equipo_columna;
    //los cruces van a la cancha activa (dia y cancha); sin ella no hay donde ponerlos
    if(!this.cancha_activa){
      this.toastr.info("Elige primero el día y la cancha donde van los partidos: al lado de la matriz o con \"+ siguiente\" en el calendario");
      this.partido.equipo_1_c=null;
      this.partido.equipo_2_c=null;
      return;
    }
    await this.llenarTurnoActivo();
  }

  async validarPartido(partido){
    let res=true;
    if(!partido.disciplina){
			this.toastr.error("Debe especificar la disciplina!");
			res=false;
		}
		if(!partido.equipo_1_c){
			this.toastr.error("Debe especificar el primer equipo!");
			res=false;
		}
    if(!partido.equipo_2_c){
			this.toastr.error("Debe especificar el segundo equipo!");
			res=false;
		}
		if(!partido.fecha_hora_texto || !partido.fecha_hora_texto.year || !partido.fecha_hora_texto.month || !partido.fecha_hora_texto.day){
      res=res && false;
      this.toastr.error("Debe especificar la fecha del partido!");
    }
    if(!partido.hora || (partido.hora.hour==null || partido.hora.hour==undefined) || (partido.hora.minute==null || partido.hora.minute==undefined)){
      res=res && false;
      this.toastr.error("Debe especificar la hora completa del partido!");
    }
    if(!partido.escenario){
			this.toastr.error("Debe especificar el escenario!");
			res=false;
		}
    partido.equipo_1=partido.equipo_1_c;
    partido.equipo_2=partido.equipo_2_c;
    if(await this.validarDuplicidadPartido(partido)){
      res=false;
    }
		return res;
  }

  validarRolPartido(){
    let res=true;
		if(!this.rol_partido.campeonato){
			this.toastr.error("Debe especificar el campeonato!");
			res=false;
		}
    if(!this.rol_partido.rol){
			this.toastr.error("Debe especificar el rol!");
			res=false;
		}
    if(this.rol_partido.partidos.length==0){
			this.toastr.error("Debe agregar al menos un partido!");
			res=false;
		}
		return res;
  }

  guardarRolPartido(){
    if(this.validarRolPartido()){
      this.blockUI.start();
      if(this.rol_partido.id){
        this.rolesPartidosService.actualizarRolPartido(this.rol_partido).subscribe((res:any)=>{
          this.blockUI.stop();
          this.modal_registro_rol_partido.close();
          this.toastr.success(res.mensaje);
          this.getItems();
        });
      }else{
        this.rolesPartidosService.guardarRolPartido(this.rol_partido).subscribe((res:any)=>{
          this.actualizarUltimoCodigo(GlobalVariable.Dictionary.TIPO_CORRELATIVO_CODIGO_ROL_PARTIDO);
          this.blockUI.stop();
          this.modal_registro_rol_partido.close();
          this.toastr.success(res.mensaje);
          this.getItems();
        });
      }
    }
  }

  async generarPdfPlanillaPartidoBlanco(disciplina){
    let rol_partido_fuente={
      rol:{nombre:""},
      campeonato:{nombre:""},
      partidos:[{fecha_hora:new Date(),equipo_1:{nombre:"",cliente:{},jugadores:[]},equipo_2:{nombre:"",cliente:{},jugadores:[]},escenario:{nombre:""},disciplina:{nombre:disciplina},categoria:{nombre:""},activo:true}]
    }
    this.generarPdfPlanillasPartidos(rol_partido_fuente);
  }

  async generarPdfPlanillasPartidos(rol_partido_fuente){
    this.blockUI.start();
    let rol_partido;
    if(!rol_partido_fuente.partidos || rol_partido_fuente.partidos.length==0){
      rol_partido=await this.rolesPartidosService.obtenerRolPartido(rol_partido_fuente.id).toPromise();
      //el campeonato vuelve del servidor sin normalizar, hay que completarle la configuracion otra vez
      this.asegurarConfiguracionPdfRolPartido(rol_partido.campeonato);
    }else{
      rol_partido=Object.assign({} ,rol_partido_fuente);
    }
    if(rol_partido.partidos.filter(p => p.activo && p.selected).length>0){
      rol_partido.partidos=rol_partido.partidos.filter(p => p.activo && p.selected);
    }else{
      rol_partido.partidos=rol_partido.partidos.filter(p => p.activo);
    }

    let tamano_papel,numero_jugadores,distancia_equipos;
    if(this.configuracion_pagina.getOrden().impresion.papel_planilla_partido==GlobalVariable.Dictionary.PAPEL_CARTA){
      tamano_papel=GlobalVariable.Dictionary.PAPEL_OFICIO_MEDIDA;
      numero_jugadores=13;
      distancia_equipos=283;
    }else if(this.configuracion_pagina.getOrden().impresion.papel_planilla_partido==GlobalVariable.Dictionary.PAPEL_OFICIO){
      tamano_papel=GlobalVariable.Dictionary.PAPEL_OFICIO_MEDIDA;
      numero_jugadores=18;
      distancia_equipos=360;
    }else{
      tamano_papel=GlobalVariable.Dictionary.PAPEL_CARTA_MEDIDA;
      numero_jugadores=13;
      distancia_equipos=283;
    }

    var doc = new PDFDocument({size: tamano_papel,margin:10});
    var stream = doc.pipe(blobStream());
    for(let i=0;i<rol_partido.partidos.length;i++){
      if(rol_partido.partidos[i].id){
        rol_partido.partidos[i]=await this.rolesPartidosService.obtenerPartido(rol_partido.partidos[i].id).toPromise();
      }
      await this.generarPdfPlanillaPartido(rol_partido,rol_partido.partidos[i],doc,tamano_papel,numero_jugadores,distancia_equipos);
      if(i+1<rol_partido.partidos.length){
        doc.addPage({size:tamano_papel,margin:10});
      }
    }
    doc.end();
    this.blockUI.stop();
    stream.on('finish', function() {
      var fileURL = stream.toBlobURL('application/pdf');
      window.open(fileURL,'_blank','location=no');
    });
  }

  async generarPdfPlanillaPartido(rol_partido,partido,doc_f,tamano_papel,numero_jugadores,distancia_equipos){
      var doc = doc_f?doc_f:new PDFDocument({size: tamano_papel,margin:10});
      var stream = doc.pipe(blobStream());
      doc.roundedRect(50,20,540,(numero_jugadores==13?750:894),5).stroke();
      if (this.usuario.empresa.imagen.length > 100) { doc.image(this.usuario.empresa.imagen,60,25, { width: 50, height: 50,align:'left' }); }
      doc.font('Helvetica-Bold',20);
      doc.text(rol_partido.campeonato.nombre.toUpperCase(),0,30,{align:"center"});
      doc.font('Helvetica',10);
      doc.text(rol_partido.rol.nombre,0,50,{align:"center"});
      doc.text(partido.categoria.nombre+" - "+partido.disciplina.nombre,0,65,{align:"center"});
      if(rol_partido.campeonato.logo){
        let logo=await Util.convertirUrlToBase64Image(this.rest_server+rol_partido.campeonato.logo);
        doc.image(logo,530,25, { width: 50, height: 50,align:'right' });
      }
      doc.rect(50,80,540,0).stroke();
      doc.font('Helvetica-Bold',10);
      doc.text("CANCHA:",60,82);
      doc.text("FECHA:",330,82);
      doc.text("HORA:",430,82);
      doc.font('Helvetica',10);
      doc.text(partido.escenario.nombre,110,82);
      let fecha_hora=new Date(partido.fecha_hora);
      doc.text((fecha_hora.getDate()+"/"+(fecha_hora.getMonth()+1)+"/"+fecha_hora.getFullYear()),370,82);
      doc.text(fecha_hora.getHours()+":"+fecha_hora.getMinutes(),465,82);

      if(partido.disciplina.nombre=="FÚTBOL DE SALÓN"){
        await this.generarPlanillaEquipo(doc,rol_partido,partido,partido.equipo_1,100,145,numero_jugadores);
      }else if(partido.disciplina.nombre=="BALONCESTO"){
        doc.rect(50,92,540,0).stroke();
        await this.generarPlanillaEquipoBaloncesto(doc,partido.equipo_1,100,145,numero_jugadores);
      }else if(partido.disciplina.nombre=="VOLEIBOL"){
        doc.rect(50,92,540,0).stroke();
        await this.generarPlanillaEquipoVoleibol(doc,rol_partido,partido,partido.equipo_1,100,145,numero_jugadores);
      }

      if(partido.disciplina.nombre=="FÚTBOL DE SALÓN"){
        await this.generarPlanillaEquipo(doc,rol_partido,partido,partido.equipo_2,100+distancia_equipos,100+distancia_equipos+45,numero_jugadores);
      }else if(partido.disciplina.nombre=="BALONCESTO"){
        doc.rect(50,100+distancia_equipos-8,282,0).stroke();//mitad hoja
        await this.generarPlanillaEquipoBaloncesto(doc,partido.equipo_2,100+distancia_equipos+2,100+distancia_equipos+47,numero_jugadores);
      }else if(partido.disciplina.nombre=="VOLEIBOL"){
        doc.rect(50,100+distancia_equipos-8,540,0).stroke();//mitad hoja
        await this.generarPlanillaEquipoVoleibol(doc,rol_partido,partido,partido.equipo_2,100+distancia_equipos,100+distancia_equipos+45,numero_jugadores);
      }

      if(partido.disciplina.nombre=="BALONCESTO"){
        doc.font('Helvetica',7);
        let y_canastas=115,canastas=1,numero_canastas=37;
        for(let i=0;i<numero_canastas;i++){
          doc.text(canastas,347,y_canastas-3);
          doc.text(canastas,350,y_canastas+4);
          doc.rect(332,y_canastas-5,15,15).stroke();
          doc.rect(347,y_canastas-5,11,15).stroke();
          doc.rect(358,y_canastas-5,15,15).stroke();
          y_canastas=y_canastas+15;
          canastas=canastas+1;
        }
        y_canastas=115;
        for(let i=0;i<numero_canastas;i++){
          doc.text(canastas,388,y_canastas-3);
          doc.text(canastas,391,y_canastas+4);
          doc.rect(373,y_canastas-5,15,15).stroke();
          doc.rect(388,y_canastas-5,11,15).stroke();
          doc.rect(399,y_canastas-5,15,15).stroke();
          y_canastas=y_canastas+15;
          canastas=canastas+1;
        }
      }

      doc.font('Helvetica',10);
      doc.rect(50,(numero_jugadores==13?665:809),540,0).stroke();
      doc.text("OBSERVACIONES:",60,(numero_jugadores==13?668:812));
      doc.text("FIRMA DEL PLANILLERO                          FIRMA DEL JUEZ",0,(numero_jugadores==13?760:904),{align:"center"});

      await this.dibujarRecibosPlanilla(doc,rol_partido,partido,partido.equipo_1,306,false);
      await this.dibujarRecibosPlanilla(doc,rol_partido,partido,partido.equipo_1,376,true);
      await this.dibujarRecibosPlanilla(doc,rol_partido,partido,partido.equipo_2,446,false);
      await this.dibujarRecibosPlanilla(doc,rol_partido,partido,partido.equipo_2,516,true);
      
      if(!doc_f){
        doc.end();
        stream.on('finish', function() {
          var fileURL = stream.toBlobURL('application/pdf');
          window.open(fileURL,'_blank','location=no');
        });
      }
  }

  async dibujarRecibosPlanilla(doc,rol_partido,partido,equipo,x_inicial,es_copia){
    let x=x_inicial+5,y=780;//841
    doc.rect(x,y+45,70,0).dash(5, { space: 5 }).stroke();
    doc.font('Helvetica',5);
    doc.text(rol_partido.campeonato.nombre.toUpperCase(),x,y+2,{align:"left",width:70});
    doc.text(rol_partido.rol.nombre,x,y+15,{align:"left",width:70});
    doc.text(partido.categoria.nombre+" - "+partido.disciplina.nombre,x,y+21,{align:"left",width:70});
    let fecha_hora=new Date(partido.fecha_hora);
    doc.text("FECHA: "+(fecha_hora.getDate()+"/"+(fecha_hora.getMonth()+1)+"/"+fecha_hora.getFullYear())+" "+(fecha_hora.getHours()+":"+fecha_hora.getMinutes()),x,y+27);
    doc.text("RECIBO Nº "+rol_partido.codigo,x,y+33,{align:"left",width:70});
    doc.text(equipo.nombre,x,y+39,{align:"left",width:70});

    if(es_copia){
      doc.font('Helvetica',7);
      doc.text("- DER. CANCHA",x,y+50,{align:"left",width:70});
      doc.rect(x+54,y+50,12,8).dash(0, { space: 0 }).stroke();
      doc.text("- T. AMARILLAS",x,y+58,{align:"left",width:70});
      doc.rect(x+54,y+58,12,8).stroke();
      doc.text("- T. ROJAS",x,y+66,{align:"left",width:70});
      doc.rect(x+54,y+66,12,8).stroke();
      doc.text("- SIN CINTILLO",x,y+74,{align:"left",width:70});
      doc.rect(x+54,y+74,12,8).stroke();
      doc.text("- SIN PELOTA",x,y+82,{align:"left",width:70});
      doc.rect(x+54,y+82,12,8).stroke();
      doc.text("- PONCHILLOS",x,y+90,{align:"left",width:70});
      doc.rect(x+54,y+90,12,8).stroke();
      doc.text("- OTROS",x,y+98,{align:"left",width:70});
      doc.rect(x+54,y+98,12,8).stroke();
      doc.roundedRect(x+54,y+108,12,12,1).stroke();
      doc.text("Total",x,y+122,{align:"right",width:68});

      doc.text("--------------------",x,y+117,{align:"left",width:70});
      doc.text("Oficial de Mesa",x,y+122,{align:"left",width:70});
    }else{
      doc.font('Helvetica',10);
      doc.roundedRect(x+15,y+60,40,20,1).stroke();
      doc.text("Total BS",x,y+82,{align:"center",width:68});
      doc.font('Helvetica',7);
      doc.text("------------------------",x,y+117,{align:"center",width:70});
      doc.text("Delegado Equipo",x,y+122,{align:"center",width:70});
    }

    doc.roundedRect(310,y,280,130,5).dash(0, { space: 0 }).stroke();
    doc.rect(380,y,0,130).dash(5, { space: 10 }).stroke();
    doc.rect(450,y,0,130).dash(5, { space: 10 }).stroke();
    doc.rect(520,y,0,130).dash(5, { space: 10 }).stroke();
  }

  /* Nombre del jugador en la planilla. Si debe (tarjetas o su parte de deudas del club, en cualquier club o campeonato;
     el servidor lo marca en jugador.deuda_total al traer el partido) va en rojo con una etiqueta "Bs X" al final de la
     columna del nombre (termina en x=298 en las tres planillas), antes de las tarjetas pendientes que se marcan en x=292 */
  dibujarNombreJugadorPlanilla(doc,jugador,x,y){
    let nombre=jugador.persona.nombre_completo.toUpperCase();
    if(!(jugador.deuda_total>0)){
      doc.text(nombre,x,y);
      return;
    }
    let fuente=doc._font.name,tamano=doc._fontSize;
    let monto="Bs "+(jugador.deuda_total%1==0?jugador.deuda_total.toFixed(0):jugador.deuda_total.toFixed(2));
    doc.font('Helvetica-Bold',6);
    let ancho_monto=doc.widthOfString(monto)+4;
    doc.rect(290-ancho_monto,y-1,ancho_monto,8).fill("red");
    doc.fillColor("white").text(monto,292-ancho_monto,y+0.5,{lineBreak:false});
    doc.font(fuente,tamano).fillColor("#b00000");
    doc.text(nombre,x,y,{width:290-ancho_monto-x-2,height:tamano+1,ellipsis:true});
    doc.fillColor("black");
  }

  async generarPlanillaEquipo(doc,rol_partido,partido,equipo,y_inicio,y_jugador,numero_jugadores){
    let detalles_ventas_pendientes:any=await this.rolesPartidosService.obtenerDetallesVentaPendientes(equipo.cliente.id).toPromise();
    doc.font('Helvetica-Bold',10);
    doc.rect(50,y_inicio-8,540,0).stroke();//mitad hoja
    doc.text("EQUIPO:",55,y_inicio-5);
    doc.text("CODIGO:",55,y_inicio+4);
    doc.font('Helvetica',10);
    doc.text(equipo.nombre,100,y_inicio-5);
    doc.text(equipo.codigo,100,y_inicio+4);
    doc.text("¿Trajo Balon?:",55,y_inicio+14);
    doc.rect(130,y_inicio+13,18,11).stroke();
    doc.text("¿Trajo Cintillo?:",155,y_inicio+14);
    doc.rect(235,y_inicio+13,18,11).stroke();
    if(equipo.logo){
      let logo=await Util.convertirUrlToBase64Image(this.rest_server+equipo.logo);
      doc.image(logo,270,y_inicio-10, { width: 25, height: 25,align:'right' });
    }
    doc.font('Helvetica-Bold',10);
    doc.text("Marcador Final",300,y_inicio-6,{width:'100'});
    doc.rect(320,y_inicio+3,40,20).stroke();
    doc.text("FALTAS",403,y_inicio,{width:'100'});
    doc.text("1º tiempo",445,y_inicio-6);
    doc.rect(445,y_inicio-8,145,12).stroke();
    doc.rect(490,y_inicio-8,0,24).stroke();
    doc.rect(510,y_inicio-8,0,24).stroke();
    doc.rect(530,y_inicio-8,0,24).stroke();
    doc.rect(550,y_inicio-8,0,24).stroke();
    doc.rect(570,y_inicio-8,0,24).stroke();
    doc.rect(590,y_inicio-8,0,24).stroke();
    doc.text("2º tiempo",445,y_inicio+6);
    doc.rect(445,y_inicio+4,145,12).stroke();
    //doc.rect(50,y_inicio+40,540,0).stroke();
    doc.rect(50,y_inicio+25,540,15).stroke();
    doc.font('Helvetica-Bold',7);
    doc.text("COD",51,y_inicio+30);
    doc.font('Helvetica-Bold',10);
    doc.rect(71,y_inicio+25,0,(numero_jugadores*15)).stroke();
    doc.text("JUGADOR",120,y_inicio+30);
    doc.rect(298,y_inicio+25,0,(numero_jugadores*15)).stroke();
    doc.text("Nº",300,y_inicio+30);
    doc.rect(320,y_inicio+25,0,(numero_jugadores*15)).stroke();

    doc.font('Helvetica-Bold',7);
    //doc.rotate(-90, { origin: [240,120] });
    //doc.text("GOLES", ((y_inicio==100)?220:(numero_jugadores==13?-62:-140)),225);
    //doc.text("Total Goles", ((y_inicio==100)?220:(numero_jugadores==13?-62:-140)),202,{width:25});
    //doc.rotate(90 , { origin: [240,120] });
    doc.text("Goles",320,y_inicio+30);
    doc.text("Total", 341,y_inicio+27);
    doc.text("Goles", 341,y_inicio+34);
    doc.rect(341,y_inicio+25,0,(numero_jugadores*15)).stroke();

    doc.font('Helvetica-Bold',10);
    //doc.text("GOLES",322,y_inicio+30);
    doc.rect(362,y_inicio+25,0,(numero_jugadores*15)).stroke();
    doc.rect(363, y_inicio+26,25,14).fill("yellow").stroke();
    doc.rect(389, y_inicio+26,25,14).fill("red").stroke();
    doc.fillColor("black");
    doc.font('Helvetica-Bold',7);
    doc.text("Tarjeta",363,y_inicio+27);
    doc.text("Amarilla",361,y_inicio+34);
    doc.fillColor("white");
    doc.text("Tarjeta",390,y_inicio+27);
    doc.text("Roja",394,y_inicio+34);
    doc.fillColor("black");
    doc.font('Helvetica-Bold',10);
    doc.rect(388,y_inicio+25,0,(numero_jugadores*15)).stroke();
    doc.rect(414,y_inicio+25,0,(numero_jugadores*15)).stroke();
    doc.text("DERECHO CANCHA (Bs):",430,y_inicio+17);
    doc.fillColor("red");
    doc.text(((Util.obtenerProductoArbitraje(rol_partido.campeonato,partido)?Util.obtenerProductoArbitraje(rol_partido.campeonato,partido).precio_unitario:0)+partido.escenario.importe_partido/2),560,y_inicio+17,{width:142});
    doc.fillColor("#000000");
    doc.text("MARCADOR",470,y_inicio+30);

    doc.font('Helvetica',9);
    let goles=1;
    equipo.jugadores=equipo.jugadores.filter(jug => jug.activo);
    equipo.jugadores=this.orderPipe.transform(equipo.jugadores, 'jugador.persona.nombre_completo',false);
    for(let i=0;i<equipo.jugadores.length || i<numero_jugadores;i++){
      doc.rect(50,y_jugador+10,365,0).stroke();
      //doc.text(i+1,55,y_jugador);
      if(equipo.jugadores[i]){
        doc.font('Helvetica',7);
        if(equipo.jugadores[i].jugador.persona.ci=="0"){
          doc.fillColor("red");
        }
        doc.text(equipo.jugadores[i].jugador.codigo.toUpperCase(),51,y_jugador);
        doc.fillColor("black");
        doc.font('Helvetica',9);
        this.dibujarNombreJugadorPlanilla(doc,equipo.jugadores[i].jugador,72,y_jugador);

        let tarjetas_amarillas=detalles_ventas_pendientes.filter(p => p.producto.nombre.includes("TARJETA AMARILLA"));
        let tarjetas_amarillas_jugador=tarjetas_amarillas.filter(p => p.descripcion.includes(equipo.jugadores[i].jugador.persona.nombre_completo));
        let tarjetas_rojas=detalles_ventas_pendientes.filter(p => p.producto.nombre.includes("TARJETA ROJA"));
        let tarjetas_rojas_jugador=tarjetas_rojas.filter(p => p.descripcion.includes(equipo.jugadores[i].jugador.persona.nombre_completo));
        if(tarjetas_amarillas_jugador.length>0){
          doc.rect(292,y_jugador-5,7,7).fill("yellow").stroke();
          doc.fillColor("black");
          doc.text(tarjetas_amarillas_jugador.length,292,y_jugador-5);
        }
        if(tarjetas_rojas_jugador.length>0){
          doc.rect(292,y_jugador+2,7,7).fill("red").stroke();
          doc.fillColor("black");
          doc.text(tarjetas_rojas_jugador.length,292,y_jugador+2);
        }
        
      }

      let x_goles=414;

      if(i%2==0 && goles<21){
        doc.rect(x_goles,y_jugador-5,25,15).stroke();
        doc.rect(x_goles,y_jugador+10,25,15).stroke();
        doc.rect(x_goles+25,y_jugador-5,25,15).stroke();
        doc.rect(x_goles+25,y_jugador+10,25,15).stroke();
        doc.rect(x_goles+50,y_jugador-5,25,15).stroke();
        doc.rect(x_goles+50,y_jugador+10,25,15).stroke();
        doc.rect(x_goles+75,y_jugador-5,25,15).stroke();
        doc.rect(x_goles+75,y_jugador+10,25,15).stroke();
        doc.rect(x_goles+100,y_jugador-5,25,15).stroke();
        doc.rect(x_goles+100,y_jugador+10,25,15).stroke();
        doc.rect(x_goles+125,y_jugador-5,25,15).stroke();
        doc.rect(x_goles+125,y_jugador+10,25,15).stroke();
        doc.rect(x_goles+150,y_jugador-5,26,15).stroke();
        doc.rect(x_goles+150,y_jugador+10,26,15).stroke();
        //doc.rect(x_goles+175,y_jugador-5,25,15).stroke();


        doc.text(goles,425,y_jugador);
        doc.text(goles+1,450,y_jugador);
        doc.text(goles+2,475,y_jugador);
        doc.text(goles+3,500,y_jugador);
        doc.text(goles+4,525,y_jugador);
        doc.text(goles+5,550,y_jugador);
        doc.text(goles+6,575,y_jugador);
        goles=goles+7;

        doc.rect(x_goles+25,y_jugador-5,0,15).stroke();
        doc.rect(x_goles+75,y_jugador-5,0,15).stroke();
        doc.rect(x_goles+125,y_jugador-5,0,15).stroke();
      }

      y_jugador=y_jugador+15;
    }
    let y_detalle_venta=y_inicio+150;
    doc.font('Helvetica-Bold',7);
    doc.text("PENDIENTES ECONOMICOS",417,y_detalle_venta-16);
    doc.font('Helvetica',7);
    let suma_saldo=0;
    for(let i=0;i<detalles_ventas_pendientes.length;i++){
      let fecha_venta=new Date(detalles_ventas_pendientes[i].venta.fecha);
      let texto_economico="Bs "+detalles_ventas_pendientes[i].venta.saldo.toFixed(2);
      let texto=(fecha_venta.getDate()+"/"+(fecha_venta.getMonth()+1)+"/"+fecha_venta.getFullYear());
      if(detalles_ventas_pendientes[i].producto.nombre.includes("TARJETA AMARILLA")){
        doc.rect(448,y_detalle_venta-6,7,7).fill("yellow").stroke();
        texto=texto+(detalles_ventas_pendientes[i].descripcion?" "+detalles_ventas_pendientes[i].descripcion:"");
        texto=texto.substring(0,33);
      }else if(detalles_ventas_pendientes[i].producto.nombre.includes("TARJETA ROJA")){
        doc.rect(448,y_detalle_venta-6,7,7).fill("red").stroke();
        texto=texto+(detalles_ventas_pendientes[i].descripcion?" "+detalles_ventas_pendientes[i].descripcion:"");
        texto=texto.substring(0,33);
      }else{
        texto=texto+" "+detalles_ventas_pendientes[i].producto.nombre;
        texto=texto+(detalles_ventas_pendientes[i].descripcion?" "+detalles_ventas_pendientes[i].descripcion:"");
      }
      doc.fillColor("red");
      doc.font('Helvetica-Bold',7);
      doc.text(texto_economico,417,y_detalle_venta-5,{width:142});
      doc.fillColor("#000000");
      doc.font('Helvetica',7);
      doc.text(texto,450,y_detalle_venta-5,{width:142});
      doc.rect(415,y_detalle_venta-7,175,0).stroke();
      y_detalle_venta=y_detalle_venta+(texto.length>34?16:9);
      suma_saldo=suma_saldo+detalles_ventas_pendientes[i].venta.saldo;
    }
    doc.fillColor("red");
    doc.font('Helvetica-Bold',7);
    doc.text("Total: Bs "+suma_saldo.toFixed(2),530,y_inicio+134);
    doc.font('Helvetica',10);
    doc.fillColor("#000000");
    doc.text("DIRECTOR TÉCNICO:",60,y_jugador);
    doc.text("CAPITÁN:",330,y_jugador);
    //doc.rect(410,y_jugador-5,180,0).stroke();
  }

  async generarPlanillaEquipoBaloncesto(doc,equipo,y_inicio,y_jugador,numero_jugadores){
    doc.font('Helvetica-Bold',10);
    doc.text("EQUIPO:",60,y_inicio);
    doc.font('Helvetica-Bold',6);
    let logo;
    if(equipo.logo){
      logo=await Util.convertirUrlToBase64Image(this.rest_server+equipo.logo);
      doc.image(logo,270,y_inicio-10, { width: 25, height: 25,align:'right' });
    }
    if(y_inicio==100){
      if(equipo.logo){
        doc.image(logo,335,y_inicio-6, { width: 10, height: 10,align:'right' });
        doc.image(logo,376,y_inicio-6, { width: 10, height: 10,align:'right' });
      }
      doc.rotate(-90 , { origin: [240,120] });
      doc.text("FALTAS",220,204);
      doc.rotate(90, { origin: [240,120] });
    }else{
      if(equipo.logo){
        doc.image(logo,361,94, { width: 10, height: 10,align:'right' });
        doc.image(logo,402,94, { width: 10, height: 10,align:'right' });
      }
      doc.rotate(-90 , { origin: [240,120] });
      doc.text("FALTAS",(numero_jugadores==13?-65:-140),204);
      doc.rotate(90, { origin: [240,120] });
    }
    
    //doc.rect(383,y_inicio+4,177,12).stroke();
    doc.font('Helvetica',10);
    doc.text(equipo.nombre,110,y_inicio);

    doc.rect(50,y_inicio+16,282,0).stroke();
    doc.font('Helvetica-Bold',10);
    doc.text("Nº",55,y_inicio+30);
    doc.text("JUGADOR",70,y_inicio+30);
    doc.rect(298,y_inicio-8,0,48+(numero_jugadores*15)).stroke();
    doc.text("Nº",300,y_inicio+30);
    doc.rect(320,y_inicio+16,0,24+(numero_jugadores*15)).stroke();
    
    doc.fillColor("black");

    doc.text("Con Balon",486,y_inicio-6);
    doc.text("SI",542,y_inicio-6);
    doc.roundedRect(552,y_inicio-7,10,10,5).stroke();
    doc.text("NO",563,y_inicio-6);
    doc.roundedRect(579,y_inicio-7,10,10,5).stroke();
    doc.text("Con Cintillo",486,y_inicio+6);
    doc.text("SI",542,y_inicio+6);
    doc.roundedRect(552,y_inicio+5,10,10,5).stroke();
    doc.text("NO",563,y_inicio+6);
    doc.roundedRect(579,y_inicio+5,10,10,5).stroke();
    
    doc.rect(414,y_inicio+16,0,219).stroke();
    doc.text("DERECHO CANCHA (Bs): .......",430,y_inicio+19);
    
    doc.font('Helvetica',10);
    doc.text("Falta por equipo",430,y_inicio+70,{width:40});
    let x_f=480,y_f=y_jugador+5;
    for(let i=0;i<4;i++){
      doc.text(i+1,x_f-8,y_f+4);
      for(let j=0;j<4;j++){
        doc.rect(x_f,y_f,15,15).stroke();
        doc.text(j+1,x_f+4,y_f+4);
        x_f=x_f+15;
      } 
      x_f=480;
      y_f=y_f+15;
    }

    doc.rect(50,y_jugador+10-15,300,0).stroke();
    let goles=1;
    equipo.jugadores=equipo.jugadores.filter(jug => jug.activo);
    equipo.jugadores=this.orderPipe.transform(equipo.jugadores, 'jugador.persona.nombre_completo',false);
    for(let i=0;i<equipo.jugadores.length || i<numero_jugadores;i++){
      doc.rect(50,y_jugador+10,300,0).stroke();
      doc.text(i+1,55,y_jugador);
      if(equipo.jugadores[i]){
        this.dibujarNombreJugadorPlanilla(doc,equipo.jugadores[i].jugador,70,y_jugador);
      }
      y_jugador=y_jugador+15;
    }
    let detalles_ventas_pendientes:any=await this.rolesPartidosService.obtenerDetallesVentaPendientes(equipo.cliente.id).toPromise();
    let y_detalle_venta=y_inicio+150;
    doc.font('Helvetica-Bold',7);
    doc.text("PENDIENTES ECONOMICOS",417,y_detalle_venta-16);
    doc.font('Helvetica',7);
    let suma_saldo=0;
    for(let i=0;i<detalles_ventas_pendientes.length;i++){
      let fecha_venta=new Date(detalles_ventas_pendientes[i].venta.fecha);
      let texto_economico="Bs "+detalles_ventas_pendientes[i].venta.saldo.toFixed(2);
      let texto=(fecha_venta.getDate()+"/"+(fecha_venta.getMonth()+1)+"/"+fecha_venta.getFullYear())+" "+detalles_ventas_pendientes[i].producto.nombre+(detalles_ventas_pendientes[i].descripcion?" "+detalles_ventas_pendientes[i].descripcion:"");
      doc.fillColor("red");
      doc.font('Helvetica-Bold',7);
      doc.text(texto_economico,417,y_detalle_venta-5,{width:142});
      doc.fillColor("#000000");
      doc.font('Helvetica',7);
      doc.text(texto,450,y_detalle_venta-5,{width:142});
      doc.rect(415,y_detalle_venta-7,175,0).stroke();
      y_detalle_venta=y_detalle_venta+16;
      suma_saldo=suma_saldo+detalles_ventas_pendientes[i].venta.saldo;
    }
    doc.fillColor("red");
    doc.font('Helvetica-Bold',7);
    doc.text("Total: Bs "+suma_saldo.toFixed(2),530,y_inicio+134);
    doc.font('Helvetica',10);
    doc.fillColor("#000000");
    doc.text("DIRECTOR TÉCNICO:",60,y_jugador);
    doc.text("CAPITÁN:",60,y_jugador+25);
    doc.rect(50,y_jugador-5,540,0).stroke();
  }

  async generarPlanillaEquipoVoleibol(doc,rol_partido,partido,equipo,y_inicio,y_jugador,numero_jugadores){
    let detalles_ventas_pendientes:any=await this.rolesPartidosService.obtenerDetallesVentaPendientes(equipo.cliente.id).toPromise();
    doc.font('Helvetica-Bold',10);
    doc.rect(50,y_inicio-8,270,0).stroke();//mitad hoja
    doc.text("EQUIPO:",55,y_inicio-5);
    doc.text("CODIGO:",55,y_inicio+4);
    doc.font('Helvetica',10);
    doc.text(equipo.nombre,100,y_inicio-5);
    doc.text(equipo.codigo,100,y_inicio+4);
    doc.text("¿Trajo Balon?:",55,y_inicio+14);
    doc.rect(130,y_inicio+13,18,11).stroke();
    doc.text("¿Trajo Cintillo?:",155,y_inicio+14);
    doc.rect(235,y_inicio+13,18,11).stroke();
    if(equipo.logo){
      let logo=await Util.convertirUrlToBase64Image(this.rest_server+equipo.logo);
      doc.image(logo,270,y_inicio-10, { width: 25, height: 25,align:'right' });
    }

    doc.rect(50,y_inicio+25,270,15).stroke();
    doc.font('Helvetica-Bold',7);
    doc.text("COD",51,y_inicio+30);
    doc.font('Helvetica-Bold',10);
    doc.rect(71,y_inicio+25,0,(numero_jugadores*15)).stroke();
    doc.text("JUGADOR",120,y_inicio+30);
    doc.rect(298,y_inicio+25,0,(numero_jugadores*15)).stroke();
    doc.text("Nº",300,y_inicio+30);
    doc.rect(320,y_inicio+25,0,(numero_jugadores*15)).stroke();
    
    doc.fillColor("black");

    /*doc.text("Con Balon",486,y_inicio-6);
    doc.text("SI",542,y_inicio-6);
    doc.roundedRect(552,y_inicio-7,10,10,5).stroke();
    doc.text("NO",563,y_inicio-6);
    doc.roundedRect(579,y_inicio-7,10,10,5).stroke();
    doc.text("Con Cintillo",486,y_inicio+6);
    doc.text("SI",542,y_inicio+6);
    doc.roundedRect(552,y_inicio+5,10,10,5).stroke();
    doc.text("NO",563,y_inicio+6);
    doc.roundedRect(579,y_inicio+5,10,10,5).stroke();*/
    
    doc.rect(414,y_inicio+130,0,105).stroke();
    doc.text("DERECHO CANCHA (Bs):",430,y_inicio);
    doc.fillColor("red");
    doc.text(((Util.obtenerProductoArbitraje(rol_partido.campeonato,partido)?Util.obtenerProductoArbitraje(rol_partido.campeonato,partido).precio_unitario:0)+partido.escenario.importe_partido/2),560,y_inicio,{width:142});
    doc.font('Helvetica',10);

    let y_canastas,canastas,numero_sets=3,x_set=455;
    for(let j=0;j<numero_sets;j++){
      y_canastas=y_inicio+15,canastas=1;
      doc.fillColor("red");
      doc.text(j+1,x_set-6,y_canastas+55);
      doc.fillColor("#000000");
      doc.rect(x_set,y_canastas-5,39,120).stroke();
      doc.rect(x_set+13,y_canastas-5,0,120).stroke();
      doc.rect(x_set+26,y_canastas-5,0,120).stroke();
      for(let i=0;i<10;i++){
        doc.text(canastas,x_set,y_canastas-3,{width:13,align:'center'});
        doc.text(canastas+10,x_set+13,y_canastas-3,{width:13,align:'center'});
        doc.text(canastas+20,x_set+26,y_canastas-3,{width:13,align:'center'});
        /*doc.rect(x_set,y_canastas-5,13,12).stroke();
        doc.rect(x_set+13,y_canastas-5,13,12).stroke();
        doc.rect(x_set+26,y_canastas-5,13,12).stroke();*/
        y_canastas=y_canastas+12;
        canastas=canastas+1;
      }
      x_set=x_set+46;
    }

    let x_f=325,y_f=y_inicio+10;
    for(let i=0;i<6;i++){
      for(let j=0;j<6;j++){
        if(i%2==0){
          doc.text(Util.convertirNumeroRomano(j+1),x_f+1,y_f+1);
        }
        doc.rect(x_f,y_f,20,20).stroke();
        if(i%2!=0){
          doc.rect(x_f,y_f,10,10).stroke();
          doc.rect(x_f+10,y_f+10,10,10).stroke();
        }
        //doc.text(j+1,x_f+4,y_f+4);
        x_f=x_f+20;
      } 
      x_f=325;
      y_f=y_f+20;
    }

    x_f=325,y_f=y_inicio+170;
    doc.text("RESULTADO",325,y_f-20);
    doc.text("SET",325,y_f-10);
    doc.text("PTS.",365,y_f-10);
    doc.rect(x_f+40,y_f,40,60).stroke();
    for(let i=0;i<3;i++){
      doc.text(i+1,x_f,y_f+5,{align:"center",width:20});
      for(let j=0;j<2;j++){
        doc.rect(x_f,y_f,20,20).stroke();
        x_f=x_f+20;
      } 
      x_f=325;
      y_f=y_f+20;
    }

    doc.rect(50,y_inicio+40,270,0).stroke();
    let goles=1;
    equipo.jugadores=equipo.jugadores.filter(jug => jug.activo);
    equipo.jugadores=this.orderPipe.transform(equipo.jugadores, 'jugador.persona.nombre_completo',false);
    for(let i=0;i<equipo.jugadores.length || i<numero_jugadores;i++){
      doc.rect(50,y_jugador+10,270,0).stroke();
      //doc.text(i+1,55,y_jugador);
      if(equipo.jugadores[i]){
        doc.font('Helvetica',7);
        if(equipo.jugadores[i].jugador.persona.ci=="0"){
          doc.fillColor("red");
        }
        doc.text(equipo.jugadores[i].jugador.codigo.toUpperCase(),51,y_jugador);
        doc.font('Helvetica',9);
        doc.fillColor("black");
        this.dibujarNombreJugadorPlanilla(doc,equipo.jugadores[i].jugador,72,y_jugador);
      }
      y_jugador=y_jugador+15;
    }
    let y_detalle_venta=y_inicio+150;
    doc.font('Helvetica-Bold',7);
    doc.text("PENDIENTES ECONOMICOS",417,y_detalle_venta-16);
    doc.font('Helvetica',7);
    doc.rect(415,y_detalle_venta-7,175,0).stroke();
    let suma_saldo=0;
    for(let i=0;i<detalles_ventas_pendientes.length;i++){
      let fecha_venta=new Date(detalles_ventas_pendientes[i].venta.fecha);
      let texto_economico="Bs "+detalles_ventas_pendientes[i].venta.saldo.toFixed(2);
      let texto=(fecha_venta.getDate()+"/"+(fecha_venta.getMonth()+1)+"/"+fecha_venta.getFullYear())+" "+detalles_ventas_pendientes[i].producto.nombre+(detalles_ventas_pendientes[i].descripcion?" "+detalles_ventas_pendientes[i].descripcion:"");
      doc.fillColor("red");
      doc.font('Helvetica-Bold',7);
      doc.text(texto_economico,417,y_detalle_venta-5,{width:142});
      doc.fillColor("#000000");
      doc.font('Helvetica',7);
      doc.text(texto,450,y_detalle_venta-5,{width:142});
      y_detalle_venta=y_detalle_venta+16;
      doc.rect(415,y_detalle_venta-7,175,0).stroke();
      suma_saldo=suma_saldo+detalles_ventas_pendientes[i].venta.saldo;
    }
    doc.fillColor("red");
    doc.font('Helvetica-Bold',7);
    doc.text("Total: Bs "+suma_saldo.toFixed(2),530,y_inicio+134);
    doc.font('Helvetica',10);
    doc.fillColor("#000000");
    doc.text("DIRECTOR TÉCNICO:",60,y_jugador);
    doc.text("CAPITÁN:",330,y_jugador);
    //doc.rect(50,y_jugador-5,540,0).stroke();
  }

  async obtenerCategoriasEquiposEmpresa(){
		this.tipo_categoria=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_EQUIPO_CATEGORIAS).toPromise();
	}

  async obtenerFasesCampeonato(){
    this.tipo_fase=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_CAMPEONATO_FASES).toPromise();
  }

  async obtenerDisciplinasCampeonato(){
    this.tipo_disciplina=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_EQUIPO_DISCIPLINAS).toPromise();
  }

  async obtenerEquiposDiferente(equipo_origen){
	  this.equipos_diferente=this.equipos.filter(e => e.id!=equipo_origen.id);
    this.partido.equipo_2=null;
	}

  abrirPopupConfirmacionEliminacionAmarillaEq1(jugador){
		this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = "¿Esta seguro(a) de quitar el jugador?";

		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){
        let indexJugador = this.partido.lista_amarillas_equipo_1.findIndex(jugadorLista => jugadorLista.id_persona === jugador.id_persona);
        this.partido.lista_amarillas_equipo_1.splice(indexJugador, 1);
			}
			this.popupConfirmacion.close();
    });
	}

  abrirPopupConfirmacionEliminacionAmarillaEq2(jugador){
		this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = "¿Esta seguro(a) de quitar el jugador?";

		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){
        let indexJugador = this.partido.lista_amarillas_equipo_2.findIndex(jugadorLista => jugadorLista.id_persona === jugador.id_persona);
        this.partido.lista_amarillas_equipo_2.splice(indexJugador, 1);
			}
			this.popupConfirmacion.close();
    });
	}


  abrirPopupConfirmacionEliminacionRojaEq1(jugador){
		this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = "¿Esta seguro(a) de quitar el jugador?";

		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){
        let indexJugador = this.partido.lista_rojas_equipo_1.findIndex(jugadorLista => jugadorLista.id_persona === jugador.id_persona);
        this.partido.lista_rojas_equipo_1.splice(indexJugador, 1);
			}
			this.popupConfirmacion.close();
    });
	}

  abrirPopupConfirmacionEliminacionRojaEq2(jugador){
		this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = "¿Esta seguro(a) de quitar el jugador?";

		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){
        let indexJugador = this.partido.lista_rojas_equipo_2.findIndex(jugadorLista => jugadorLista.id_persona === jugador.id_persona);
        this.partido.lista_rojas_equipo_2.splice(indexJugador, 1);
			}
			this.popupConfirmacion.close();
    });
	}

  abrirPopupConfirmacionEliminacionMarcadorEq1(marcador_equipo_1){
		this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = "¿Esta seguro(a) de quitar el jugador?";

		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){

        this.marcadorEquipo1 = this.obtenerMarcadorInicialEquipo1() - marcador_equipo_1.marcador;
        let indexJugador = this.partido.lista_marcador_equipo_1.findIndex(jugadorLista => jugadorLista.jugador.id === marcador_equipo_1.jugador.id);
        this.partido.lista_marcador_equipo_1.splice(indexJugador, 1);
			}
			this.popupConfirmacion.close();
    });
	}

  abrirPopupConfirmacionEliminacionMarcadorEq2(marcador_equipo_2){
		this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = "¿Esta seguro(a) de quitar el jugador?";

		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){

        this.marcadorEquipo2 = this.obtenerMarcadorInicialEquipo2() - marcador_equipo_2.marcador;
        let indexJugador = this.partido.lista_marcador_equipo_2.findIndex(jugadorLista => jugadorLista.jugador.id === marcador_equipo_2.jugador.id);
        this.partido.lista_marcador_equipo_2.splice(indexJugador, 1);
			}
			this.popupConfirmacion.close();
    });
	}

  abrirPopupConfirmacionEliminacionPartido(partido){
		this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = "¿Esta seguro(a) de quitar el partido?";

		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){
        partido.eliminado=true;
        this.refrescarMatrizCruces();
    this.refrescarCalendario();
			}
			this.popupConfirmacion.close();
    });
	}

  abrirPopupConfirmacionEliminacion(rol_partido){
		this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = "¿Esta seguro(a) de anular el rol de partidos?";
		this.popupConfirmacion.componentInstance.data = rol_partido;

		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){
				this.eliminarRolPartido($e.data);
			}
			this.popupConfirmacion.close();
        });
	  }

    eliminarRolPartido(rol_partido){
		this.blockUI.start();
		this.rolesPartidosService.eliminarRolPartido(rol_partido).subscribe((res:any) => {
			this.toastr.success(res.mensaje);
			this.getItems();
			this.blockUI.stop();
		});
	}

  /* El dibujo del PDF del rol vive en RolPartidoPdfService, que tambien usa la vista previa de la
     configuracion del campeonato. Aca queda solo que hacer con el documento en cada version. */
  asegurarConfiguracionPdfRolPartido(campeonato){
    return this.rolPartidoPdfService.asegurarConfiguracionPdfRolPartido(campeonato);
  }

  async generarPdfRolPartidos(rol_partido_fuente,doc_f,con_resultados){
    this.asegurarConfiguracionPdfRolPartido(rol_partido_fuente.campeonato);
    let version=rol_partido_fuente.campeonato.configuracion_pdf_rol_partido.usar_rol_version;
    this.blockUI.start();
    let rol_partido,dibujo;
    try{
      rol_partido=await this.rolPartidoPdfService.prepararRolPartido(rol_partido_fuente);
      dibujo=await this.rolPartidoPdfService.dibujarRolPartidos(rol_partido,doc_f,con_resultados,{ usuario:this.usuario, version:version });
    }catch(error){
      this.blockUI.stop();
      console.error(error);
      this.toastr.error("No se pudo generar el rol de partidos");
      return;
    }
    if(doc_f){
      this.blockUI.stop();
      return;
    }
    let doc=dibujo.doc,stream=dibujo.stream;
    let me=this;
    //las versiones 1 y 2 pueden salir en varias imagenes (la 1, una cada 8 partidos)
    if(version==1 || version==2){
      doc.end();
      stream.on('finish', function(d) {
        var reader = new FileReader();
        reader.readAsDataURL(stream.toBlob('application/pdf'));
        reader.onloadend = async function() {
          var base64data = reader.result;
          me.rolesPartidosService.convertirPdfImg({nombre:"rol-partidos.png",publicar_facebook:con_resultados,campeonato:rol_partido_fuente.campeonato,base64:base64data}).subscribe(async (res:any)=>{
            //el rol puede salir en varias imagenes; el servidor devuelve una ruta por pagina
            let rutas=res.paths?res.paths:[res.path];
            for(let i=0;i<rutas.length;i++){
              //espaciadas, porque el navegador descarta las descargas simultaneas
              if(i>0){
                await new Promise(terminar => setTimeout(terminar,700));
              }
              fs.saveAs(GlobalVariable.SERVER_URL+rutas[i], rutas[i].split("/").pop());
            }
            me.blockUI.stop();
          });
        }
      });
    }else{
      doc.end();
      stream.on('finish', async function(d) {
        var reader = new FileReader();
        reader.readAsDataURL(stream.toBlob('application/pdf'));
        reader.onloadend = async function() {
          var base64data = reader.result;
          me.rolesPartidosService.convertirPdfImg({nombre:"rol-partidos.png",publicar_facebook:con_resultados,campeonato:rol_partido_fuente.campeonato,base64:base64data}).subscribe(async (res:any)=>{
            fs.saveAs(GlobalVariable.SERVER_URL+res.path, "rol-partidos.png");
            me.blockUI.stop();
          });
        }
      });
    }
  }

  /* Mensaje de WhatsApp del rol para los arbitros: por dia y por cancha, la hora de cada partido con
     su disciplina y categoria, sin los equipos, la cantidad de partidos ni el campeonato; solo el
     nombre de la empresa arriba. Igual que los otros botones del fixture, sale con lo marcado o, sin
     marcas, con todo el rol (o la cancha). Queda copiado para pegarlo en el chat. */
  async copiarMensajeRolArbitros(rol_partido_fuente){
    this.blockUI.start();
    try{
      let fuente=Object.assign({},rol_partido_fuente);
      if(fuente.partidos){
        fuente.partidos=fuente.partidos.filter(partido => !partido.eliminado);
      }
      let rol_partido=await this.rolPartidoPdfService.prepararRolPartido(fuente);
      if(rol_partido.partidos.length==0){
        this.toastr.warning("El rol no tiene partidos activos");
        return;
      }
      await navigator.clipboard.writeText(this.generarMensajeRolArbitros(rol_partido.partidos));
      this.toastr.success("Mensaje copiado! Péguelo en el chat de whatsapp.");
    }catch(error){
      console.error(error);
      this.toastr.error("No se pudo copiar el mensaje!");
    }finally{
      this.blockUI.stop();
    }
  }

  generarMensajeRolArbitros(partidos,subtitulo=null){
    let inicioDia=(partido) => { let dia=new Date(partido.fecha_hora); dia.setHours(0,0,0,0); return dia.getTime(); };
    let nombreCancha=(partido) => (partido.escenario && partido.escenario.nombre)?String(partido.escenario.nombre):"";
    //dia, cancha (con "Cancha 2" antes que "Cancha 10") y hora, como el PDF del rol
    let ordenados=partidos.slice().sort((a,b) =>
      (inicioDia(a)-inicioDia(b)) ||
      nombreCancha(a).localeCompare(nombreCancha(b),"es",{ numeric:true, sensitivity:"base" }) ||
      (new Date(a.fecha_hora).getTime()-new Date(b.fecha_hora).getTime()));
    //bloques de un mismo dia y cancha, en el orden de arriba
    let bloques=[];
    for(let i=0;i<ordenados.length;i++){
      let ultimo=bloques[bloques.length-1];
      if(ultimo && ultimo.dia===inicioDia(ordenados[i]) && ultimo.cancha===nombreCancha(ordenados[i])){
        ultimo.partidos.push(ordenados[i]);
      }else{
        bloques.push({ dia:inicioDia(ordenados[i]), cancha:nombreCancha(ordenados[i]), escenario:ordenados[i].escenario, partidos:[ordenados[i]] });
      }
    }
    let mensaje="*"+this.usuario.empresa.nombre.toUpperCase()+"*\n";
    if(subtitulo){
      mensaje=mensaje+subtitulo+"\n";
    }
    let dia_anterior=null;
    for(let b=0;b<bloques.length;b++){
      let bloque=bloques[b];
      if(bloque.dia!==dia_anterior){
        let fecha=new Date(bloque.dia);
        mensaje=mensaje+"\n📅 *"+fecha.toLocaleDateString("es-ES",{ weekday:'long' }).toUpperCase()+" "+fecha.getDate()+
                " DE "+fecha.toLocaleString("es-ES",{ month:'long' }).toUpperCase()+"*\n";
        dia_anterior=bloque.dia;
      }else{
        //las canchas de un mismo dia van separadas por una linea en blanco
        mensaje=mensaje+"\n";
      }
      for(let i=0;i<bloque.partidos.length;i++){
        let partido=bloque.partidos[i];
        let datos=[partido.disciplina?partido.disciplina.nombre:null,partido.categoria?partido.categoria.nombre:null]
                  .filter(dato => dato);
        mensaje=mensaje+"🕑 "+this.rolPartidoPdfService.horaTextoPdf(new Date(partido.fecha_hora))+(datos.length>0?" - "+datos.join(" - "):"")+"\n";
      }
      //la cancha, su direccion y el mapa van al final de sus partidos
      if(bloque.cancha){
        mensaje=mensaje+this.textoCanchaMensajeArbitros(bloque.escenario);
      }
    }
    return mensaje.trim();
  }

  /* Cancha, direccion y enlace al mapa. El partido trae la cancha solo con id y nombre; la direccion
     y la ubicacion se toman de las canchas de la empresa. Lo que la cancha no tenga cargado no sale. */
  textoCanchaMensajeArbitros(escenario){
    let completo=this.escenarios?this.escenarios.find(e => e.id==escenario.id):null;
    completo=completo?completo:escenario;
    let texto="🏟️ Cancha : "+completo.nombre+"\n";
    if(completo.direccion && String(completo.direccion).trim()){
      texto=texto+"📌 Dirección: "+String(completo.direccion).trim()+"\n";
    }
    if(completo.latitud && completo.longitud && (Number(completo.latitud)!=0 || Number(completo.longitud)!=0)){
      texto=texto+"📍 Mapa: https://www.google.com/maps?q="+Number(completo.latitud)+","+Number(completo.longitud)+"\n";
    }
    return texto;
  }

  /* PDF del rol en la lista clasica, sin importar el diseño que el campeonato tenga configurado para
     las imagenes de redes. Se descarga, asi se manda directo por WhatsApp. Con respetar_marcas (el
     fixture general) sale solo lo marcado, o todo si no hay marcas; sin el (la lista de roles),
     siempre todo el rol. */
  async generarPdfRolCompleto(rol_partido_fuente,respetar_marcas=false){
    this.blockUI.start();
    try{
      let fuente=Object.assign({},rol_partido_fuente);
      if(fuente.partidos){
        fuente.partidos=fuente.partidos.filter(partido => !partido.eliminado)
                                       .map(partido => respetar_marcas?partido:Object.assign({},partido,{ selected:false }));
      }
      let rol_partido=await this.rolPartidoPdfService.prepararRolPartido(fuente);
      if(rol_partido.partidos.length==0){
        this.toastr.warning("El rol no tiene partidos activos");
        return;
      }
      let pdf=await this.rolPartidoPdfService.generarBlobRolPartidos(rol_partido,false,{ usuario:this.usuario, version:"LISTA" });
      let nombre=(rol_partido.rol && rol_partido.rol.nombre)?rol_partido.rol.nombre:"partidos";
      fs.saveAs(pdf,("Rol "+nombre).replace(/[\\/:*?"<>|]/g,"-")+".pdf");
    }catch(error){
      console.error(error);
      this.toastr.error("No se pudo generar el PDF del rol");
    }finally{
      this.blockUI.stop();
    }
  }

  /* Las categorias y disciplinas guardan su color en nombre_corto. Se usa tanto en la lista como
     en las tarjetas del calendario, para que cada una se lea siempre del mismo color. */
  colorClase(clase){
    return (clase && this.rolPartidoPdfService.esColorPdf(clase.nombre_corto))?clase.nombre_corto:null;
  }

  horaTextoPdf(fecha){
    return this.rolPartidoPdfService.horaTextoPdf(fecha);
  }

  abrirModalResultados(partido){
    this.blockUI.start();
    this.partido=partido;
    this.rolesPartidosService.obtenerPartido(this.partido.id).subscribe((partido_datos:any)=>{
      this.blockUI.stop();
      this.partido.equipo_1=partido_datos.equipo_1;
      this.partido.equipo_2=partido_datos.equipo_2;
      this.modal_resultado_partido=this.modalService.open(this.modal_resultado_partido_ref, {windowClass:'resultado-rol-partido',ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static',scrollable:true});
      this.modal_resultado_partido.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    })
  }

  agregarJugadorAmarillaEq1(jugador){
    this.partido.lista_amarillas_equipo_1=this.partido.lista_amarillas_equipo_1 ?? [];
    if(jugador){
      let jugadorRepetido = this.partido.lista_amarillas_equipo_1.some(jugadorLista => jugadorLista.id === jugador.jugador.id);
    if(jugadorRepetido){
      this.toastr.error("El jugador seleccionado ya se encuentra en la lista");
    }else{
      this.partido.lista_amarillas_equipo_1.push(jugador.jugador);
    }
    }else{
      this.toastr.error("Debe seleccionar un jugador");
    }
  }

  agregarJugadorAmarillaEq2(jugador){
    this.partido.lista_amarillas_equipo_2=this.partido.lista_amarillas_equipo_2?this.partido.lista_amarillas_equipo_2:[];
    if(jugador){
      let jugadorRepetido = this.partido.lista_amarillas_equipo_2.some(jugadorLista => jugadorLista.id === jugador.jugador.id);
      if(jugadorRepetido){
        this.toastr.error("El jugador seleccionado ya se encuentra en la lista");
      }else{
        this.partido.lista_amarillas_equipo_2.push(jugador.jugador);
      }
    }else{
      this.toastr.error("Debe seleccionar un jugador");
    }
  }

  agregarJugadorRojaEq1(jugador){
    this.partido.lista_rojas_equipo_1=this.partido.lista_rojas_equipo_1?this.partido.lista_rojas_equipo_1:[];
    if(jugador){
      let jugadorRepetido = this.partido.lista_rojas_equipo_1.some(jugadorLista => jugadorLista.id === jugador.jugador.id);
    if(jugadorRepetido){
      this.toastr.error("El jugador seleccionado ya se encuentra en la lista");
    }else{
      this.partido.lista_rojas_equipo_1.push(jugador.jugador);
    }
    }else{
      this.toastr.error("Debe seleccionar un jugador");
    }
  }

  agregarJugadorRojaEq2(jugador){
    this.partido.lista_rojas_equipo_2=this.partido.lista_rojas_equipo_2?this.partido.lista_rojas_equipo_2:[];
    if(jugador){
      let jugadorRepetido = this.partido.lista_rojas_equipo_2.some(jugadorLista => jugadorLista.id === jugador.jugador.id);
      if(jugadorRepetido){
        this.toastr.error("El jugador seleccionado ya se encuentra en la lista");
      }else{
        this.partido.lista_rojas_equipo_2.push(jugador.jugador);
      }
    }else{
      this.toastr.error("Debe seleccionar un jugador");
    }
  }

  obtenerMarcadorInicialEquipo1(){
    let marcadorEquipoInicial = 0;
    for (let i = 0; this.partido.lista_marcador_equipo_1 && i < this.partido.lista_marcador_equipo_1.length; i++) {
      marcadorEquipoInicial += this.partido.lista_marcador_equipo_1[i].marcador;
    }
    return marcadorEquipoInicial;
  }
  obtenerMarcadorInicialEquipo2(){
    let marcadorEquipoInicial = 0;
    for (let i = 0; this.partido.lista_marcador_equipo_2 && i < this.partido.lista_marcador_equipo_2.length; i++) {
      marcadorEquipoInicial += this.partido.lista_marcador_equipo_2[i].marcador;
    }
    return marcadorEquipoInicial;
  }

  agregarJugadorMarcadorEq1(jugador, marcador){
    this.partido.lista_marcador_equipo_1 = this.partido.lista_marcador_equipo_1 ?? [];
    if(jugador && marcador){
      if(marcador > 0){
        let jugadorRepetido = this.partido.lista_marcador_equipo_1.some(jugadorLista => jugadorLista.jugador.id === jugador.jugador.id);
      if(jugadorRepetido){
        this.toastr.error("El jugador seleccionado ya se encuentra en la lista");
      }else{
        if (this.partido.lista_marcador_equipo_1.length !== 0 || this.partido.marcador_equipo_1 !== 0) {
          this.marcadorEquipo1 = this.obtenerMarcadorInicialEquipo1() + marcador;
          if(this.marcadorEquipo1 <= this.partido.marcador_equipo_1){
            this.marcadorEquipo1 += marcador;
            this.partido.lista_marcador_equipo_1.push({jugador:jugador.jugador, marcador:marcador});
          }else{
            this.toastr.error("El marcador no corresponde");
            this.marcadorEquipo1 = this.marcadorEquipo1 - marcador;
          }
        }else{
          this.toastr.error(`El equipo ${this.partido.equipo_1.nombre} no marco goles`);
        }
      }
      }else{
        this.toastr.error("No ingresar numeros negativos en los marcadores");
      }
    }else{
      this.toastr.error("Debe seleccionar un jugador y su marcador");
    }
  }

  agregarJugadorMarcadorEq2(jugador,marcador){
    this.partido.lista_marcador_equipo_2=this.partido.lista_marcador_equipo_2 ?? [];
    if(jugador && marcador){
      let jugadorRepetido = this.partido.lista_marcador_equipo_2.some(jugadorLista => jugadorLista.jugador.id === jugador.jugador.id);
      if(jugadorRepetido){
        this.toastr.error("El jugador seleccionado ya se encuentra en la lista");
      }else{
        if(this.partido.lista_marcador_equipo_2.length !== 0 || this.partido.marcador_equipo_2 !== 0){
          this.marcadorEquipo2 = this.obtenerMarcadorInicialEquipo2() + marcador;
          if(this.marcadorEquipo2 <= this.partido.marcador_equipo_2){
            this.marcadorEquipo2 += marcador;
            this.partido.lista_marcador_equipo_2.push({jugador:jugador.jugador,marcador:marcador});
          }else{
            this.toastr.error("El marcador no corresponde");
            this.marcadorEquipo2 = this.marcadorEquipo2 - marcador;
          }
        }else{
          this.toastr.error(`El equipo ${this.partido.equipo_2.nombre} no marco goles`);
        }

      }
    }else{
      this.toastr.error("Debe seleccionar un jugador y su marcador");
    }
  }

  guardarResultadoPartido(){
    if(this.validarResultadoPatido()){
      this.blockUI.start();
      this.rolesPartidosService.actualizarResultadoPartido(this.partido).subscribe((res:any)=>{
        this.toastr.success(res.mensaje);
        this.modal_resultado_partido.close();
        this.blockUI.stop();
        //el marcador y el walk over se ven en la matriz, hay que repintarla
        this.refrescarMatrizCruces();
        this.refrescarCalendario();
      });
    }
  }

async generarVentaEquipo(campeonato,partido,equipo_1,equipo_2){
		this.blockUI.start();
		let configuracion_aplicacion_ventas:any=await this.usuarioService.obtenerConfiguracionPaginaPorCodigo(this.usuario.id_empresa,GlobalVariable.Dictionary.CODIGO_APP_VENTAS,this.usuario.empresa.usar_permisos_avanzados_usuarios?this.usuario.id:0).toPromise();
		this.modalVenta = this.modalService.open(VentaComponent, {windowClass:'venta-popup', ariaLabelledBy: 'modal-basic-title',size: 'lg', backdrop: 'static'});
			this.modalVenta.componentInstance.venta.usuario = this.usuario;
			this.modalVenta.componentInstance.usuario = this.usuario;
			this.modalVenta.componentInstance.configuracion_pagina = configuracion_aplicacion_ventas;
			this.modalVenta.componentInstance.venta.sucursales = Util.obtenerSucursalesUsuario(this.usuario);
			this.modalVenta.componentInstance.es_administrador=Util.esUsuarioAdministrador(this.usuario);
			this.modalVenta.componentInstance.venta.cliente=equipo_1?equipo_1.cliente:equipo_2.cliente;
			this.modalVenta.componentInstance.venta.sucursal=Util.obtenerSucursalesUsuario(this.usuario)[0];
			this.modalVenta.componentInstance.nombre_corto_canal_directo=this.global_variable.Dictionary.CANAL_VENTA_DIRECTA;
      this.modalVenta.componentInstance.venta.descontar_almacen=this.usuario.empresa.usar_inventario?true:false;
      this.modalVenta.componentInstance.venta.fecha=partido.fecha_hora;
      //this.modalVenta.componentInstance.nombre_corto_tipo_pago=GlobalVariable.Dictionary.TIPO_PAGO_CRE;
      this.modalVenta.componentInstance.venta.id_partido=partido.id;
      if(equipo_1){
        this.modalVenta.componentInstance.venta.id_equipo_1=equipo_1.id;
      }else{
        this.modalVenta.componentInstance.venta.id_equipo_2=equipo_2.id;
      }

      let detalles_venta=[];
      //el arbitraje se cobra con el producto de la disciplina del partido, o con el derecho de cancha general
      let producto_arbitraje=Util.obtenerProductoArbitraje(campeonato,partido);
      let importe_derecho_cancha=producto_arbitraje?producto_arbitraje.precio_unitario+(partido.escenario.importe_partido/2):0;
      if(producto_arbitraje){
        detalles_venta.push({
          producto:producto_arbitraje,
          precio_unitario:importe_derecho_cancha,
          importe:importe_derecho_cancha,
          total:importe_derecho_cancha,
          es_servicio:false,
          es_combo:false,
          item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
          editar_precio:true,
          cantidad:1,descuento:0,tipo_descuento:false
        });
        this.modalVenta.componentInstance.venta.pagado=importe_derecho_cancha;
      }
      
			this.modalVenta.componentInstance.venta.detallesVenta=detalles_venta;
			this.modalVenta.componentInstance.inhabilitar_busqueda_item=false;
			this.modalVenta.componentInstance.inhabilitar_sucursal=true;
			this.modalVenta.componentInstance.inhabilitar_almacen=true;
			this.modalVenta.componentInstance.inhabilitar_descontar_almacen=true;
			this.blockUI.stop();
			this.modalVenta.componentInstance.alTerminar.subscribe((res) => {
				if(res){
					if(res.tiene_error){
						this.toastr.error(res.mensaje);
						this.toastr.error(res.stack.substring(0,500));
					}else{
            this.rolesPartidosService.obtenerRolPartido(this.rol_partido.id).subscribe((res:any)=>{
              this.blockUI.stop();
              this.rol_partido=res;
              this.rol_partido.partidos=this.rol_partido.partidos.filter(p => p.activo);
            });
						this.toastr.success(res.mensaje);
						this.modalVenta.close();
					}
				}else{
					this.modalVenta.close();
				}
				
			});
  }

validarResultadoPatido(){
    let res=true;
    if(!this.partido.w_o_equipo_1.es_wo && !this.partido.w_o_equipo_2.es_wo){
      if(this.partido.marcador_equipo_1 === null){
        this.toastr.error(`Debe ingresar un marcador valido al equipo ${this.partido.equipo_1.nombre}!`);
        res=false;
      }
      if(this.partido.marcador_equipo_2 === null){
        this.toastr.error(`Debe ingresar un marcador valido al equipo ${this.partido.equipo_2.nombre}!`);
        res=false;
      }
      if(this.partido.marcador_equipo_1 < 0 || this.partido.marcador_equipo_2 < 0){
        this.toastr.error("No ingresar numeros negativos en los marcadores");
        res=false;
      }
      if(this.partido.marcador_equipo_1 !== this.obtenerMarcadorInicialEquipo1()){
        this.toastr.error(`Los marcadores del equipo ${this.partido.equipo_1.nombre} no coinciden`);
        res=false;
      }
      if(this.partido.marcador_equipo_2 !== this.obtenerMarcadorInicialEquipo2()){
        this.toastr.error(`Los marcadores del equipo ${this.partido.equipo_2.nombre} no coinciden`);
        res=false;
      }
    }
    return res;
  }

  async generarVentaJugadorAmarilla(partido,equipo_1,equipo_2,jugador){
		this.blockUI.start();
		let configuracion_aplicacion_ventas:any=await this.usuarioService.obtenerConfiguracionPaginaPorCodigo(this.usuario.id_empresa,GlobalVariable.Dictionary.CODIGO_APP_VENTAS,this.usuario.empresa.usar_permisos_avanzados_usuarios?this.usuario.id:0).toPromise();
		this.modalVenta = this.modalService.open(VentaComponent, {windowClass:'venta-popup', ariaLabelledBy: 'modal-basic-title',size: 'lg', backdrop: 'static'});
			this.modalVenta.componentInstance.venta.usuario = this.usuario;
			this.modalVenta.componentInstance.usuario = this.usuario;
			this.modalVenta.componentInstance.configuracion_pagina = configuracion_aplicacion_ventas;
			this.modalVenta.componentInstance.venta.sucursales = Util.obtenerSucursalesUsuario(this.usuario);
			this.modalVenta.componentInstance.es_administrador=Util.esUsuarioAdministrador(this.usuario);
			this.modalVenta.componentInstance.venta.cliente=equipo_1?equipo_1.cliente:equipo_2.cliente;
			this.modalVenta.componentInstance.venta.sucursal=Util.obtenerSucursalesUsuario(this.usuario)[0];
			this.modalVenta.componentInstance.nombre_corto_canal_directo=this.global_variable.Dictionary.CANAL_VENTA_DIRECTA;
      this.modalVenta.componentInstance.venta.descontar_almacen=this.usuario.empresa.usar_inventario?true:false;
      this.modalVenta.componentInstance.nombre_corto_tipo_pago=GlobalVariable.Dictionary.TIPO_PAGO_CRE;
      this.modalVenta.componentInstance.venta.id_partido=partido.id;
      this.modalVenta.componentInstance.venta.fecha=partido.fecha_hora;
      let detalles_venta=[];
      let productos:any=await this.productosService.obtenerProductosEmpresa(this.usuario.id_empresa).toPromise();

      let tarjeta_amarilla=productos.filter(p => p.nombre.includes("AMARILLA"));
      tarjeta_amarilla=tarjeta_amarilla.length>0?tarjeta_amarilla[0]:null;
      if(tarjeta_amarilla){
        this.modalVenta.componentInstance.venta.id_jugador=jugador.id;
        if(equipo_1){
          this.modalVenta.componentInstance.venta.lista_amarillas_equipo_1=partido.lista_amarillas_equipo_1;
        }else{
          this.modalVenta.componentInstance.venta.lista_amarillas_equipo_2=partido.lista_amarillas_equipo_2;
        }

        detalles_venta.push({
          producto:tarjeta_amarilla,
          descripcion:jugador.persona.nombre_completo,
          precio_unitario:tarjeta_amarilla.precio_unitario,
          importe:tarjeta_amarilla.precio_unitario,
          total:tarjeta_amarilla.precio_unitario,
          es_servicio:false,
          es_combo:false,
          item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
          editar_precio:true,
          cantidad:1,descuento:0,tipo_descuento:false
        });
      }
      
			this.modalVenta.componentInstance.venta.detallesVenta=detalles_venta;
			this.modalVenta.componentInstance.inhabilitar_busqueda_item=false;
			this.modalVenta.componentInstance.inhabilitar_sucursal=true;
			this.modalVenta.componentInstance.inhabilitar_almacen=true;
			this.modalVenta.componentInstance.inhabilitar_descontar_almacen=true;
			this.blockUI.stop();
			this.modalVenta.componentInstance.alTerminar.subscribe((res) => {
				if(res){
					if(res.tiene_error){
						this.toastr.error(res.mensaje);
						this.toastr.error(res.stack.substring(0,500));
					}else{
            if(this.rol_partido){
              this.rolesPartidosService.obtenerRolPartido(this.rol_partido.id).subscribe((res:any)=>{
                this.blockUI.stop();
                this.rol_partido=res;
                this.partido=this.rol_partido.partidos.filter(par => par.id==this.partido.id)[0];
              });
            }
            //this.obtenerTarjetas();
						this.toastr.success(res.mensaje);
						this.modalVenta.close();
					}
				}else{
					this.modalVenta.close();
				}
				
			});
  }

  async generarVentaJugadorRoja(partido,equipo_1,equipo_2,jugador){
		this.blockUI.start();
		let configuracion_aplicacion_ventas:any=await this.usuarioService.obtenerConfiguracionPaginaPorCodigo(this.usuario.id_empresa,GlobalVariable.Dictionary.CODIGO_APP_VENTAS,this.usuario.empresa.usar_permisos_avanzados_usuarios?this.usuario.id:0).toPromise();
		this.modalVenta = this.modalService.open(VentaComponent, {windowClass:'venta-popup', ariaLabelledBy: 'modal-basic-title',size: 'lg', backdrop: 'static'});
			this.modalVenta.componentInstance.venta.usuario = this.usuario;
			this.modalVenta.componentInstance.usuario = this.usuario;
			this.modalVenta.componentInstance.configuracion_pagina = configuracion_aplicacion_ventas;
			this.modalVenta.componentInstance.venta.sucursales = Util.obtenerSucursalesUsuario(this.usuario);
			this.modalVenta.componentInstance.es_administrador=Util.esUsuarioAdministrador(this.usuario);
			this.modalVenta.componentInstance.venta.cliente=equipo_1?equipo_1.cliente:equipo_2.cliente;
			this.modalVenta.componentInstance.venta.sucursal=Util.obtenerSucursalesUsuario(this.usuario)[0];
			this.modalVenta.componentInstance.nombre_corto_canal_directo=this.global_variable.Dictionary.CANAL_VENTA_DIRECTA;
      this.modalVenta.componentInstance.venta.descontar_almacen=this.usuario.empresa.usar_inventario?true:false;
      this.modalVenta.componentInstance.nombre_corto_tipo_pago=GlobalVariable.Dictionary.TIPO_PAGO_CRE;
      this.modalVenta.componentInstance.venta.id_partido=partido.id;
      this.modalVenta.componentInstance.venta.fecha=partido.fecha_hora;
      let detalles_venta=[];
      let productos:any=await this.productosService.obtenerProductosEmpresa(this.usuario.id_empresa).toPromise();

      let tarjeta_roja=productos.filter(p => p.nombre.includes("ROJA"));
      tarjeta_roja=tarjeta_roja.length>0?tarjeta_roja[0]:null;
      if(tarjeta_roja){
        this.modalVenta.componentInstance.venta.id_jugador=jugador.id;
        if(equipo_1){
          this.modalVenta.componentInstance.venta.lista_rojas_equipo_1=partido.lista_rojas_equipo_1;
        }else{
          this.modalVenta.componentInstance.venta.lista_rojas_equipo_2=partido.lista_rojas_equipo_2;
        }
        detalles_venta.push({
          producto:tarjeta_roja,
          descripcion:jugador.persona.nombre_completo,
          precio_unitario:tarjeta_roja.precio_unitario,
          importe:tarjeta_roja.precio_unitario,
          total:tarjeta_roja.precio_unitario,
          es_servicio:false,
          es_combo:false,
          item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
          editar_precio:true,
          cantidad:1,descuento:0,tipo_descuento:false
        });
      }
      
			this.modalVenta.componentInstance.venta.detallesVenta=detalles_venta;
			this.modalVenta.componentInstance.inhabilitar_busqueda_item=false;
			this.modalVenta.componentInstance.inhabilitar_sucursal=true;
			this.modalVenta.componentInstance.inhabilitar_almacen=true;
			this.modalVenta.componentInstance.inhabilitar_descontar_almacen=true;
			this.blockUI.stop();
			this.modalVenta.componentInstance.alTerminar.subscribe((res) => {
				if(res){
					if(res.tiene_error){
						this.toastr.error(res.mensaje);
						this.toastr.error(res.stack.substring(0,500));
					}else{
            if(this.rol_partido){
              this.rolesPartidosService.obtenerRolPartido(this.rol_partido.id).subscribe((res:any)=>{
                this.blockUI.stop();
                this.rol_partido=res;
                this.partido=this.rol_partido.partidos.filter(par => par.id==this.partido.id)[0];
              });
            }
            //this.obtenerTarjetas();
						this.toastr.success(res.mensaje);
						this.modalVenta.close();
					}
				}else{
					this.modalVenta.close();
				}
				
			});
  }

  establecerWOEquipo1(){
    if(this.partido.w_o_equipo_1.es_wo){
      this.partido.w_o_equipo_2.es_wo=!this.partido.w_o_equipo_1.es_wo;
      if(this.partido.disciplina.nombre=="BALONCESTO"){
        this.partido.marcador_equipo_1=20;
        this.partido.marcador_equipo_2=0;
      }else{
        this.partido.marcador_equipo_1=3;
        this.partido.marcador_equipo_2=0;
      }
    }
  }

  establecerWOEquipo2(){
    if(this.partido.w_o_equipo_2.es_wo){
      this.partido.w_o_equipo_1.es_wo=!this.partido.w_o_equipo_2.es_wo;
      if(this.partido.disciplina.nombre=="BALONCESTO"){
        this.partido.marcador_equipo_1=0;
        this.partido.marcador_equipo_2=20;
      }else{
        this.partido.marcador_equipo_1=0;
        this.partido.marcador_equipo_2=3;
      }
    }
  }

  async generarVentaWO(partido,equipo_1,equipo_2,equipo_que_dio){
		this.blockUI.start();
		let configuracion_aplicacion_ventas:any=await this.usuarioService.obtenerConfiguracionPaginaPorCodigo(this.usuario.id_empresa,GlobalVariable.Dictionary.CODIGO_APP_VENTAS,this.usuario.empresa.usar_permisos_avanzados_usuarios?this.usuario.id:0).toPromise();
		this.modalVenta = this.modalService.open(VentaComponent, {windowClass:'venta-popup', ariaLabelledBy: 'modal-basic-title',size: 'lg', backdrop: 'static'});
			this.modalVenta.componentInstance.venta.usuario = this.usuario;
			this.modalVenta.componentInstance.usuario = this.usuario;
			this.modalVenta.componentInstance.configuracion_pagina = configuracion_aplicacion_ventas;
			this.modalVenta.componentInstance.venta.sucursales = Util.obtenerSucursalesUsuario(this.usuario);
			this.modalVenta.componentInstance.es_administrador=Util.esUsuarioAdministrador(this.usuario);
			this.modalVenta.componentInstance.venta.cliente=equipo_1?equipo_1.cliente:equipo_2.cliente;
			this.modalVenta.componentInstance.venta.sucursal=Util.obtenerSucursalesUsuario(this.usuario)[0];
			this.modalVenta.componentInstance.nombre_corto_canal_directo=this.global_variable.Dictionary.CANAL_VENTA_DIRECTA;
      this.modalVenta.componentInstance.venta.descontar_almacen=this.usuario.empresa.usar_inventario?true:false;
      this.modalVenta.componentInstance.nombre_corto_tipo_pago=GlobalVariable.Dictionary.TIPO_PAGO_CRE;
      this.modalVenta.componentInstance.venta.id_partido=partido.id;
      this.modalVenta.componentInstance.venta.fecha=partido.fecha_hora;
      let detalles_venta=[];
      let productos:any=await this.productosService.obtenerProductosEmpresa(this.usuario.id_empresa).toPromise();

      let w_o=productos.filter(p => p.nombre.includes("W.O."));
      w_o=w_o.length>0?w_o[0]:null;
      if(w_o){
        if(equipo_1){
          this.modalVenta.componentInstance.venta.w_o_equipo_1=partido.w_o_equipo_1;
        }else{
          this.modalVenta.componentInstance.venta.w_o_equipo_2=partido.w_o_equipo_2;
        }
        detalles_venta.push({
          producto:w_o,
          descripcion:"Partido contra "+equipo_que_dio.nombre,
          precio_unitario:w_o.precio_unitario,
          importe:w_o.precio_unitario,
          total:w_o.precio_unitario,
          es_servicio:false,
          es_combo:false,
          item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
          editar_precio:true,
          cantidad:1,descuento:0,tipo_descuento:false
        });
      }
      
			this.modalVenta.componentInstance.venta.detallesVenta=detalles_venta;
			this.modalVenta.componentInstance.inhabilitar_busqueda_item=false;
			this.modalVenta.componentInstance.inhabilitar_sucursal=true;
			this.modalVenta.componentInstance.inhabilitar_almacen=true;
			this.modalVenta.componentInstance.inhabilitar_descontar_almacen=true;
			this.blockUI.stop();
			this.modalVenta.componentInstance.alTerminar.subscribe((res) => {
				if(res){
					if(res.tiene_error){
						this.toastr.error(res.mensaje);
						this.toastr.error(res.stack.substring(0,500));
					}else{
            this.rolesPartidosService.obtenerRolPartido(this.rol_partido.id).subscribe((res:any)=>{
              this.blockUI.stop();
              this.rol_partido=res;
              this.partido=this.rol_partido.partidos.filter(par => par.id==this.partido.id)[0];
            });
						this.toastr.success(res.mensaje);
						this.modalVenta.close();
					}
				}else{
					this.modalVenta.close();
				}
				
			});
  }

  abrirModalTablaPosiciones(){
    this.tabla_posiciones={};
    this.obtenerCategoriasEquiposEmpresa();
    this.obtenerFasesCampeonato();
    this.obtenerDisciplinasCampeonato();
    this.modal_tabla_posiciones=this.modalService.open(this.modal_tabla_posiciones_ref, {windowClass:'tabla-posiciones',ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static',scrollable:true});
    this.modal_tabla_posiciones.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  abrirModalRolPartidosArbitro(){
    let fecha_actual=new Date();
    this.rol_partido_arbitro={
      campeonato:GlobalVariable.Dictionary.SELECCION_TODOS,
      fecha_inicio:{
				year: fecha_actual.getFullYear(), 
				month: (fecha_actual.getMonth()+1),
				day:fecha_actual.getDate()
			},
			fecha_fin:{
				year: fecha_actual.getFullYear(), 
				month: (fecha_actual.getMonth()+1),
				day:fecha_actual.getDate()
			}
    };
    this.obtenerArbitros();
    this.modal_rol_partidos_arbitros=this.modalService.open(this.modal_rol_partidos_arbitros_ref, {windowClass:'rol-partido-arbitro',ariaLabelledBy: 'modal-basic-title',size: 'lg', backdrop: 'static',scrollable:true});
    this.modal_rol_partidos_arbitros.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  buscarTablaPosiciones(){
    this.blockUI.start();
    this.rolesPartidosService.obtenerTablaPosiciones(this.tabla_posiciones).subscribe((res:any)=>{
      this.equipos=res;
      for(let i=0;i<this.equipos.length;i++){
        if(i<this.equipos.length/2){
          this.equipos[i].clasificacion="#207020";
        }else{
          this.equipos[i].clasificacion="#ff0000";
        }
      }
      this.blockUI.stop();
    });
  }

  buscarTablaGoleadores(){
    this.blockUI.start();
    this.rolesPartidosService.obtenerTablaGoleadores(this.tabla_posiciones).subscribe((res:any)=>{
      this.goleadores=res;
      this.blockUI.stop();
    });
  }

  abrirModalTablaGoleadores(){
    this.tabla_posiciones={};
    this.obtenerCategoriasEquiposEmpresa();
    this.obtenerDisciplinasCampeonato();
    this.modal_tabla_goleadores=this.modalService.open(this.modal_tabla_goleadores_ref, {windowClass:'tabla-posiciones',ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static',scrollable:true});
    this.modal_tabla_goleadores.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  async modificarPartido(partido){
    partido.modificar=!partido.modificar;
    let fecha_hora=new Date(partido.fecha_hora);
    partido.fecha_hora_texto=Util.convertirFechaAObjectoFecha(fecha_hora);
    partido.hora={hour:fecha_hora.getHours(),minute:fecha_hora.getMinutes()};
    this.obtenerEquiposCampeonato(this.rol_partido.campeonato,partido.categoria,partido.disciplina);
    partido.equipos=await this.campeonatosService.obtenerListaEquipos(this.rol_partido.campeonato.id,partido.categoria.id,partido.disciplina?partido.disciplina.id:0).toPromise();
    partido.equipo_1_c=partido.equipo_1;
    partido.equipo_2_c=partido.equipo_2;
  }

  async cambiarCategoriaModificacion(partido){
    partido.equipos=await this.campeonatosService.obtenerListaEquipos(this.rol_partido.campeonato.id,partido.categoria.id,partido.disciplina?partido.disciplina.id:0).toPromise();
  }

  async establecerPartidoEquipos(partido){
    if(await this.validarPartido(partido)){
      partido.fecha_hora=Util.convertirObjetoAfecha(partido.fecha_hora_texto);
      partido.fecha_hora.setHours(partido.hora.hour);
      partido.fecha_hora.setMinutes(partido.hora.minute);
      partido.modificar=!partido.modificar;
      this.refrescarMatrizCruces();
    this.refrescarCalendario();
    }else{
      return;
    }
  }

  async validarDuplicidadPartido(partido){
    let respuesta:any=await this.rolesPartidosService.validarDuplicidadPartido(partido).toPromise();
    if(respuesta.tiene_error){
      this.toastr.error(respuesta.mensaje);
    }
    return respuesta.tiene_error;
  }

  /* La tabla sale como imagen (el PDF se convierte a PNG en el servidor): se descarga y, si el
     campeonato tiene pagina de facebook configurada, se publica directo en ella. */
  async generarImagenTablaPosiciones(){
    this.blockUI.start();
    let doc = new PDFDocument({size:[612, Math.max(150+(this.equipos.length*30),468)],margin:10});
    let stream = doc.pipe(blobStream());
    let fondo=await Util.convertirUrlToBase64Image(this.rest_server+this.tabla_posiciones.campeonato.fondo_tabla_posiciones);
    doc.image(fondo,0,0, { width: GlobalVariable.Dictionary.PAPEL_OFICIO_MEDIDA[0], height: GlobalVariable.Dictionary.PAPEL_OFICIO_MEDIDA[1],align:'right' });
    doc.rect(0,0,GlobalVariable.Dictionary.PAPEL_OFICIO_MEDIDA[0],80).fill(this.tabla_posiciones.campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta).stroke();
    if (this.usuario.empresa.imagen.length > 100) { doc.image(this.usuario.empresa.imagen,20,5, { width: 70, height: 70,align:'left' }); }
    doc.fillColor(this.tabla_posiciones.campeonato.configuracion_tarjeta_jugador.enunciados_color);
    doc.font('Times-Bold',30);
    doc.text("TABLA CLASIFICATORIA",0,15,{align:"center"});
    doc.font('Times-Bold',20);
    doc.text(this.tabla_posiciones.categoria.nombre.toUpperCase()+" - "+this.tabla_posiciones.disciplina.nombre.toUpperCase(),0,40,{align:"center"});
    doc.font('Times-Bold',18);
    doc.text(this.tabla_posiciones.fase.nombre.toUpperCase(),0,60,{align:"center"});
    let logo=await Util.convertirUrlToBase64Image(this.rest_server+this.tabla_posiciones.campeonato.logo);
    doc.image(logo,522,5, { width: 70, height: 70,align:'right' });
    doc.font('Helvetica-Bold',16);
    let y_partido=135,items=0,page=1,partidos_por_pagina=20;
    doc.roundedRect(35,87,550,40,20).fill(this.tabla_posiciones.campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta).stroke();
    doc.fillColor(this.tabla_posiciones.campeonato.configuracion_tarjeta_jugador.enunciados_color);
    doc.text("Nº",45,100);
    doc.text("EQUIPO",100,100);
    doc.text("PJ",340,100);
    doc.text("PG",370,100);
    doc.text("PE",400,100);
    doc.text("PP",430,100);
    doc.text("MF",460,100);
    doc.text("MC",490,100);
    doc.text("MD",520,100);
    doc.text("PTS",550,100);
    for(let i=0;i<this.equipos.length;i++){
      doc.roundedRect(50,y_partido-8,20,30,10).fill(this.equipos[i].clasificacion).stroke();
      doc.rect(40,y_partido-8,20,30).fill(this.equipos[i].clasificacion).stroke();
      doc.fillColor(this.tabla_posiciones.campeonato.configuracion_tarjeta_jugador.enunciados_color);
      doc.text(i+1,45,y_partido);
      let logo_eq=await Util.convertirUrlToBase64Image(this.rest_server+this.equipos[i].logo);
      doc.image(logo_eq,70,y_partido-7, { width: 25, height: 25,align:'right' });
      doc.text(this.equipos[i].nombre,100,y_partido);
      doc.text(this.equipos[i].partidos_jugados,340,y_partido);
      doc.text(this.equipos[i].victorias,370,y_partido);
      doc.text(this.equipos[i].empates,400,y_partido);
      doc.text(this.equipos[i].derrotas,430,y_partido);
      doc.text(this.equipos[i].marcador_a_favor,460,y_partido);
      doc.text(this.equipos[i].marcador_contra,490,y_partido);
      doc.text(this.equipos[i].marcador_diferencia,520,y_partido);
      doc.text(this.equipos[i].puntos,565,y_partido);
      items++;
      y_partido=y_partido+30;
    }

    doc.end();
    let me=this,campeonato=this.tabla_posiciones.campeonato;
    let publicar_facebook=campeonato.id_pagina_facebook && campeonato.token_pagina_facebook?true:false;
    stream.on('finish', function(d) {
      var reader = new FileReader();
      reader.readAsDataURL(stream.toBlob('application/pdf'));
      reader.onloadend = function() {
        me.rolesPartidosService.convertirPdfImg({nombre:"tabla-posiciones.png",publicar_facebook:publicar_facebook,campeonato:campeonato,base64:reader.result}).subscribe((res:any)=>{
          fs.saveAs(GlobalVariable.SERVER_URL+res.path, "tabla-posiciones.png");
          if(publicar_facebook){
            me.toastr.success("Tabla de posiciones publicada en la página del campeonato");
          }else{
            me.toastr.warning("El campeonato no tiene página de facebook configurada: solo se descargó la imagen");
          }
          me.blockUI.stop();
        },(error)=>{
          me.blockUI.stop();
          me.toastr.error("No se pudo generar la imagen de la tabla de posiciones");
        });
      }
    });
  }

  buscarPartidosArbitro(){
    this.blockUI.start();
    this.rolesPartidosService.obtenerPartidosArbitro(this.rol_partido_arbitro).subscribe((res:any)=>{
      this.blockUI.stop();
      this.rol_partido_arbitro.partidos=res;
      this.allItemsSelected=true;
      this.selectAllItems(this.rol_partido_arbitro.partidos);
    });
  }

  async generarPdfRolPartidosArbitro(){
    let rol_partido=JSON.parse(JSON.stringify(this.rol_partido_arbitro));
    rol_partido.campeonato.fondo_rol_partido=rol_partido.partidos[0].rol_partido.campeonato.fondo_rol_partido;
    if(rol_partido.partidos.filter(p => p.activo && p.selected).length>0){
      rol_partido.partidos=rol_partido.partidos.filter(p => p.activo && p.selected);
    }else{
      rol_partido.partidos=rol_partido.partidos.filter(p => p.activo);
    }

    let canchas = rol_partido.partidos.filter((partido, i, arr) => arr.findIndex(t => t.id_escenario === partido.id_escenario) === i);
    for(let i=0;i<canchas.length;i++){
      let indice=rol_partido.partidos.indexOf(canchas[i]);
      rol_partido.partidos.splice(indice,0,{fecha_hora:canchas[i].fecha_hora,escenario:canchas[i].escenario})
    }

    let fechas = rol_partido.partidos.filter((partido, i, arr) => arr.findIndex(t => new Date(t.fecha_hora).toDateString() === new Date(partido.fecha_hora).toDateString() && partido.id!=null) === i);
    for(let i=0;i<fechas.length;i++){
      let indice=rol_partido.partidos.indexOf(fechas[i]);
      rol_partido.partidos.splice(indice,0,{fecha_hora:fechas[i].fecha_hora,escenario:fechas[i].escenario})
    }

    let doc = new PDFDocument({size:[612, Math.max(150+(40*rol_partido.partidos.length),468)],margin:10});
    let stream = doc.pipe(blobStream());
    const numeroAleatorio = Math.floor(Math.random() * 6) + 1;
    let fondo=await Util.convertirUrlToBase64Image(this.rest_server+"./img/fondo-rol-partido-futsal-"+numeroAleatorio+".png");
    await this.dibujarCabeceraRolPartidoArbitro(doc,fondo,rol_partido);
    let y_partido=100,items=0,page=1,partidos_por_pagina=20;
    for(let i=0;i<rol_partido.partidos.length;i++){
      doc.switchToPage(page-1);
      items++;
      if(rol_partido.partidos[i].equipo_1){
        //doc.roundedRect(20,y_partido,GlobalVariable.Dictionary.PAPEL_CARTA_MEDIDA[0]-40,25,5).fill(rol_partido.campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta).stroke();
        let fecha_hora=new Date(rol_partido.partidos[i].fecha_hora);
        doc.fillColor("#06427e");
        //doc.fillColor(rol_partido.campeonato.configuracion_tarjeta_jugador.enunciados_color);
        
        doc.text(fecha_hora.getHours()+":"+fecha_hora.getMinutes(),20,y_partido+3,{width:43,align:"left"});
        doc.font('Helvetica-Bold',16);
        doc.fillColor("#000000");
        doc.text(rol_partido.partidos[i].equipo_1.nombre,60,y_partido+7,{width:231,align:"right"});
        let logo_eq_1=await Util.convertirUrlToBase64Image(this.rest_server+rol_partido.partidos[i].equipo_1.logo);
        doc.image(logo_eq_1,62,y_partido-0, { width: 25, height: 25,align:'right' });
        doc.fillColor("#06427e");

        doc.font('Helvetica',8);
        if(rol_partido.partidos[i].disciplina.nombre=="BALONCESTO"){
          doc.roundedRect(280,y_partido+22,90,12,5).fill("#ed7213").stroke();
        }else{
          doc.roundedRect(280,y_partido+22,90,12,5).fill("#06427e").stroke();
        }
        doc.fillColor("#ffffff");
        doc.text(rol_partido.partidos[i].disciplina.nombre,281,y_partido+25,{width:90,height:30,align:"center"});

        doc.font('Helvetica-Bold',16);
        let color_categoria;
        color_categoria=rol_partido.partidos[i].categoria.nombre_corto?rol_partido.partidos[i].categoria.nombre_corto:"#06427e";
        doc.fillColor(color_categoria);
        doc.text("VS",311,y_partido,{width:30,align:"center"});          
        doc.font('Helvetica-Bold',10);
        doc.roundedRect(295,y_partido+10,62,14,5).fill(color_categoria).stroke();
        doc.fillColor("#ffffff");
        doc.text(rol_partido.partidos[i].categoria.nombre,296,y_partido+13,{width:60,align:"center"});

        doc.font('Helvetica-Bold',16);
        doc.fillColor("#000000");
        doc.text(rol_partido.partidos[i].equipo_2.nombre,361,y_partido+7,{width:231,align:"left"});
        doc.fillColor("#000000");
        let logo_eq_2=await Util.convertirUrlToBase64Image(this.rest_server+rol_partido.partidos[i].equipo_2.logo);
        doc.image(logo_eq_2,565,y_partido-0, { width: 25, height: 25,align:'right' });
      }else{
        doc.roundedRect(153,y_partido,300,30,5).fill("#06427e").stroke();
        let fecha_hora=new Date(rol_partido.partidos[i].fecha_hora);
        doc.fillColor("#ffffff");
        let y_fecha=y_partido+8;
        y_fecha=y_partido+5;
        doc.font('Helvetica-Bold',10);
        doc.text(rol_partido.partidos[i].escenario.nombre,0,y_partido+20,{width:612,align:"center"});
        doc.font('Helvetica-Bold',16);
        doc.text(fecha_hora.toLocaleDateString("es-ES", { weekday: 'long' }).toUpperCase()+", "+fecha_hora.getDate()+" "+fecha_hora.toLocaleString('es-ES', { month: 'long' }).toUpperCase()+" "+fecha_hora.getFullYear(),0,y_fecha,{width:612,align:"center"});
      }
      y_partido=y_partido+40;

      if(items==partidos_por_pagina){
        items=0;
        y_partido=100;
        doc.addPage({size:[612, Math.max(150+(40*rol_partido.partidos.length),468)],margin:10});
        page++;
        await this.dibujarCabeceraRolPartidoArbitro(doc,fondo,rol_partido);
      }
    }

    doc.end();
    let me=this;
    stream.on('finish', function(d) {
      var reader = new FileReader();
      reader.readAsDataURL(stream.toBlob('application/pdf')); 
      reader.onloadend = async function() {
        var base64data = reader.result;                
        me.rolesPartidosService.convertirPdfImg({nombre:"rol-partidos.png",publicar_facebook:false,campeonato:rol_partido.campeonato,base64:base64data}).subscribe(async (res:any)=>{
          fs.saveAs(GlobalVariable.SERVER_URL+res.path, "rol-partidos.png");
          me.blockUI.stop();
        });
      }
      /*var fileURL = stream.toBlobURL('application/pdf');
      window.open(fileURL,'_blank','location=no');*/
    });
  }

  /* Mensaje de WhatsApp del rol del arbitro elegido en el modal, con el mismo formato que el de los
     arbitros del fixture y el nombre del arbitro arriba. Igual que el PDF, sale con lo marcado o, sin
     marcas, con todos los partidos activos encontrados. */
  async copiarMensajeRolPartidosArbitro(){
    let partidos=(this.rol_partido_arbitro.partidos || []).filter(p => p.activo);
    if(partidos.filter(p => p.selected).length>0){
      partidos=partidos.filter(p => p.selected);
    }
    if(partidos.length==0){
      this.toastr.warning("No hay partidos para generar el rol. Busque los partidos del arbitro.");
      return;
    }
    let subtitulo="🧑‍⚖️ *ROL DE PARTIDOS - ARBITRO"+(this.rol_partido_arbitro.arbitro?": "+this.rol_partido_arbitro.arbitro.persona.nombre_completo.toUpperCase():"")+"*";
    try{
      await navigator.clipboard.writeText(this.generarMensajeRolArbitros(partidos,subtitulo));
      this.toastr.success("Mensaje copiado! Péguelo en el chat de whatsapp.");
    }catch(error){
      console.error(error);
      this.toastr.error("No se pudo copiar el mensaje!");
    }
  }

  async dibujarCabeceraRolPartidoArbitro(doc,fondo,rol_partido){
    doc.opacity(0.5);
    doc.image(fondo,0,0, { width: GlobalVariable.Dictionary.PAPEL_OFICIO_MEDIDA[0], height: GlobalVariable.Dictionary.PAPEL_OFICIO_MEDIDA[1],align:'right' });
    doc.opacity(1.0);
    doc.rect(0,0,GlobalVariable.Dictionary.PAPEL_OFICIO_MEDIDA[0],80).fill("#06427e").stroke();
    if (this.usuario.empresa.imagen.length > 100) { doc.image(this.usuario.empresa.imagen,20,5, { width: 70, height: 70,align:'left' }); }
    doc.fillColor("#ffffff");
    doc.font('Times-Bold',20);
    doc.text(this.usuario.empresa.nombre.toUpperCase(),0,20,{align:"center"});
    doc.font('Times-Bold',15);
    doc.text("ROL DE PARTIDOS - ARBITRO: "+rol_partido.arbitro.persona.nombre_completo.toUpperCase(),0,50,{align:"center"});
    if (this.usuario.empresa.imagen.length > 100) { doc.image(this.usuario.empresa.imagen,522,5, { width: 70, height: 70,align:'right' }); }
    doc.font('Helvetica-Bold',16);
  }  

  async generarPdfTablaGoleadores(){
    this.blockUI.start();
    let doc = new PDFDocument({size:[GlobalVariable.Dictionary.PAPEL_CARTA_MEDIDA[0],GlobalVariable.Dictionary.PAPEL_CARTA_MEDIDA[1]],margin:10});
    let stream = doc.pipe(blobStream());
    let fondo=await Util.convertirUrlToBase64Image(this.rest_server+this.tabla_posiciones.campeonato.fondo_tabla_posiciones);
    doc.image(fondo,0,0, { width: GlobalVariable.Dictionary.PAPEL_CARTA_MEDIDA[0], height: GlobalVariable.Dictionary.PAPEL_CARTA_MEDIDA[1],align:'right' });
    doc.rect(0,0,GlobalVariable.Dictionary.PAPEL_CARTA_MEDIDA[0],80).fill(this.tabla_posiciones.campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta).stroke();
    if (this.usuario.empresa.imagen.length > 100) { doc.image(this.usuario.empresa.imagen,20,5, { width: 70, height: 70,align:'left' }); }
    doc.fillColor(this.tabla_posiciones.campeonato.configuracion_tarjeta_jugador.enunciados_color);
    doc.font('Times-Bold',30);
    doc.text("TABLA GOLEADORES",0,15,{align:"center"});
    doc.font('Times-Bold',20);
    doc.text(this.tabla_posiciones.categoria.nombre.toUpperCase()+" - "+this.tabla_posiciones.disciplina.nombre.toUpperCase(),0,40,{align:"center"});
    let logo=await Util.convertirUrlToBase64Image(this.rest_server+this.tabla_posiciones.campeonato.logo);
    doc.image(logo,522,5, { width: 70, height: 70,align:'right' });
    doc.font('Helvetica-Bold',16);
    let y_partido=135,items=0,page=1,partidos_por_pagina=20;
    doc.roundedRect(10,87,590,40,20).fill(this.tabla_posiciones.campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta).stroke();
    doc.fillColor(this.tabla_posiciones.campeonato.configuracion_tarjeta_jugador.enunciados_color);
    doc.text("Nº",15,100);
    doc.text("EQUIPO",100,100);
    doc.text("JUGADOR",340,100);
    doc.text("GOLES",530,100);
    for(let i=0;i<this.goleadores.length;i++){
      doc.roundedRect(20,y_partido-8,20,60,10).fill(this.tabla_posiciones.campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta).stroke();
      doc.rect(10,y_partido-8,20,60).fill(this.tabla_posiciones.campeonato.configuracion_tarjeta_jugador.fondo_color_tarjeta).stroke();
      doc.fillColor(this.tabla_posiciones.campeonato.configuracion_tarjeta_jugador.enunciados_color);
      doc.text(i+1,15,y_partido);
      let logo_eq=await Util.convertirUrlToBase64Image(this.rest_server+this.goleadores[i].logo_equipo);
      let foto_jugador=await Util.convertirUrlToBase64Image(this.rest_server+this.goleadores[i].foto_jugador);
      doc.image(logo_eq,35,y_partido-7, { width: 50, height: 50,align:'right' });
      doc.text(this.goleadores[i].equipo,85,y_partido+10);
      doc.text(this.goleadores[i].jugador.toUpperCase(),325,y_partido+10,{width:160});
      doc.image(foto_jugador,490,y_partido-7, { width: 50, height: 50,align:'right' });
      doc.text(this.goleadores[i].marcador,550,y_partido+10);
      items++;
      y_partido=y_partido+60;
    }

    doc.end();
    this.blockUI.stop();
    stream.on('finish', function(d) {
      var fileURL = stream.toBlobURL('application/pdf');
      window.open(fileURL,'_blank','location=no');
    });
  }

  aumentarMarcadorEq1(partido){
    partido.marcador_equipo_1=partido.marcador_equipo_1?partido.marcador_equipo_1+1:1;
    this.socket.emit('cambiarMarcador',partido);
    this.refrescarMatrizCruces();
  }

  disminuirMarcadorEq1(partido){
    partido.marcador_equipo_1=partido.marcador_equipo_1?partido.marcador_equipo_1-1:1;
    this.socket.emit('cambiarMarcador',partido);
    this.refrescarMatrizCruces();
  }

  aumentarMarcadorEq2(partido){
    partido.marcador_equipo_2=partido.marcador_equipo_2?partido.marcador_equipo_2+1:1;
    this.socket.emit('cambiarMarcador',partido);
    this.refrescarMatrizCruces();
  }

  disminuirMarcadorEq2(partido){
    partido.marcador_equipo_2=partido.marcador_equipo_2?partido.marcador_equipo_2-1:1;
    this.socket.emit('cambiarMarcador',partido);
    this.refrescarMatrizCruces();
  }
  

  //enlace del marcador en vivo para la transmision: se pega como fuente Web en Prism u OBS
  copiarEnlace(partido){
    navigator.clipboard.writeText(GlobalVariable.SERVER_URL+"tor/consulta-marcador-partido/partido/"+partido.id)
      .then(() => this.toastr.success("Enlace del marcador copiado! Péguelo como fuente Web en la transmisión."))
      .catch(() => this.toastr.error("No se pudo copiar el enlace!"));
  }

  abrirConfiguracionAplicacion(){
		this.configuracion_aplicacion_modal=this.modalService.open(ConfiguracionAplicacionRolPartidosComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static',scrollable:true});
		this.configuracion_aplicacion_modal.componentInstance.configuracion_pagina=this.configuracion_pagina;
		this.configuracion_aplicacion_modal.componentInstance.usuario=this.usuario;
		this.configuracion_aplicacion_modal.componentInstance.alTerminar.subscribe((res) => {
			this.configuracion_aplicacion_modal.close();
		});
	}

  async crearNuevoJugador(equipo){
    this.modalJugador = this.modalService.open(RegistroJugadorComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    this.modalJugador.componentInstance.equipo = equipo;
		this.modalJugador.componentInstance.usuario = this.usuario;
		
		this.modalJugador.componentInstance.alTerminar.subscribe((res) => {
			if(res){
				if(res.tiene_error){
					this.toastr.error(res.mensaje);
					this.toastr.error(res.stack.substring(0,500));
				}else{
          this.blockUI.start();
          this.rolesPartidosService.obtenerRolPartido(this.rol_partido.id).subscribe((res:any)=>{
            this.blockUI.stop();
            this.rol_partido=res;
            this.partido=this.rol_partido.partidos.filter(par => par.id==this.partido.id)[0];
          });
					this.modalJugador.close();
				}
			}else{
				this.modalJugador.close();
			}
			
		});
  }

  async modificarJugador(equipo,jugador){
    this.modalJugador = this.modalService.open(RegistroJugadorComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    this.modalJugador.componentInstance.equipo = equipo;
    this.modalJugador.componentInstance.jugador = jugador;
		this.modalJugador.componentInstance.usuario = this.usuario;
		
		this.modalJugador.componentInstance.alTerminar.subscribe((res) => {
			if(res){
				if(res.tiene_error){
					this.toastr.error(res.mensaje);
					this.toastr.error(res.stack.substring(0,500));
				}else{
          this.blockUI.start();
          this.rolesPartidosService.obtenerRolPartido(this.rol_partido.id).subscribe((res:any)=>{
            this.blockUI.stop();
            this.rol_partido=res;
            this.partido=this.rol_partido.partidos.filter(par => par.id==this.partido.id)[0];
          });
					this.modalJugador.close();
				}
			}else{
				this.modalJugador.close();
			}
			
		});
  }

  abrirPopupConfirmacionEliminacionJugador(jugador){
      this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
      this.popupConfirmacion.componentInstance.message = "¿Esta seguro de eliminar al jugador?";
      this.popupConfirmacion.componentInstance.data = jugador;
      
      this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
        if($e.confirm){
          this.eliminarJugador($e.data);
        }
        this.popupConfirmacion.close();
          });
    }
      
    eliminarJugador(jugador){
      this.blockUI.start();
      this.campeonatosService.eliminarJugador(jugador).subscribe((dato:any)=>{
        this.blockUI.stop();
        if(dato.tiene_error){
          this.toastr.error(dato.mensaje);
        }else{
          this.blockUI.start();
          this.rolesPartidosService.obtenerRolPartido(this.rol_partido.id).subscribe((res:any)=>{
            this.blockUI.stop();
            this.rol_partido=res;
            this.partido=this.rol_partido.partidos.filter(par => par.id==this.partido.id)[0];
          });
          this.toastr.success(dato.mensaje);
        }
      });
    }

    async cerrarCaja(rol_partido){
      this.blockUI.start();
      let rol_partido_datos:any=await this.rolesPartidosService.obtenerRolPartidoCierres(rol_partido.id).toPromise();
      this.blockUI.stop();
      this.cierres_mesas=rol_partido_datos.cierres_caja?rol_partido_datos.cierres_caja:[];
      for(let i=0;i<this.cierres_mesas.length;i++){
        this.cierres_mesas[i].fecha_texto=this.etiquetaFechaCierre(this.cierres_mesas[i]);
      }
      //se abre el primer cierre por procesar, o el primero si ya estan todos procesados
      let indice_pendiente=this.cierres_mesas.findIndex(c => !c.procesado);
      this.indice_cierre_seleccionado=indice_pendiente>=0?indice_pendiente:0;
      this.cierre_rol={rol_partido:{id:rol_partido.id},ventas:[],pagos_venta:[],compras:[],saldo_faltante:0,saldo_sobrante:0,id_usuario:this.usuario.id,id_sucursal:Util.obtenerSucursalesUsuario(this.usuario)[0].id};
      this.abrirRegistroCaja();
      this.obtenerMovimientosEgreso();
      this.obtenerCajasEmpresa();
      this.obtenerTiposDocumentosCompra();
      this.obtenerConceptosEgresoCompra();
    }

    //lo que quedo a credito de un cobro de la mesa (lo no pagado en efectivo ni QR); el pago de una deuda anterior no genera credito
    obtenerCreditoDetallePago(detalle_pago){
      if(detalle_pago.es_pendiente){
        return 0;
      }
      return Math.max(0,(detalle_pago.total || 0)-(detalle_pago.importe || 0)-(detalle_pago.qr || 0));
    }

    obtenerTotalesEquipoCierre(equipo){
      return (equipo && equipo.detalle_pago || []).reduce((totales,detalle_pago) => {
        totales.efectivo+=detalle_pago.importe || 0;
        totales.qr+=detalle_pago.qr || 0;
        totales.credito+=this.obtenerCreditoDetallePago(detalle_pago);
        return totales;
      },{efectivo:0,qr:0,credito:0});
    }

    //una misma mesa puede tener un cierre por cada fecha del rol, los cierres antiguos no tienen el campo fecha y se deriva de sus partidos
    etiquetaFechaCierre(cierre){
      let clave_fecha=cierre.fecha;
      if(!clave_fecha && cierre.partidos && cierre.partidos.length>0 && cierre.partidos[0].fecha_hora){
        let fecha=new Date(cierre.partidos[0].fecha_hora);
        clave_fecha=fecha.getFullYear()+"-"+("0"+(fecha.getMonth()+1)).slice(-2)+"-"+("0"+fecha.getDate()).slice(-2);
      }
      if(!clave_fecha){
        return "";
      }
      let partes=clave_fecha.split("-");
      return partes[2]+"/"+partes[1]+"/"+partes[0];
    }

    obtenerTiposDocumentosCompra(){
    this.blockUI.start();
    this.generalService.obtenerClases("TIPDOC").subscribe((entidad:any)=>{
      this.tiposDocumentosCompra=entidad.clases;
      this.blockUI.stop();
    });
  }

    obtenerCajasEmpresa(){
      this.blockUI.start();
      this.cajasService.obtenerCajasEmpresa(this.usuario.id_empresa).subscribe((cajas:any)=>{
        this.cajas=cajas;
        this.blockUI.stop();
      });
    }

    async obtenerMovimientosEgreso(){
        let entidad:any=await this.generalService.obtenerClases("MOVEGR").toPromise();
        let movimientosEgresoOriginal=entidad.clases;
        this.movimientos=movimientosEgresoOriginal.filter(e => e.nombre_corto == GlobalVariable.Dictionary.EGRE_PROFORMA);
    }

    abrirRegistroCaja(){
      this.modal_registro_caja_mesa=this.modalService.open(this.modal_registro_caja_mesa_ref, {windowClass:'rol-partido',ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static', scrollable:true});
      this.modal_registro_caja_mesa.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }

    async procesarCaja(cierre_caja){
      this.blockUI.start();
      let fecha_hora;
      if(this.validarCierreCaja(this.cierre_rol)){
        //los cierres se leyeron al abrir esta ventana y las tablets pudieron seguir guardando planillas: se procesa lo ultimo guardado
        let rol_partido_datos:any=await this.rolesPartidosService.obtenerRolPartidoCierres(this.cierre_rol.rol_partido.id).toPromise();
        let cierre_actual=(rol_partido_datos.cierres_caja?rol_partido_datos.cierres_caja:[]).find(c => c._id==cierre_caja._id);
        if(cierre_actual){
          cierre_actual.fecha_texto=cierre_caja.fecha_texto;
          cierre_caja=cierre_actual;
        }
        if(!cierre_caja.procesado){
          this.tiposPago=await this.generalService.obtenerClases("TIPA").toPromise();
          cierre_caja.procesado=true;
          for(let i=0;i<cierre_caja.partidos.length;i++){
            //procesando los detalles de pago
            for(let j=0;j<cierre_caja.partidos[i].equipo_1.detalle_pago.length;j++){
              fecha_hora=cierre_caja.partidos[i].fecha_hora;
              if(cierre_caja.partidos[i].equipo_1.detalle_pago[j].es_pendiente){
                this.cierre_rol.pagos_venta.push(await this.generarPagoVenta(cierre_caja.partidos[i].equipo_1.detalle_pago[j].id_venta,
                  cierre_caja.partidos[i],
                  cierre_caja.partidos[i].equipo_1.detalle_pago[j],
                  this.cierre_rol.caja));
              }else{
                this.cierre_rol.ventas.push(await this.generarVenta(cierre_caja.partidos[i].equipo_1.cliente,
                  cierre_caja.partidos[i],
                  cierre_caja.partidos[i].equipo_1,null,
                  cierre_caja.partidos[i].equipo_1.detalle_pago[j],
                  this.cierre_rol.caja,
                  this.cierre_rol.movimiento));
              }
            }
            for(let j=0;j<cierre_caja.partidos[i].equipo_2.detalle_pago.length;j++){
              if(cierre_caja.partidos[i].equipo_2.detalle_pago[j].es_pendiente){
                this.cierre_rol.pagos_venta.push(await this.generarPagoVenta(cierre_caja.partidos[i].equipo_2.detalle_pago[j].id_venta,
                  cierre_caja.partidos[i],
                  cierre_caja.partidos[i].equipo_2.detalle_pago[j],
                  this.cierre_rol.caja));
              }else{
                this.cierre_rol.ventas.push(await this.generarVenta(cierre_caja.partidos[i].equipo_2.cliente,
                  cierre_caja.partidos[i],
                  null,cierre_caja.partidos[i].equipo_2,
                  cierre_caja.partidos[i].equipo_2.detalle_pago[j],
                  this.cierre_rol.caja,
                  this.cierre_rol.movimiento));
              }
            }
            //agregando el marcador
            let jugadores_marcador_eq1=cierre_caja.partidos[i].equipo_1.jugadores.filter(j => (j.jugador.marcador && j.jugador.marcador!=undefined));
            cierre_caja.partidos[i].lista_marcador_equipo_1=[];
            for(let k=0;k<jugadores_marcador_eq1.length;k++){
              cierre_caja.partidos[i].lista_marcador_equipo_1.push({jugador:jugadores_marcador_eq1[k].jugador, marcador:jugadores_marcador_eq1[k].jugador.marcador});
            }

            let jugadores_marcador_eq2=cierre_caja.partidos[i].equipo_2.jugadores.filter(j => (j.jugador.marcador && j.jugador.marcador!=undefined));
            cierre_caja.partidos[i].lista_marcador_equipo_2=[];
            for(let k=0;k<jugadores_marcador_eq2.length;k++){
              cierre_caja.partidos[i].lista_marcador_equipo_2.push({jugador:jugadores_marcador_eq2[k].jugador, marcador:jugadores_marcador_eq2[k].jugador.marcador});
            }
          }        
          this.cierre_rol.compras.push(await this.generarCompra(fecha_hora,cierre_caja.pago_arbitro,"COD46","SERVICIO ARBITRAJE"));
          this.cierre_rol.compras.push(await this.generarCompra(fecha_hora,cierre_caja.pago_mesa,cierre_caja.mesa.persona.nombres+" "+cierre_caja.mesa.persona.apellido_paterno,"SERVICIO MESA PLANILLA"));
          if(cierre_caja.pago_otros>0){
            this.cierre_rol.compras.push(await this.generarCompra(fecha_hora,cierre_caja.pago_otros,"SIN NOMBRE","OTROS"));
          }
          
          this.cierre_rol.saldo_faltante=cierre_caja.saldo_faltante;
          this.cierre_rol.saldo_sobrante=cierre_caja.saldo_sobrante;

          let indice_cierre=this.cierres_mesas.findIndex(c => c._id==cierre_caja._id);
          if(indice_cierre>=0){
            this.cierres_mesas[indice_cierre]=cierre_caja;
          }
          this.cierre_rol.rol_partido.cierres_caja=this.cierres_mesas;
          //el servidor guarda solo este cierre sobre la lista guardada, sin pisar lo que las tablets guardaron en los otros
          this.cierre_rol.rol_partido.cierre_caja=cierre_caja;
          console.log(this.cierre_rol);
          let res:any=await this.ventasService.guardarVentasRolPartido(this.cierre_rol).toPromise();
          this.blockUI.stop();
          if(res.tiene_error){
            this.toastr.error(res.mensaje);
          }else{
            this.toastr.success(res.mensaje);
          }
          this.modal_registro_caja_mesa.close();

        }else{
          this.toastr.warning("La caja de mesa ya se proceso!")
          this.blockUI.stop();
        }
      }else{
        this.blockUI.stop();
      }
    }

    async generarVenta(cliente,partido,equipo_1,equipo_2,pago,caja,movimiento){
      let tipo_pago,
      venta:any={
        detallesVenta:[],
        cliente:cliente,
        nit_ci:cliente.nit,
        razon_social:cliente.razon_social,
        usuario:this.usuario,
        fecha:partido.fecha_hora,
        pagado:0,
        importe_gift_card:0,
        importe_qr:0,
        cambio:0,
        sucursal:Util.obtenerSucursalesUsuario(this.usuario)[0],
        a_cuenta:0,
        saldo:0,
        total:0,
        almacen:null,
        actividad:null,
        sin_documento:null,
        pagoMinimo:0,
        importe:0,
        cotizacion:null,
        filtro_consulta:null,
        pedido:{},
        es_pedido:false,
        transaccion:movimiento,
        descuento:0,
        descontar_almacen:false,
        cantidad_decimal:true,
        tipoPago:null,
        dias_credito:1,
        observacion:null,
        documentos:[],
        tipo_descuento:false,
        id_historia_paciente:null,
        id_equipo_1:null,
        id_equipo_2:null,
        id_partido:partido.id,
        id_jugador:pago.jugador?pago.jugador.id:null
      }      
      if(pago.importe==0 && pago.qr==0){
        tipo_pago=this.tiposPago.clases.filter(e => e.nombre_corto == GlobalVariable.Dictionary.TIPO_PAGO_CRE)[0];
        venta.a_cuenta=0;
        venta.importe=pago.total;
        venta.total=pago.total;
        venta.saldo=pago.total;
        venta.importe_qr=0;
      }else if(pago.importe==0 && pago.qr>0){
        if(pago.qr==pago.total){
          tipo_pago=this.tiposPago.clases.filter(e => e.nombre_corto == GlobalVariable.Dictionary.TIPO_PAGO_CODQR)[0];
          venta.importe=pago.total;
          venta.total=pago.total;
          venta.saldo=0;
          venta.pagado=pago.total;
        }else{
          tipo_pago=this.tiposPago.clases.filter(e => e.nombre_corto == GlobalVariable.Dictionary.TIPO_PAGO_CRE)[0];
          venta.a_cuenta=pago.qr;
          venta.importe=pago.total;
          venta.total=pago.total;
          venta.saldo=pago.total-pago.qr;
        }
        venta.importe_qr=pago.qr;
        venta.caja=caja;
      }else if(pago.qr==0 && pago.importe>0){
        if(pago.importe==pago.total){
          tipo_pago=this.tiposPago.clases.filter(e => e.nombre_corto == GlobalVariable.Dictionary.TIPO_PAGO_CONT)[0];
          venta.importe=pago.total;
          venta.total=pago.total;
          venta.saldo=0;
          venta.pagado=pago.total;
        }else{
          tipo_pago=this.tiposPago.clases.filter(e => e.nombre_corto == GlobalVariable.Dictionary.TIPO_PAGO_CRE)[0];
          venta.a_cuenta=pago.importe;
          venta.importe=pago.total;
          venta.total=pago.total;
          venta.saldo=pago.total-pago.importe;
        }
        venta.importe_qr=0;
      }else if(pago.qr>0 && pago.importe>0){
        if(pago.importe+pago.qr==pago.total){
          tipo_pago=this.tiposPago.clases.filter(e => e.nombre_corto == GlobalVariable.Dictionary.TIPO_PAGO_CONTADO_TRANSFERENCIA)[0];
          venta.importe=pago.total;
          venta.total=pago.total;
          venta.saldo=0;
          venta.importe_qr=pago.qr;
          venta.pagado=pago.importe;
          venta.caja=caja;
        }else{
          tipo_pago=this.tiposPago.clases.filter(e => e.nombre_corto == GlobalVariable.Dictionary.TIPO_PAGO_CRE)[0];
          venta.a_cuenta=pago.importe;
          venta.importe=pago.total;
          venta.total=pago.total;
          venta.saldo=pago.total-pago.importe;
          venta.pago_venta={
            a_cuenta_anterior:pago.importe,
            saldo_anterior:venta.saldo,
            importe:pago.qr,
            observacion:"Pago Mixto Efectivo Qr",
            fecha:partido.fecha_hora,
            caja:caja
          }
        }
        venta.pagado=pago.importe;
      }
      venta.tipoPago=tipo_pago;
			venta.sucursales = Util.obtenerSucursalesUsuario(this.usuario);

      if(pago.producto.nombre.includes("AMARILLA")){
        if(equipo_1){
          venta.lista_amarillas_equipo_1=partido.lista_amarillas_equipo_1;
        }else{
          venta.lista_amarillas_equipo_2=partido.lista_amarillas_equipo_2;
        }
      }else if(pago.producto.nombre.includes("ROJA")){
        if(equipo_1){
          venta.lista_rojas_equipo_1=partido.lista_rojas_equipo_1;
        }else{
          venta.lista_rojas_equipo_2=partido.lista_rojas_equipo_2;
        }
      }else{
        if(equipo_1){
          venta.id_equipo_1=equipo_1.id;
        }else{
          venta.id_equipo_2=equipo_2.id;
        }
      }
      
      
      venta.detallesVenta.push({
        producto:pago.producto,
        precio_unitario:pago.total,
        importe:pago.total,
        total:pago.total,
        es_servicio:false,
        es_combo:false,
        item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
        cantidad:1,descuento:0,tipo_descuento:false,
        descripcion:this.descripcionCobroPartido(partido,equipo_1,pago)
      });
      return venta;
    }

    /* El arbitraje (o la multa W.O. que lo reemplaza) es el primer cobro de cada equipo, con id 'a'+partido+equipo: lleva
       el rival y la categoria, para que si queda debiendo se sepa de que partido es la deuda */
    descripcionCobroPartido(partido,equipo_1,pago){
      if(String(pago.id || "").indexOf("a"+partido.id)!=0){
        return pago.descripcion;
      }
      let rival=equipo_1?partido.equipo_2:partido.equipo_1;
      let categoria=partido.categoria && partido.categoria.nombre?partido.categoria.nombre:"";
      let descripcion=pago.descripcion || ("Partido contra "+(rival && rival.nombre?rival.nombre:""));
      return categoria && descripcion.indexOf(categoria)<0?descripcion+" · "+categoria:descripcion;
    }

    async generarPagoVenta(id_venta,partido,pago,caja){
      //torneos: deuda de un jugador cobrada en la mesa (id_jugador), baja solo su parte de la venta
      let pago_venta:any={
        id_venta:id_venta,
        id_jugador:pago.id_jugador || null,
        id_usuario: this.usuario.id,
        observacion:pago.id_jugador?"Pago de "+(pago.nombre_jugador || "jugador")+" desde cierre mesa":"Pago desde cierre mesa",
        fecha:partido.fecha_hora,
        caja:null,
        transaccion:null,
        sucursal:Util.obtenerSucursalesUsuario(this.usuario)[0],
        id_empresa:this.usuario.id_empresa
      }      
      if(pago.importe==0 && pago.qr>0){
        pago_venta.transaccion=this.tiposPago.clases.filter(e => e.nombre_corto == GlobalVariable.Dictionary.TIPO_PAGO_CODQR)[0];
        pago_venta.importe=pago.qr;
        pago_venta.caja=caja;
      }else if(pago.qr==0 && pago.importe>0){
        pago_venta.transaccion=this.tiposPago.clases.filter(e => e.nombre_corto == GlobalVariable.Dictionary.TIPO_PAGO_CONT)[0];
        pago_venta.importe=pago.importe;
      }else if(pago.qr>0 && pago.importe>0){
        pago_venta.transaccion=this.tiposPago.clases.filter(e => e.nombre_corto == GlobalVariable.Dictionary.TIPO_PAGO_CONTADO_TRANSFERENCIA)[0];
        pago_venta.importe=pago.qr;
        pago_venta.caja=caja;
        pago_venta.pago_venta={
          importe:pago.importe,
          transaccion:this.tiposPago.clases.filter(e => e.nombre_corto == GlobalVariable.Dictionary.TIPO_PAGO_CONTADO_TRANSFERENCIA)[0],
          id_venta:id_venta,
          id_jugador:pago.id_jugador || null,
          id_usuario: this.usuario.id,
          observacion:"Pago desde cierre mesa",
          fecha:partido.fecha_hora,
          caja:null,
          sucursal:Util.obtenerSucursalesUsuario(this.usuario)[0],
          id_empresa:this.usuario.id_empresa
        }
      }
      return pago_venta;
    }

    obtenerConceptosEgresoCompra(){
        this.blockUI.start();
        this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_CONCEPTO_EGRESOS).subscribe((entidad:any)=>{
          this.conceptos_egreso_compra=entidad.clases
          this.blockUI.stop();
        });
    }

    async generarCompra(fecha_hora,pago,codigo_arbitro,egreso){
      //arbitro
      let proveedor=await this.proveedoresService.buscarProveedoresNit(this.usuario.id_empresa,codigo_arbitro).toPromise();
      proveedor=proveedor[0];
      let documento_compra=this.tiposDocumentosCompra.filter(d => d.nombre_corto==GlobalVariable.Dictionary.TIPO_DOCUMENTO_RECIBO)[0];
      let tipo_pago=this.tiposPago.clases.filter(e => e.nombre_corto == GlobalVariable.Dictionary.TIPO_PAGO_CONT)[0];
      let compra={
            usuario:this.usuario,
            proveedor:proveedor,
            tipoPago:tipo_pago,
            tipo_documento:documento_compra,
            detallesCompra:[],
            fecha:fecha_hora,
            tipo_descuento:false,
            codigo_control:0,
            autorizacion:0,
            tipo_recargo:false,
            descuento:0,
            recargo:0,
            ice:0,
            excento:0,
            factura:0,
            sucursal:Util.obtenerSucursalesUsuario(this.usuario)[0],
            a_cuenta:0,
            saldo:0,
            importe:pago,
            total:pago,
            almacen:{id_sucursal:Util.obtenerSucursalesUsuario(this.usuario)[0].id},
            documentos:[]
        }

        compra.detallesCompra.push({
          centroCosto:this.conceptos_egreso_compra.filter(e => e.nombre==egreso)[0],
          producto:{},
          costo_unitario:pago,
          cantidad:1,
          descuento:0,recargo:0,ice:0,excento:0,tipo_descuento:false,tipo_recargo:false,
          importe:pago,
          total:pago
        });

        return compra;
    }

    validarCierreCaja(cierre_rol){
        let res=true;
        if(!cierre_rol.movimiento){
          res=res && false;
          this.toastr.error("Debe especificar el movimiento!");
        }
        if(!cierre_rol.caja){
          res=res && false;
          this.toastr.error("Debe especificar la caja!");
        }
        return res;
    }

    onDragStart(index: number) {
    this.draggedIndex = index; // Store the index of the row being moved
  }

  onDragOver(event: DragEvent) {
    event.preventDefault(); // Essential to allow a drop event to occur
  }

  onDrop(targetIndex: number) {
    if (this.draggedIndex !== null && this.draggedIndex !== targetIndex) {
      // Reorder the array
      let fecha_hora=this.rol_partido.partidos[this.draggedIndex].fecha_hora;
      this.rol_partido.partidos[this.draggedIndex].fecha_hora=this.rol_partido.partidos[targetIndex].fecha_hora;
      this.rol_partido.partidos[targetIndex].fecha_hora=fecha_hora;
      const movedItem = this.rol_partido.partidos.splice(this.draggedIndex, 1)[0];
      this.rol_partido.partidos.splice(targetIndex, 0, movedItem);
      console.log(this.draggedIndex);
      console.log(targetIndex);
    }
    this.draggedIndex = null;
  }

  drop(event: CdkDragDrop<any[]>) {
    const previousIndex = event.previousIndex;
    const currentIndex = event.currentIndex;

    // 1. Identificar las listas involucradas
    const listaOrigen = event.previousContainer.data;
    const listaDestino = event.container.data;

    // 2. Guardar el orden de horas actual de AMBAS listas antes de mover nada
    // Esto es vital para que las horas se queden fijas en su posición
    const horasOrigen = listaOrigen.map(p => p.fecha_hora);
    const horasDestino = listaDestino.map(p => p.fecha_hora);

    if (event.previousContainer === event.container) {
      // Mismo contenedor: Reordenar físicamente
      moveItemInArray(listaDestino, previousIndex, currentIndex);
      
      // Reasignar las horas originales a la nueva posición de los partidos
      listaDestino.forEach((partido, index) => {
        partido.fecha_hora = horasDestino[index];
      });
    } else {
      // Diferentes contenedores: Transferir
      transferArrayItem(listaOrigen, listaDestino, previousIndex, currentIndex);

      // Reasignar horas en la lista de origen (para cubrir el hueco)
      listaOrigen.forEach((partido, index) => {
        partido.fecha_hora = horasOrigen[index];
      });

      // Reasignar horas en la lista de destino (para acomodar el nuevo)
      // Nota: Si la lista destino ahora tiene más elementos, necesitarás una lógica
      // para generar la nueva hora o usar una lista de horas predefinidas.
      listaDestino.forEach((partido, index) => {
        if (horasDestino[index]) {
          partido.fecha_hora = horasDestino[index];
        }
      });
    }

    // Si usas base de datos, aquí guardarías el nuevo estado
    // this.actualizarBackend(this.canchas);
  }

  async abrirRegistroRolFixturePartido(){
    this.blockUI.start();
    for(let i=0;i<this.roles_partido_seleccionados.length;i++){
        this.roles_partido_seleccionados[i]=await this.rolesPartidosService.obtenerRolPartido(this.roles_partido_seleccionados[i].id).toPromise();
        this.roles_partido_seleccionados[i].partidos=this.roles_partido_seleccionados[i].partidos.filter(p => p.activo);
    }
    this.blockUI.stop();
    this.modal_registro_rol_partido_fixture=this.modalService.open(this.modal_registro_rol_partido_fixture_ref, {windowClass:'rol-partido',ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
    this.modal_registro_rol_partido_fixture.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  async guardarRolesPartidos(){
    this.blockUI.start();
    for(let i=0;i<this.roles_partido_seleccionados.length;i++){
      let res:any=await this.rolesPartidosService.actualizarRolPartido(this.roles_partido_seleccionados[i]).toPromise();
      if(res.tiene_error){
        this.toastr.error(res.mensaje);
      }else{
        this.toastr.success(res.mensaje);
      }
    }
    this.modal_registro_rol_partido_fixture.close();
    this.getItems();
    this.blockUI.stop();
  }

  agregarRolPartido(item: any){
      if(item.selected){
          this.roles_partido_seleccionados.push(item);
      }else{
          this.roles_partido_seleccionados.splice(this.roles_partido_seleccionados.indexOf(item), 1);
      }
  }

  seleccionarTodosItems(items:any){
      this.roles_partido_seleccionados=[];
      for(var i=0;i<items.length;i++){
          if(this.allItemsSelected){
              items[i].selected=true;
              this.roles_partido_seleccionados.push(items[i]);
          }else{
              items[i].selected=false;
          }
      }
  }
}
